// import { TranslationKeys } from '../types/localization';

export const ar = {
  // Navigation
  'nav.dashboard': 'لوحة التحكم',
  'nav.patients': 'المرضى',
  'nav.records': 'السجلات الطبية',
  'nav.schedule': 'الجدول',
  'nav.scheduling': 'جدولة المواعيد',
  'nav.providerAvailability': 'توافر مقدمي الخدمة',
  'nav.resourceScheduling': 'جدولة الموارد',
  'nav.waitlistManagement': 'إدارة قائمة الانتظار',
  'nav.clinical': 'السريري',
  'nav.drugs': 'قاعدة بيانات الأدوية',
  'nav.billing': 'الفواتير',
  'nav.featureToggles': 'إعدادات الميزات',
  'nav.subscription': 'الاشتراك',
  'nav.adt': 'القبول والخروج والنقل',
  'nav.labOrders': 'طلبات المختبر',
  'nav.pharmacy': 'الصيدلية',
  'nav.pharmacyInventory': 'مخزون الصيدلية',
  'nav.bedManagement': 'إدارة الأسرة',
  'nav.census': 'التعداد والطاقة',
  'nav.templates': 'القوالب',
  'nav.imagingOrders': 'طلبات الأشعة',
  'nav.teamMembers': 'أعضاء الفريق',
  'nav.settings': 'الإعدادات',

  // Common
  'common.search': 'بحث',
  'common.filter': 'تصفية',
  'common.save': 'حفظ',
  'common.cancel': 'إلغاء',
  'common.close': 'إغلاق',
  'common.create': 'إنشاء',
  'common.edit': 'تعديل',
  'common.delete': 'حذف',
  'common.add': 'إضافة',
  'common.update': 'تحديث',
  'common.new': 'جديد',
  'common.addNew': 'إضافة جديد',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.previous': 'السابق',
  'common.loading': 'جاري التحميل',
  'common.error': 'خطأ',
  'common.success': 'نجاح',
  'common.noData': 'لا توجد بيانات متاحة',
  'common.viewAll': 'عرض الكل',
  'common.viewDetails': 'عرض التفاصيل',
  'common.poweredBy': 'مدعوم بواسطة',
  'common.aiAssistant': 'المساعد الذكي',
  'common.filteredResults': 'النتائج المفلترة',
  'common.actions': 'الإجراءات',
  'common.minutes': 'دقائق',
  'common.hour': 'ساعة',
  'common.hours': 'ساعات',
  'common.searchPatients': 'البحث عن المرضى والسجلات...',
  'common.profile': 'الملف الشخصي',
  'common.logout': 'تسجيل الخروج',
  'common.menu': 'القائمة',
  'common.user': 'مستخدم',
  'common.never': 'أبداً',
  'common.today': 'اليوم',
  'common.accessDenied': 'تم رفض الوصول. ليس لديك صلاحية لعرض هذه الصفحة.',
  'common.all': 'الكل',
  'common.view': 'عرض',
  'common.dismiss': 'إزالة',
  'common.filters': 'المرشحات',
  'common.results': 'نتيجة',
  'common.noResults': 'لا توجد نتائج',
  'common.searching': 'جارٍ البحث…',
  'common.refresh': 'تحديث',
  'common.clear': 'مسح',
  'common.export': 'تصدير',
  'common.recommendation': 'التوصية',
  'common.source': 'المصدر',
  'common.references': 'المراجع',

  // Feature Guard
  'featureGuard.featureDisabled': 'الميزة معطلة',
  'featureGuard.moduleDisabled': 'تم تعطيل وحدة {{moduleName}} من قبل المسؤول.',
  'featureGuard.featureUnavailable': 'هذه الميزة غير متاحة حالياً. يرجى الاتصال بمسؤول النظام إذا كنت بحاجة إلى الوصول إلى هذه الوحدة.',
  'featureGuard.returnToDashboard': 'العودة إلى لوحة التحكم',
  'featureGuard.accessDenied': 'تم رفض الوصول',
  'featureGuard.noPermission': 'ليس لديك صلاحية للوصول إلى وحدة {{moduleName}}.',
  'featureGuard.noPermissionMessage': 'دورك الحالي لا يملك الصلاحيات المطلوبة لعرض هذه الصفحة. يرجى الاتصال بالمسؤول إذا كنت تعتقد أنه يجب أن يكون لديك وصول.',

  // User Management
  'userManagement.title': 'إدارة المستخدمين',
  'userManagement.description': 'إدارة المستخدمين والأدوار والصلاحيات',
  'userManagement.addUser': 'إضافة مستخدم',
  'userManagement.editUser': 'تعديل المستخدم',
  'userManagement.createUser': 'إنشاء مستخدم',
  'userManagement.user': 'المستخدم',
  'userManagement.firstName': 'الاسم الأول',
  'userManagement.lastName': 'اسم العائلة',
  'userManagement.username': 'اسم المستخدم',
  'userManagement.email': 'البريد الإلكتروني',
  'userManagement.role': 'الدور',
  'userManagement.department': 'القسم',
  'userManagement.licenseNumber': 'رقم الترخيص',
  'userManagement.npiNumber': 'رقم NPI',
  'userManagement.phoneNumber': 'رقم الهاتف',
  'userManagement.status': 'الحالة',
  'userManagement.lastLogin': 'آخر تسجيل دخول',
  'userManagement.sendWelcomeEmail': 'إرسال بريد ترحيب',
  'userManagement.searchPlaceholder': 'البحث عن المستخدمين...',
  'userManagement.allRoles': 'جميع الأدوار',
  'userManagement.allStatuses': 'جميع الحالات',
  'userManagement.confirmDelete': 'هل أنت متأكد من حذف هذا المستخدم؟',
  'userManagement.suspensionReason': 'يرجى إدخال سبب الإيقاف:',

  'userManagement.roles.SUPER_ADMIN': 'مدير عام',
  'userManagement.roles.ADMIN': 'مدير',
  'userManagement.roles.DOCTOR': 'طبيب',
  'userManagement.roles.NURSE': 'ممرض',
  'userManagement.roles.NURSE_MANAGER': 'مدير التمريض',
  'userManagement.roles.PHARMACIST': 'صيدلي',
  'userManagement.roles.LAB_TECHNICIAN': 'فني مختبر',
  'userManagement.roles.RADIOLOGIST': 'أخصائي أشعة',
  'userManagement.roles.THERAPIST': 'معالج',
  'userManagement.roles.SOCIAL_WORKER': 'أخصائي اجتماعي',
  'userManagement.roles.CASE_MANAGER': 'مدير الحالة',
  'userManagement.roles.BILLING_SPECIALIST': 'أخصائي فوترة',
  'userManagement.roles.IT_SUPPORT': 'دعم تقني',
  'userManagement.roles.RECEPTIONIST': 'موظف استقبال',

  'userManagement.statuses.active': 'نشط',
  'userManagement.statuses.inactive': 'غير نشط',
  'userManagement.statuses.suspended': 'موقف',
  'userManagement.manageSystemUsers': 'إدارة مستخدمي النظام والأدوار والصلاحيات',
  'userManagement.exportCSV': 'تصدير CSV',
  'userManagement.export': 'تصدير',
  'userManagement.active': 'نشط',
  'userManagement.inactive': 'غير نشط',
  'userManagement.suspended': 'موقف',
  'userManagement.totalUsers': 'إجمالي المستخدمين',
  'userManagement.searchAndFilters': 'البحث والتصفية',
  'userManagement.searchByNameEmailOrUsername': 'البحث بالاسم أو البريد الإلكتروني أو اسم المستخدم...',
  'userManagement.allRolesFilter': 'جميع الأدوار',
  'userManagement.allStatusesFilter': 'جميع الحالات',
  'userManagement.sortByUsername': 'ترتيب حسب اسم المستخدم',
  'userManagement.sortByFirstName': 'ترتيب حسب الاسم الأول',
  'userManagement.sortByLastName': 'ترتيب حسب اسم العائلة',
  'userManagement.sortByEmail': 'ترتيب حسب البريد الإلكتروني',
  'userManagement.sortByDateCreated': 'ترتيب حسب تاريخ الإنشاء',
  'userManagement.sortAscending': 'ترتيب تصاعدي',
  'userManagement.sortDescending': 'ترتيب تنازلي',
  'userManagement.activate': 'تفعيل',
  'userManagement.deactivate': 'إلغاء التفعيل',
  'userManagement.suspend': 'تعليق',
  'userManagement.deleteUser': 'حذف المستخدم',
  'userManagement.noRole': 'لا يوجد دور',
  'userManagement.noDepartment': 'لا يوجد قسم',
  'userManagement.never': 'أبداً',
  'userManagement.actions': 'الإجراءات',
  'userManagement.noUsersFound': 'لم يتم العثور على مستخدمين. حاول تعديل معايير البحث أو إضافة مستخدم جديد.',
  'userManagement.cannotDeleteOwnAccount': 'لا يمكنك حذف حسابك الخاص.',
  'userManagement.cannotChangeOwnStatus': 'لا يمكنك تغيير حالة حسابك الخاص',
  'userManagement.resetSigningPin': 'إعادة تعيين PIN التوقيع',
  'userManagement.confirmResetPin': 'إعادة تعيين PIN التوقيع لـ {{name}}؟ سيُطلب منه تعيين رمز جديد عند توقيع السجل التالي.',
  'userManagement.resetPinSuccess': 'تمت إعادة تعيين PIN التوقيع لـ {{name}}. سيقوم بتعيين رمز جديد عند التوقيع التالي.',
  'userManagement.cannotDeactivateOwnAccount': 'لا يمكنك إلغاء تفعيل أو تعليق حسابك الخاص.',
  'userManagement.skippingOwnAccount': 'تخطي حسابك الخاص. تحديث {{count}} مستخدم آخر.',
  'userManagement.cannotDeleteOwnAccountBulk': 'لا يمكنك حذف حسابك الخاص. حذف {{count}} مستخدم آخر محدد؟',
  'userManagement.confirmBulkDelete': 'حذف {{count}} مستخدم محدد؟',

  // Tenant dark-mode palette editor
  'darkPalette.title': 'لوحة الوضع الداكن',
  'darkPalette.subtitle':
    'الأطباء الذين يختارون الوضع الداكن في إعدادات إمكانية الوصول سيرون ألوان عيادتك هنا.',
  'darkPalette.statusCustom': 'مخصص',
  'darkPalette.statusDefault': 'افتراضي المنصة',
  'darkPalette.previewTitle': 'بطاقة تجريبية',
  'darkPalette.previewBody': 'كيف يبدو هذا على خلفيتك الداكنة.',
  'darkPalette.previewChip': 'شارة الحالة',
  'darkPalette.save': 'حفظ اللوحة الداكنة',
  'darkPalette.saving': 'جارٍ الحفظ…',
  'darkPalette.saved': 'تم الحفظ',
  'darkPalette.resetToDefault': 'استخدم افتراضي المنصة',
  'darkPalette.saveFailed': 'تعذر حفظ اللوحة الداكنة.',

  // Encounter — patient-context sidebar
  'encounter.history.title': 'التاريخ الطبي',
  'encounter.history.titleMobile': 'التاريخ الطبي للمريض',
  'encounter.history.empty': 'لا يوجد تاريخ طبي مسجّل',
  'encounter.history.chronicConditions': 'الأمراض المزمنة',
  'encounter.history.activeAllergies': 'الحساسيات النشطة',
  'encounter.history.recentSurgeries': 'العمليات الجراحية الأخيرة',
  'encounter.history.familyHistory': 'التاريخ العائلي',
  'encounter.history.more': '+{{count}} المزيد',

  // AI Assistant Bubble
  'aiAssistant.brandFallback': 'المساعد الذكي',
  'aiAssistant.continueAnswer': 'أكمل الرد',
  'aiAssistant.welcome.greeting':
    'مرحباً — أنا MAIE. اكتب / للأوامر، أو اسألني مباشرة:',
  'aiAssistant.welcome.bullet.navigate':
    'تحليلات سريرية سريعة (/analyze, /labs, /meds, /risk, /vitals, /summary)',
  'aiAssistant.welcome.bullet.search':
    'البحث عن المرضى والسجلات والمواعيد',
  'aiAssistant.welcome.bullet.create':
    'حجز المواعيد أو صياغة زيارة من الصوت',
  'aiAssistant.welcome.bullet.answer':
    'الإجابة عن أسئلة النظام أو سؤال يخص المريض الحالي',
  'aiAssistant.welcome.examples':
    'جرب: "/labs" على مريض · "/risk" لتقييم المخاطر · "ابحث عن المريض أحمد" · "افتح الجدول"',
  'aiAssistant.thinking': 'المساعد يفكّر',
  'aiAssistant.takingLonger': 'يستغرق وقتًا أطول من المعتاد…',
  'aiAssistant.voiceUnavailableAiOff': 'المساعد الصوتي بالذكاء الاصطناعي معطّل. لا يزال بإمكانك العمل يدويًا.',
  'aiAssistant.placeholder.recording': '🎤 جارٍ التسجيل…',
  'aiAssistant.placeholder.transcribing': '⏳ جارٍ التفريغ…',
  'aiAssistant.placeholder.idle': 'اسأل أي شيء، أو اكتب / للأوامر',
  'aiAssistant.send.sendMessage': 'إرسال الرسالة',
  'aiAssistant.send.completePendingFirst':
    'أكمل الاختيار المعلّق أولاً',
  'aiAssistant.send.waitForResponse':
    'انتظر اكتمال الرد الحالي',
  'aiAssistant.listening.pushToActivate': 'جارٍ الاستماع ({{key}})',
  'aiAssistant.listening.wakeWord': 'يستمع لـ "هاي {{brand}}"',

  // Coming-soon overlay + badges
  'comingSoon.badge': 'قريباً',
  'comingSoon.defaultTitle': 'قريباً',
  'comingSoon.defaultDescription':
    'نضع اللمسات الأخيرة على هذا. سيتفعّل تلقائياً — لا حاجة لأي إجراء.',

  // Subscription page (OWNER)
  'subscription.plansComingSoon.title': 'الخطط والأسعار — قريباً',
  'subscription.plansComingSoon.body':
    'أنت في الفترة التجريبية المجانية لمدة 30 يوماً — المنتج كامل، بما في ذلك التدوين الصوتي بالذكاء الاصطناعي والمساعد. لا حاجة لبطاقة ائتمان. عند انتهائها تبقى عيادتك على الخطة المجانية: يستمر سجلك الطبي اليدوي في العمل وتتوقف ميزات الذكاء الاصطناعي مؤقتاً حتى تشترك.',

  // Feedback widget
  'feedback.title': 'الإبلاغ عن مشكلة أو تقديم ملاحظات',
  'feedback.subtitle':
    'نلتقط الصفحة الحالية والسجلات الأخيرة داخل التطبيق للمساعدة في إعادة إنتاج المشكلة.',
  'feedback.message.label': 'ما المشكلة، أو ما الذي قد يساعد؟',
  'feedback.message.placeholder':
    'صف المشكلة، خطوات إعادة الإنتاج، أو التعديل الذي تتمنى رؤيته…',
  'feedback.email.label': 'البريد الإلكتروني',
  'feedback.email.optional': '(اختياري)',
  'feedback.email.placeholder': 'you@clinic.example',
  'feedback.send': 'إرسال',
  'feedback.errors.send': 'تعذر إرسال الملاحظات',
  'feedback.success.title': 'شكراً — وصلنا.',
  'feedback.success.body':
    'تقريرك في قائمة الفرز. إن تركت بريدك سنتابع معك عند توفر تحديث.',
  'feedback.success.done': 'تم',

  // Connected accounts card (الإعدادات → الأمان)
  'connectedAccounts.eyebrow': 'الحساب',
  'connectedAccounts.title': 'الحسابات المتصلة',
  'connectedAccounts.subtitle':
    'سجّل الدخول إلى حساب MAIE الواحد عبر أيّ مزود تربطه. بريدك الإلكتروني هو نفسه في جميعها.',
  'connectedAccounts.providers.password': 'البريد الإلكتروني وكلمة المرور',
  'connectedAccounts.providers.sso': 'الدخول الموحّد',
  'connectedAccounts.password.set':
    'مضبوط — يمكنك تسجيل الدخول بكلمة المرور.',
  'connectedAccounts.password.unset': 'لا توجد كلمة مرور على هذا الحساب.',
  'connectedAccounts.status.active': 'نشط',
  'connectedAccounts.status.connected': 'متصل',
  'connectedAccounts.connect': 'ربط',
  'connectedAccounts.disconnect': 'فصل',
  'connectedAccounts.notConnected': 'غير متصل بعد.',
  'connectedAccounts.lastUsed': 'آخر استخدام {{date}}',
  'connectedAccounts.empty':
    'لا توجد مزودات خارجية مهيأة على هذه النشرة بعد.',
  'connectedAccounts.disconnectBlockedTooltip':
    'اضبط كلمة مرور قبل فصل وسيلة تسجيل الدخول الوحيدة لديك',
  'connectedAccounts.toast.connected': 'تم ربط {{provider}}.',
  'connectedAccounts.toast.disconnected': 'تم الفصل.',
  'connectedAccounts.errors.emailMismatch':
    'البريد الإلكتروني للمزود لا يطابق بريد حسابك في MAIE. استخدم الحساب المطابق أو غيّر بريد MAIE أولاً.',
  'connectedAccounts.errors.ownedByOther':
    'حساب المزود هذا مرتبط بالفعل بمستخدم آخر في MAIE.',
  'connectedAccounts.errors.emailUnverified':
    'فعّل بريدك مع المزود قبل الربط.',
  'connectedAccounts.errors.notConfigured':
    'هذا المزود غير مهيأ بعد. حاول لاحقاً.',
  'connectedAccounts.errors.linkFailed': 'تعذر ربط الحساب. حاول مجدداً.',
  'connectedAccounts.errors.lastLoginMethod':
    'هذه وسيلتك الوحيدة لتسجيل الدخول. اضبط كلمة مرور قبل فصلها.',
  'connectedAccounts.errors.disconnectFailed': 'تعذر الفصل',
  'connectedAccounts.errors.startLinkFailed': 'تعذر بدء الربط',

  // Accessibility quick panel
  'accessibilityQuick.title': 'إمكانية الوصول والمظهر',
  'accessibilityQuick.subtitle':
    'تحكم سريع — يُحفظ في حسابك ويُزامن عبر أجهزتك.',
  'accessibilityQuick.language': 'اللغة',
  'accessibilityQuick.openFull': 'فتح إعدادات إمكانية الوصول كاملة',

  // Accessibility Card (مزامنة عبر الأجهزة)
  'accessibility.eyebrow': 'إمكانية الوصول',
  'accessibility.title': 'إمكانية الوصول',
  'accessibility.subtitle': 'تتم مزامنة الإعدادات عبر كل جهاز تسجل الدخول منه.',
  'accessibility.reset': 'إعادة الضبط',
  'accessibility.textScale.label': 'حجم النص',
  'accessibility.colorScheme.label': 'المظهر',
  'accessibility.colorScheme.description': 'اختر فاتح أو داكن، أو اتبع جهازك.',
  'accessibility.colorScheme.system': 'النظام',
  'accessibility.colorScheme.light': 'فاتح',
  'accessibility.colorScheme.dark': 'داكن',
  'accessibility.direction.label': 'اتجاه التخطيط',
  'accessibility.direction.description':
    'تجاوز اتجاه التخطيط. الوضع التلقائي يتبع اللغة المختارة.',
  'accessibility.direction.auto': 'تلقائي',
  'accessibility.direction.autoSub': 'حسب اللغة',
  'accessibility.contrast.label': 'تباين عالٍ',
  'accessibility.contrast.description':
    'نصوص وحدود وشارات أوضح لإضاءة العيادة.',
  'accessibility.reduceMotion.label': 'تقليل الحركة',
  'accessibility.reduceMotion.description':
    'تقليل الرسوم المتحركة والانتقالات في كامل التطبيق.',

  // Settings Page
  'settings.title': 'الإعدادات',
  'settings.subtitle': 'حسابك وأمانك وشكل التطبيق لك',
  'settings.tabs.profile': 'الملف الشخصي',
  'settings.tabs.security': 'الأمان',
  'settings.tabs.accessibility': 'إمكانية الوصول',
  'settings.tabs.voice': 'الصوت',
  'settings.tabs.privacy': 'الخصوصية والبيانات',
  'settings.themeAnalysis': 'تحليل المظهر',
  'settings.themeCustomization': 'تخصيص المظهر',
  'settings.theme': 'المظهر',
  'settings.hospitalBranding': 'العلامة التجارية للمستشفى',
  'settings.branding': 'العلامة التجارية',
  'settings.voiceSettings': 'إعدادات الصوت',
  'settings.voice': 'الصوت',
  'settings.themePresets': 'قوالب المظهر',
  'settings.brandingTabIdentity': 'الهوية',
  'settings.brandingTabTheme': 'المظهر',
  'settings.brandingTabLogin': 'تسجيل الدخول',
  'settings.brandingTabDocuments': 'المستندات',
  'settings.lightTheme': 'الوضع الفاتح',
  'settings.lightThemeHelper':
    'ما يراه الأطباء عندما يكون نمط الألوان لديهم فاتحاً.',
  'settings.darkTheme': 'الوضع الداكن',
  'settings.darkThemeNoneAvailable':
    'لا توجد قوالب داكنة بعد. يُطبَّق افتراضي المنصة حتى إضافة واحدة.',
  'settings.customColors': 'الألوان المخصصة',
  'settings.primaryColor': 'اللون الأساسي',
  'settings.secondaryColor': 'اللون الثانوي',
  'settings.accentColor': 'لون التمييز',
  'settings.backgroundColor': 'لون الخلفية',
  'settings.textColor': 'لون النص',
  'settings.buttonTextColor': 'لون نص الزر',
  'settings.statusActionColors': 'ألوان الحالة والإجراءات',
  'settings.successColor': 'لون النجاح',
  'settings.warningColor': 'لون التحذير',
  'settings.errorColor': 'لون الخطأ',
  'settings.infoColor': 'لون المعلومات',
  'settings.aiAssistantNote': 'ملاحظة: يستخدم زر المساعد الذكي لون التمييز',
  'settings.hospitalInformation': 'معلومات المستشفى',
  'settings.hospitalName': 'اسم المستشفى',
  'settings.tagline': 'الشعار',
  'settings.aiProviderName': 'اسم مزود الذكاء الاصطناعي',
  'settings.logoAndFavicon': 'الشعار والأيقونة المفضلة',
  'settings.hospitalLogo': 'شعار المستشفى',
  'settings.favicon': 'الأيقونة المفضلة',
  'settings.clickToUploadLogo': 'انقر لتحميل الشعار',
  'settings.logoFormat': 'PNG أو JPG أو SVG (الحد الأقصى 2 ميجابايت)',
  'settings.clickToUploadFavicon': 'انقر لتحميل الأيقونة المفضلة',
  'settings.faviconFormat': 'PNG أو ICO أو SVG (16x16 أو 32x32)',
  'settings.logoNote': 'سيظهر الشعار في الرأس والأيقونة المفضلة في علامات تبويب المتصفح',
  'settings.enterHospitalName': 'أدخل اسم المستشفى',
  'settings.enterTagline': 'أدخل الشعار',
  'settings.aiProviderPlaceholder': 'اسم مزود الذكاء الاصطناعي',
  'settings.poweredBy': 'مدعوم بواسطة',
  'settings.wakeWordDetection': 'كشف كلمة التنبيه',
  'settings.active': 'نشط',
  'settings.enableWakeWord': 'تفعيل كلمة التنبيه',
  'settings.handsFree': 'بدون استخدام اليدين',
  'settings.wakeWordDescription': 'تفعيل المساعد الذكي بقول "مرحباً {{aiProvider}}"',
  'settings.listeningMode': 'وضع الاستماع',
  'settings.alwaysListening': 'استماع دائم',
  'settings.recommended': 'موصى به',
  'settings.alwaysListeningDescription': 'جاهز دائماً - الأفضل لسير العمل بدون استخدام اليدين أثناء مقابلات المرضى',
  'settings.alwaysListeningWarning': '⚠️ يستخدم المزيد من البطارية - الميكروفون يبقى نشطاً',
  'settings.pushToActivate': 'اضغط للتفعيل',
  'settings.batterySaver': 'توفير البطارية',
  'settings.pushToActivateDescription': 'اضغط {{key}} للاستماع لمدة 10 ثوانٍ - يوفر البطارية',
  'settings.voiceTranscription': 'تحويل الصوت إلى نص',
  'settings.localTranscription': 'التحويل المحلي',
  'settings.fast': 'سريع',
  'settings.localTranscriptionDescription': 'معالجة الصوت على جهازك للحصول على نتائج فورية (~ثانية واحدة)',
  'settings.localTranscriptionWarning': '⚠️ تنزيل ملفات التعرف على الصوت عند الاستخدام الأول (يعمل بدون اتصال بعد ذلك)',
  'settings.serverModeNote': 'سيتم إرسال الصوت إلى الخادم للحصول على تحويل عالي الجودة (يستغرق بضع ثوانٍ)',
  'settings.autoSendMessages': 'إرسال الرسائل تلقائياً',
  'settings.convenience': 'راحة',
  'settings.autoSendDescription': 'إرسال الرسائل تلقائياً بعد اكتمال تحويل الصوت (موصى به لكلمة التنبيه)',
  'settings.transcriptionLanguage': 'لغة التحويل',
  'settings.transcriptionLanguageDescription': 'اللغة التي يحوّل بها الكاتب الذكي الاستشارات إلى نص. الإنجليزية هي الأدق؛ الكشف التلقائي قد يخطئ في السماع وأقل موثوقية.',
  'settings.langEnglish': 'الإنجليزية',
  'settings.langArabic': 'العربية',
  'settings.langAuto': 'كشف تلقائي (أقل دقة)',
  'settings.textToSpeech': 'تحويل النص إلى كلام (TTS)',
  'settings.enabled': 'مفعل',
  'settings.enableTTS': 'تفعيل TTS',
  'settings.voiceAssistant': 'المساعد الصوتي',
  'settings.enableTTSDescription': 'تفعيل استجابات الذكاء الاصطناعي الصوتية من الزر العائم',
  'settings.voiceSelection': 'اختيار الصوت',
  'settings.femaleVoices': 'أصوات نسائية',
  'settings.maleVoices': 'أصوات رجالية',
  'settings.neutralVoices': 'أصوات محايدة',
  'settings.voice_p225': 'أنثى - دافئ ومهني',
  'settings.voice_p228': 'أنثى - مشرق وواضح',
  'settings.voice_p229': 'أنثى - هادئ ولطيف',
  'settings.voice_p230': 'أنثى - طبيعي وواثق',
  'settings.voice_p231': 'أنثى - ناعم وودود',
  'settings.voice_p232': 'ذكر - عميق وموثوق',
  'settings.voice_p237': 'ذكر - سلس ومسترخي',
  'settings.voice_p241': 'ذكر - نشيط وواضح',
  'settings.voice_p243': 'ذكر - دافئ وثابت',
  'settings.voice_p245': 'ذكر - مهني وهادئ',
  'settings.voice_p226': 'محايد - متوازن وواضح',
  'settings.voice_p227': 'محايد - ناعم ومتساوٍ',
  'settings.voice_p233': 'محايد - مشرق وثابت',
  'settings.voice_p236': 'محايد - دافئ وسلس',
  'settings.voice_p240': 'محايد - طبيعي ومتعدد الاستخدامات',
  'settings.voiceSelectionNote': 'سيتم استخدام الصوت المحدد لاستجابات الذكاء الاصطناعي',
  'settings.speechSpeed': 'سرعة النطق',
  'settings.speechSpeedNote': 'مدى سرعة قراءة MAIE للردود بصوت عالٍ',
  'settings.speed_slow': 'بطيء',
  'settings.speed_relaxed': 'مريح (موصى به)',
  'settings.speed_normal': 'عادي',
  'settings.speed_fast': 'سريع',
  'settings.ttsNote': 'TTS نشط فقط عند استخدام زر المساعد الصوتي العائم',
  'settings.howItWorks': 'كيف يعمل',
  'settings.step1AlwaysListening': 'قل "مرحباً {{aiProvider}}" للتفعيل (ستسمع صفيراً)',
  'settings.step2AlwaysListening': 'تحدث بأمرك بشكل طبيعي',
  'settings.step3AlwaysListening': 'انتظر ثانيتين بعد الانتهاء (ستسمع صفيراً آخر)',
  'settings.step4AlwaysListening': 'سيظهر النص المنسوخ في الدردشة تلقائياً',
  'settings.step1PushToActivate': 'اضغط {{key}} لبدء الاستماع (10 ثوانٍ)',
  'settings.step2PushToActivate': 'قل "مرحباً {{aiProvider}}" عندما تسمع الصفير',
  'settings.step3PushToActivate': 'تحدث بأمرك بشكل طبيعي',
  'settings.step4PushToActivate': 'انتظر ثانيتين بعد الانتهاء - سيظهر النص المنسوخ تلقائياً',
  'settings.livePreview': 'معاينة مباشرة',
  'settings.buttonStyles': 'أنماط الأزرار',
  'settings.primaryButton': 'زر أساسي',
  'settings.secondaryButton': 'زر ثانوي',
  'settings.accentButton': 'زر تمييز',
  'settings.sampleCard': 'بطاقة نموذجية',
  'settings.success': 'نجاح',
  'settings.warning': 'تحذير',
  'settings.error': 'خطأ',
  'settings.resetChanges': 'إعادة تعيين التغييرات',
  'settings.saveSettings': 'حفظ الإعدادات',
  'settings.themeSaved': 'تم حفظ إعدادات المظهر بنجاح!',
  'settings.themeSaveFailed': 'فشل حفظ إعدادات المظهر. يرجى المحاولة مرة أخرى.',
  'settings.serverMode': 'وضع الخادم:',
  'settings.note': 'ملاحظة:',

  // AI Command Palette
  'commandPalette.placeholder': 'اسأل الذكاء الاصطناعي أو ابحث عن الأوامر...',
  'commandPalette.recording': '🎤 جاري التسجيل...',
  'commandPalette.transcribing': '⏳ جاري النسخ...',
  'commandPalette.aiUnderstood': 'الذكاء الاصطناعي فهم الأمر',
  'commandPalette.pressEnter': 'اضغط Enter أو انقر للتنفيذ',
  'commandPalette.aiUnderstanding': 'الذكاء الاصطناعي يفهم أمرك...',
  'commandPalette.noResults': 'لم يتم العثور على نتائج. جرب بحثاً مختلفاً.',
  'commandPalette.searchResults': 'نتائج البحث',
  'commandPalette.commands': 'الأوامر',
  'commandPalette.navigate': '↑↓ التنقل',
  'commandPalette.select': 'Enter للاختيار',
  'commandPalette.close': 'Esc للإغلاق',
  'commandPalette.openShortcut': 'Ctrl+K للفتح',
  'commandPalette.voiceTooltipStart': 'انقر لبدء الإدخال الصوتي (Whisper AI)',
  'commandPalette.voiceTooltipStop': 'انقر لإيقاف التسجيل',
  'commandPalette.voiceTooltipTranscribing': 'جاري نسخ الصوت...',
  'commandPalette.micAccessDenied': 'تم رفض الوصول إلى الميكروفون. يرجى السماح بأذونات الميكروفون في إعدادات المتصفح.',
  'commandPalette.micNotFound': 'لم يتم العثور على ميكروفون. يرجى توصيل ميكروفون والمحاولة مرة أخرى.',
  'commandPalette.voiceServiceNotConnected': 'خدمة النسخ الصوتي غير متصلة. يرجى المحاولة مرة أخرى.',
  'commandPalette.transcriptionError': 'خطأ في النسخ: {{error}}',
  'commandPalette.voiceRecordingFailed': 'فشل بدء التسجيل الصوتي: {{error}}',
  'commandPalette.analysisComingSoon': 'ميزة التحليل قريباً! السياق: {{context}}، المريض: {{patient}}',

  // AI Command Palette - Commands
  'commandPalette.scheduleAppointmentFor': 'جدولة موعد لـ {{patientName}}',
  'commandPalette.bookAppointment': 'حجز موعد جديد لهذا المريض',
  'commandPalette.orderLabTestsFor': 'طلب فحوصات مخبرية لـ {{patientName}}',
  'commandPalette.createLabOrder': 'إنشاء طلب مختبر جديد لهذا المريض',
  'commandPalette.prescribeMedicationFor': 'وصف دواء لـ {{patientName}}',
  'commandPalette.createPrescription': 'إنشاء وصفة طبية جديدة',
  'commandPalette.interpretLabResults': 'تفسير نتائج المختبر',
  'commandPalette.aiAnalysisLabOrder': 'تحليل الذكاء الاصطناعي لطلب المختبر الحالي',
  'commandPalette.analyzeMedicalRecord': 'تحليل هذا السجل الطبي',
  'commandPalette.aiClinicalAssessment': 'تقييم سريري بالذكاء الاصطناعي لهذه الزيارة',
  'commandPalette.summarizePatientHistory': 'تلخيص تاريخ {{patientName}}',
  'commandPalette.comprehensivePatientSummary': 'إنشاء ملخص شامل لهذا المريض',
  'commandPalette.reviewMedications': 'مراجعة أدوية {{patientName}}',
  'commandPalette.checkInteractions': 'التحقق من التفاعلات وفرص التحسين',
  'commandPalette.analyzeRiskFactors': 'تحليل عوامل الخطر لـ {{patientName}}',
  'commandPalette.riskAssessment': 'تقييم الذكاء الاصطناعي لعوامل الخطر السريرية',
  'commandPalette.analyzeRecentLabs': 'تحليل نتائج المختبر الأخيرة',
  'commandPalette.aiLabAnalysis': 'تحليل الذكاء الاصطناعي للنتائج المخبرية الأخيرة',
  'commandPalette.generateClinicalNote': 'إنشاء ملاحظة سريرية',
  'commandPalette.startVisitRecording': 'بدء تسجيل زيارة سريرية',
  'commandPalette.generateDischargeSummary': 'إنشاء ملخص الخروج',
  'commandPalette.createDischargeDoc': 'إنشاء وثيقة الخروج',
  'commandPalette.generateReferralLetter': 'إنشاء رسالة إحالة',
  'commandPalette.createReferral': 'إنشاء إحالة لمتخصص آخر',
  'commandPalette.addNewPatient': 'إضافة مريض جديد',
  'commandPalette.registerNewPatient': 'تسجيل مريض جديد في النظام',
  'commandPalette.scheduleAppointment': 'جدولة موعد',
  'commandPalette.bookNewAppointment': 'حجز موعد جديد',
  'commandPalette.goToDashboard': 'الذهاب إلى لوحة التحكم',
  'commandPalette.navigateToDashboard': 'الانتقال إلى لوحة التحكم الرئيسية',

  // Role Management
  'roleManagement.title': 'إدارة الأدوار',
  'roleManagement.description': 'إدارة الأدوار والصلاحيات',
  'roleManagement.addRole': 'إضافة دور',
  'roleManagement.editRole': 'تعديل الدور',
  'roleManagement.createRole': 'إنشاء دور',
  'roleManagement.roleName': 'اسم الدور',
  'roleManagement.displayName': 'الاسم المعروض',
  'roleManagement.roleDescription': 'الوصف',
  'roleManagement.displayNameEn': 'الاسم المعروض (بالإنجليزية)',
  'roleManagement.displayNameAr': 'الاسم المعروض (بالعربية)',
  'roleManagement.descriptionEn': 'الوصف (بالإنجليزية)',
  'roleManagement.descriptionAr': 'الوصف (بالعربية)',
  'roleManagement.permissions': 'الصلاحيات',
  'roleManagement.permissionsSelected': 'محدد',
  'roleManagement.assignedUsers': 'المستخدمون المعينون',
  'roleManagement.system': 'نظام',
  'roleManagement.systemRole': 'دور النظام',
  'roleManagement.status': 'الحالة',
  'roleManagement.confirmDelete': 'هل أنت متأكد من حذف هذا الدور؟',
  'roleManagement.noRoles': 'لا أدوار متوفرة',

  'roleManagement.permissionGroups.user': 'إدارة المستخدمين',
  'roleManagement.permissionGroups.patient': 'إدارة المرضى',
  'roleManagement.permissionGroups.record': 'السجلات الطبية',
  'roleManagement.permissionGroups.appointment': 'المواعيد',
  'roleManagement.permissionGroups.lab': 'المختبر',
  'roleManagement.permissionGroups.orders': 'الطلبات',
  'roleManagement.permissionGroups.adt': 'القبول والخروج والنقل',
  'roleManagement.permissionGroups.template': 'القوالب',
  'roleManagement.permissionGroups.system': 'إدارة النظام',

  'roleManagement.permissions.USER_READ': 'عرض المستخدمين',
  'roleManagement.permissions.USER_WRITE': 'إنشاء/تعديل المستخدمين',
  'roleManagement.permissions.USER_DELETE': 'حذف المستخدمين',
  'roleManagement.permissions.PATIENT_READ': 'عرض المرضى',
  'roleManagement.permissions.PATIENT_WRITE': 'إنشاء/تعديل المرضى',
  'roleManagement.permissions.PATIENT_DELETE': 'حذف المرضى',
  'roleManagement.permissions.RECORD_READ': 'عرض السجلات الطبية',
  'roleManagement.permissions.RECORD_WRITE': 'إنشاء/تعديل السجلات الطبية',
  'roleManagement.permissions.RECORD_DELETE': 'حذف السجلات الطبية',
  'roleManagement.permissions.APPOINTMENT_READ': 'عرض المواعيد',
  'roleManagement.permissions.APPOINTMENT_WRITE': 'إنشاء/تعديل المواعيد',
  'roleManagement.permissions.APPOINTMENT_DELETE': 'حذف المواعيد',
  'roleManagement.permissions.LAB_ORDER_READ': 'عرض طلبات المختبر',
  'roleManagement.permissions.LAB_ORDER_WRITE': 'إنشاء/تعديل طلبات المختبر',
  'roleManagement.permissions.LAB_ORDER_DELETE': 'حذف طلبات المختبر',
  'roleManagement.permissions.LAB_RESULT_READ': 'عرض نتائج المختبر',
  'roleManagement.permissions.LAB_RESULT_WRITE': 'إنشاء/تعديل نتائج المختبر',
  'roleManagement.permissions.ORDER_READ': 'عرض الطلبات',
  'roleManagement.permissions.ORDER_WRITE': 'إنشاء/تعديل الطلبات',
  'roleManagement.permissions.ORDER_DELETE': 'حذف الطلبات',
  'roleManagement.permissions.ORDER_APPROVE': 'الموافقة على الطلبات',
  'roleManagement.permissions.ADT_READ': 'عرض القبول والخروج',
  'roleManagement.permissions.ADT_WRITE': 'إنشاء/تعديل القبول والخروج',
  'roleManagement.permissions.ADT_DELETE': 'حذف القبول والخروج',
  'roleManagement.permissions.TEMPLATE_READ': 'عرض القوالب',
  'roleManagement.permissions.TEMPLATE_WRITE': 'إنشاء/تعديل القوالب',
  'roleManagement.permissions.TEMPLATE_DELETE': 'حذف القوالب',
  'roleManagement.permissions.SYSTEM_CONFIG': 'إعدادات النظام',
  'roleManagement.permissions.BACKUP_RESTORE': 'النسخ الاحتياطي والاستعادة',
  'roleManagement.permissions.AUDIT_LOG_READ': 'عرض سجلات المراجعة',

  'common.active': 'نشط',
  'common.inactive': 'غير نشط',
  'common.administration': 'الإدارة',
  'common.to': 'إلى',
  'common.saving': 'جاري الحفظ...',

  // Authentication
  'auth.welcomeBack': 'مرحباً بعودتك',
  'auth.signIn': 'تسجيل الدخول',
  'auth.username': 'اسم المستخدم',
  'auth.password': 'كلمة المرور',
  'auth.usernamePlaceholder': 'أدخل اسم المستخدم',
  'auth.passwordPlaceholder': 'أدخل كلمة المرور',
  'auth.rememberMe': 'تذكرني',
  'auth.signingIn': 'جاري تسجيل الدخول...',
  'auth.demoAccounts': 'حسابات تجريبية',
  'auth.useAnyPassword': 'استخدم أي كلمة مرور',
  'auth.twoFactorCode': 'رمز الأمان',
  'auth.twoFactorPlaceholder': 'أدخل الرمز المكون من 6 أرقام',
  'auth.useSecurityCode': 'استخدم رمز الأمان',
  'auth.hideSecurityCode': 'إخفاء رمز الأمان',
  'auth.secureLogin': 'نظام تسجيل دخول آمن',

  // Auth — login page (redesign)
  'auth.login.eyebrow': 'مدوّن سريري صوتي · بالعربية أصلاً',
  'auth.login.signInTo': 'سجِّل دخولك إلى عيادتك',
  'auth.login.heroSubtitle':
    'MAIE يحوّل كل زيارة إلى ملاحظات سريرية منظّمة — بالعربية والإنجليزية. متوافق مع HIPAA و GDPR.',
  'auth.login.compliant': 'متوافق',
  'auth.login.proof1Title': 'تدوين صوتي',
  'auth.login.proof1Body':
    'صوتك يصبح الملاحظة — لا كتابة أثناء الزيارة.',
  'auth.login.proof2Title': 'العربية أولاً',
  'auth.login.proof2Body':
    'فهم طبيعي للهجة. وإنجليزية عند الطلب.',
  'auth.login.proof3Title': 'مستأجرك، بياناتك',
  'auth.login.proof3Body':
    'سجلات المرضى تبقى في مستأجر عيادتك — لا تصلنا.',
  'auth.login.soc2': 'جاهز لـ SOC 2',
  'auth.login.title': 'تسجيل الدخول إلى MAIE',
  'auth.login.subtitle': 'استخدم حساب مؤسستك أو كلمة المرور للمتابعة.',
  'auth.login.formEyebrow': 'تسجيل الدخول',
  'auth.login.emailLabel': 'البريد الإلكتروني',
  'auth.login.emailPlaceholder': 'you@example.com',
  'auth.login.passwordLabel': 'كلمة المرور',
  'auth.login.passwordPlaceholder': 'كلمة المرور الخاصة بك',
  'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.login.signInButton': 'تسجيل الدخول',

  // إعادة تعيين كلمة المرور (التدفّق العام)
  'auth.reset.forgotTitle': 'إعادة تعيين كلمة المرور',
  'auth.reset.forgotSubtitle':
    'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لتعيين كلمة مرور جديدة.',
  'auth.reset.sendLink': 'إرسال رابط إعادة التعيين',
  'auth.reset.checkEmailTitle': 'تحقّق من بريدك',
  'auth.reset.checkEmailBody':
    'إذا كان هناك حساب مرتبط بهذا البريد، فسيصلك رابط إعادة التعيين. ينتهي الرابط خلال ساعة.',
  'auth.reset.backToLogin': 'العودة لتسجيل الدخول',
  'auth.reset.genericError': 'حدث خطأ ما. حاول مرة أخرى.',
  'auth.reset.invalidTitle': 'الرابط منتهٍ أو غير صالح',
  'auth.reset.invalidBody':
    'لم يعد رابط إعادة التعيين صالحًا. اطلب رابطًا جديدًا للمتابعة.',
  'auth.reset.requestNewLink': 'طلب رابط جديد',
  'auth.reset.setNewTitle': 'تعيين كلمة مرور جديدة',
  'auth.reset.newPasswordLabel': 'كلمة المرور الجديدة',
  'auth.reset.newPasswordPlaceholder': '8 أحرف على الأقل',
  'auth.reset.confirmLabel': 'تأكيد كلمة المرور الجديدة',
  'auth.reset.minLength': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل.',
  'auth.reset.noMatch': 'كلمتا المرور غير متطابقتين.',
  'auth.reset.setPasswordButton': 'تعيين كلمة المرور',
  'auth.reset.successToast': 'تم تحديث كلمة المرور — سجّل الدخول بكلمتك الجديدة.',
  'auth.reset.mustChangeTitle': 'عيّن كلمة مرور جديدة للمتابعة',
  'auth.reset.mustChangeBody':
    'أصدر المسؤول كلمة مرور مؤقتة. اختر كلمة جديدة لإكمال تسجيل الدخول.',
  'auth.reset.currentTempLabel': 'كلمة المرور المؤقتة',
  'auth.reset.currentTempPlaceholder': 'كلمة المرور المؤقتة التي حصلت عليها',
  'auth.reset.tempWrong': 'كلمة المرور المؤقتة غير صحيحة. تحقّق منها وحاول مجددًا.',
  'auth.reset.mustDiffer': 'يجب أن تختلف كلمة المرور الجديدة عن المؤقتة.',
  'auth.login.continueWith': 'متابعة باستخدام {{provider}}',
  'auth.login.orWithPassword': 'أو بكلمة المرور',
  'auth.login.newToMaie': 'جديد على MAIE؟',
  'auth.login.createAccount': 'أنشئ حسابك',
  'auth.login.createAccountHint':
    'أعدّ مساحة عمل لعيادتك في دقيقة — ادعُ زملاءك وابدأ التوثيق.',
  'auth.login.needHelp': 'تحتاج مساعدة؟',
  'auth.login.tfaPrompt': 'أدخل الرمز من تطبيق المصادقة',
  'auth.login.tfaVerify': 'تأكيد',
  'auth.login.back': 'العودة',
  'auth.login.pickerPrompt': 'اختر المنظمة للمتابعة',
  'auth.login.langToggle': 'English',
  'auth.login.showPassword': 'إظهار كلمة المرور',
  'auth.login.hidePassword': 'إخفاء كلمة المرور',
  'auth.login.closeModal': 'إغلاق',
  'auth.login.ssoNotConfigured':
    'تسجيل الدخول بـ{{provider}} سيتوفر قريباً. استخدم كلمة المرور حالياً.',
  'auth.login.ssoNotConfiguredGeneric':
    'تسجيل الدخول الموحّد غير مهيأ بعد. استخدم كلمة المرور حالياً.',
  'auth.login.ssoStartFailed': 'فشل بدء تسجيل الدخول الموحّد',
  'auth.login.loginFailed': 'فشل تسجيل الدخول',
  'auth.login.passwordVerifyFailed': 'فشل التحقق من كلمة المرور',
  'auth.login.tenantPickFailed': 'فشل اختيار المنظمة',
  'auth.login.footerTag': 'بيانات المرضى لا تغادر مؤسستك',
  'auth.login.termsLink': 'شروط الخدمة',
  'auth.login.privacyLink': 'سياسة الخصوصية',
  'auth.login.legalSeparator': '·',

  'auth.register.title': 'ابدأ التوثيق خلال دقيقة',
  'auth.register.subtitle':
    'بريد وكلمة مرور فقط. ابدأ منفرداً وادعُ فريقك متى شئت.',
  'auth.register.eyebrow': 'ابدأ الآن',
  'auth.register.formEyebrow': 'تسجيل',
  'auth.register.emailLabel': 'البريد الإلكتروني',
  'auth.register.emailPlaceholder': 'you@clinic.example',
  'auth.register.passwordLabel': 'كلمة المرور',
  'auth.register.passwordPlaceholder': 'اختر كلمة مرور قوية',
  'auth.register.confirmPasswordLabel': 'تأكيد كلمة المرور',
  'auth.register.confirmPasswordPlaceholder': 'أعد إدخال كلمة المرور',
  'auth.register.passwordMismatch': 'كلمتا المرور غير متطابقتين',
  'auth.register.passwordTooShort': 'يجب ألا تقل كلمة المرور عن ٨ أحرف.',
  'auth.register.passwordHint': '٨ أحرف على الأقل.',
  'auth.register.submitButton': 'إنشاء الحساب',
  'auth.register.alreadyHaveAccount': 'لديك حساب بالفعل؟',
  'auth.register.signInLink': 'تسجيل الدخول',
  'auth.register.clinicNameLabel': 'اسم العيادة',
  'auth.register.clinicNamePlaceholder': 'عيادة القاهرة العائلية',
  'auth.register.slugLabel': 'النطاق الفرعي',
  'auth.register.slugHint':
    'هذا هو الرابط الذي سيستخدمه فريقك لتسجيل الدخول. يمكنك تعديله الآن — لا يمكن تغييره بعد إنشاء الحساب.',
  'auth.register.slugPlaceholder': 'cairo-family-clinic',
  'auth.register.slugChecking': 'جارٍ التحقق…',
  'auth.register.slugAvailable': 'متاح',
  'auth.register.slugTaken': 'محجوز',
  'auth.register.slugReserved': 'كلمة محجوزة — اختر أخرى',
  'auth.register.slugInvalid': 'استخدم أحرفاً صغيرة وأرقاماً وشرطات.',
  // TODO(ar-review): new register-address strings below need Ahmed's pass.
  'auth.register.clinicAddressPreview': 'عنوان عيادتك: ',
  'auth.register.slugAuto': 'سنجهّز عنوان الويب لعيادتك تلقائياً.',
  'auth.register.customizeSlug': 'تخصيص عنوان العيادة',
  'auth.register.slugUseAutomatic': 'استخدام التلقائي',
  'auth.register.joinExisting': 'تنضم إلى عيادة موجودة؟',
  'auth.register.joinExistingCta': 'سجّل الدخول بدعوتك',
  'auth.register.termsCheckboxPrefix': 'أوافق على',
  'auth.register.termsLink': 'شروط خدمة MAIE',
  'auth.register.termsAnd': 'و',
  'auth.register.privacyLink': 'إشعار الخصوصية',
  'auth.register.signUpFailed': 'تعذّر إنشاء الحساب',
  'auth.register.clinicRequired':
    'اسم العيادة والنطاق الفرعي مطلوبان.',
  'auth.register.slugMustBeAvailable':
    'اختر نطاقاً فرعياً متاحاً للمتابعة.',
  'auth.register.continueWithGoogle': 'المتابعة عبر Google',
  'auth.register.orWithEmail': 'أو ببريد إلكتروني',
  'auth.register.heroTitle': 'ابقَ مع مريضك.',
  'auth.register.heroTitleAccent': 'MAIE يتولى التوثيق.',
  'auth.register.heroSubtitle':
    'كاتب آلي وسجل طبي في منتج واحد. ابدأ منفرداً وتوسع إلى عيادة حين تجهز.',
  'auth.register.proof1Title': 'جاهز في ٦٠ ثانية',
  'auth.register.proof1Body':
    'لا نماذج إعداد ولا مكالمات مبيعات. بريد وكلمة مرور وأنت داخل.',
  'auth.register.proof2Title': 'أضف فريقك لاحقاً',
  'auth.register.proof2Body':
    'حين تستقطب موظفين، ادعُهم بدور. نفس مساحة العمل، نفس السجل.',
  'auth.register.proof3Title': 'سيادة افتراضية',
  'auth.register.proof3Body':
    'مفاتيح تشفير لكل مؤسسة. بيانات المرضى تبقى في منطقتك.',

  'auth.errors.usernameRequired': 'اسم المستخدم مطلوب',
  'auth.errors.passwordRequired': 'كلمة المرور مطلوبة',
  'auth.errors.twoFactorRequired': 'رمز الأمان مطلوب',
  'auth.twoFactorRequired': 'المصادقة الثنائية مطلوبة. يرجى إدخال رمز الأمان.',
  'auth.electronicMedicalRecords': 'السجلات الطبية الإلكترونية',
  'auth.poweredBy': 'مدعوم بواسطة {{provider}}',
  'auth.transformYourHealthcare': 'حوّل',
  'auth.healthcarePractice': 'ممارستك الصحية',
  'auth.nextGenerationDescription': 'اختبر الجيل القادم من إدارة السجلات الطبية مع رؤى مدعومة بالذكاء الاصطناعي وسير عمل سلس.',
  'auth.keyFeatures': 'الميزات الرئيسية',
  'auth.smartDocumentation': 'توثيق ذكي',
  'auth.smartDocumentationDesc': 'سجلات طبية مدعومة بالذكاء الاصطناعي',
  'auth.appointmentManagement': 'إدارة المواعيد',
  'auth.appointmentManagementDesc': 'نظام جدولة سلس',
  'auth.patientPortal': 'بوابة المرضى',
  'auth.patientPortalDesc': 'مشاركة محسّنة للمرضى',
  'auth.fastEfficient': 'سريع وفعال',
  'auth.fastEfficientDesc': 'سير عمل محسّن',
  'auth.signInDescription': 'قم بتسجيل الدخول للوصول إلى لوحة معلومات السجلات الطبية',
  'auth.demoAccount': 'حساب تجريبي',
  'auth.hide': 'إخفاء',
  'auth.enterUsername': 'أدخل اسم المستخدم',
  'auth.enterPassword': 'أدخل كلمة المرور',
  'auth.twoFactorCodePlaceholder': '000000',

  // Dashboard
  'dashboard.title': 'لوحة التحكم',
  'dashboard.subtitle': 'مرحباً بعودتك! إليك نظرة عامة لليوم',
  'dashboard.welcomeMessage': 'مرحباً بك في نظام إدارة العيادة الطبية',
  'dashboard.doctorWelcome': 'مرحباً بعودتك، د. {{name}}! جاهز لتقديم رعاية ممتازة للمرضى.',
  'dashboard.nurseWelcome': 'مرحباً بعودتك، {{name}}! مرضاك يعتمدون على رعايتك الممتازة.',
  'dashboard.adminWelcome': 'مرحباً بعودتك، {{name}}! نظامك يعمل بسلاسة.',
  'dashboard.overview': 'نظرة عامة على لوحة التحكم',
  'dashboard.todaysAppointments': 'مواعيد اليوم',
  'dashboard.totalPatients': 'إجمالي المرضى',
  'dashboard.pendingTasks': 'المهام المعلقة',
  'dashboard.criticalAlerts': 'التنبيهات الحرجة',
  'dashboard.quickActions': 'إجراءات سريعة',
  'dashboard.recentActivity': 'النشاط الأخير',
  'dashboard.upcomingAppointments': 'المواعيد القادمة',
  'dashboard.performanceMetrics': 'مقاييس الأداء',
  'dashboard.patientSatisfaction': 'رضا المرضى',
  'dashboard.appointmentEfficiency': 'كفاءة المواعيد',
  'dashboard.documentationComplete': 'اكتمال التوثيق',
  'dashboard.aiInsights': 'رؤى الذكاء الاصطناعي',
  'dashboard.onSchedule': 'في الموعد',
  'dashboard.updated': 'محدث',
  'dashboard.medicalRecords': 'السجلات الطبية',
  'dashboard.completionRate': 'معدل {{rate}}%',
  'dashboard.completedToday': 'تم إكمالها اليوم',
  'dashboard.newPatient': 'مريض جديد',
  'dashboard.scheduleAppointment': 'جدولة موعد',
  'dashboard.createRecord': 'إنشاء سجل',
  'dashboard.aiRecommendations': 'توصيات الذكاء الاصطناعي',
  'dashboard.patientFollowUps': 'متابعات المرضى',
  'dashboard.followUpsDue': '{{count}} مريض بحاجة لمواعيد متابعة',
  'dashboard.preventiveCare': 'الرعاية الوقائية',
  'dashboard.screeningsNeeded': '{{count}} مريض يحتاجون لفحوصات سنوية',
  'dashboard.documentation': 'التوثيق',
  'dashboard.incompleteRecords': '{{count}} سجلات طبية غير مكتملة',
  'dashboard.practiceHealth': 'صحة العيادة',
  'dashboard.welcomeBack': 'مرحباً بعودتك',
  'dashboard.registeredPatients': 'المرضى المسجلين',
  'dashboard.totalScheduled': 'إجمالي المجدولة',
  'dashboard.clinicalDocumentation': 'التوثيق السريري',
  'dashboard.labOrders': 'طلبات المختبر',
  'dashboard.inProgress': 'قيد التنفيذ',
  'dashboard.invoices': 'الفواتير',
  'dashboard.pending': 'معلق',
  'dashboard.templates': 'القوالب',
  'dashboard.clinicalTemplates': 'القوالب السريرية',
  'dashboard.systemOverview': 'نظرة عامة على النظام',
  'dashboard.activeModules': 'الوحدات النشطة',
  'dashboard.totalRecords': 'إجمالي السجلات',
  'dashboard.todaysActivity': 'نشاط اليوم',
  'dashboard.occupancy': 'الإشغال',
  'dashboard.clinicalOperations': 'العمليات السريرية',
  'dashboard.administrative': 'الإدارية',
  'dashboard.clinicalInsights': 'رؤى سريرية',
  'dashboard.noModulesEnabled': 'لا توجد وحدات مفعلة',
  'dashboard.noModulesEnabledMessage': 'لا توجد وحدات مفعلة حالياً. يرجى الاتصال بالمسؤول لتفعيل الوحدات.',
  'dashboard.goToFeatureToggles': 'الذهاب إلى إعدادات الميزات',
  'dashboard.thisMonth': 'هذا الشهر',

  // Patients
  'patients.title': 'المرضى',
  'patients.subtitle': 'إدارة سجلات ومعلومات المرضى',
  'patients.addNew': 'إضافة مريض',
  'patients.addPatient': 'إضافة مريض',
  'patients.allData': 'جميع بيانات المرضى',

  // Patient Photos
  'patients.photo.upload': 'رفع صورة',
  'patients.photo.change': 'تغيير الصورة',
  'patients.photo.uploading': 'جاري الرفع...',
  'patients.photo.dragAndDrop': 'اسحب واسقط صورة هنا، أو انقر للاختيار',
  'patients.photo.supportedFormats': 'الصيغ المدعومة: {{formats}}',
  'patients.photo.maxSize': 'الحد الأقصى لحجم الملف: {{size}}',
  'patients.photo.invalidFileType': 'نوع ملف غير صالح. يرجى اختيار ملف صورة صالح.',
  'patients.photo.fileTooLarge': 'الملف كبير جداً. الحد الأقصى {{max}} ميجابايت.',
  'patients.photo.uploadFailed': 'فشل في رفع الصورة. يرجى المحاولة مرة أخرى.',
  'patients.photo.uploadSuccess': 'تم رفع الصورة بنجاح.',
  'patients.searchPlaceholder': 'ابحث عن المرضى بالاسم أو الرقم أو الهاتف...',
  'patients.filterAll': 'جميع المرضى',
  'patients.filterActive': 'نشط',
  'patients.filterInactive': 'غير نشط',
  'patients.totalPatients': 'إجمالي المرضى',
  'patients.malePatients': 'المرضى الذكور',
  'patients.femalePatients': 'المرضى الإناث',
  'patients.avgAge': 'متوسط العمر',
  'patients.years': 'سنة',
  'patients.noResults': 'لم يتم العثور على مرضى',
  'patients.adjustSearch': 'حاول تعديل البحث أو الفلاتر',
  'patients.notFound': 'لم يتم العثور على المريض',
  'patients.admitted': 'منوم',
  'patients.outpatient': 'مريض خارجي',
  'patients.filterAllStatus': 'جميع الحالات',
  'patients.filterAdmitted': 'منوم حالياً',
  'patients.filterOutpatient': 'مريض خارجي',
  'patients.filterNeverAdmitted': 'لم يتم إدخاله مطلقاً',
  'patients.analyzeData': 'تحليل بيانات المرضى',
  'patients.allGenders': 'جميع الأجناس',
  'patients.sortBy': 'ترتيب حسب',
  'patients.newestFirst': 'الأحدث أولاً',
  'patients.oldestFirst': 'الأقدم أولاً',
  'patients.firstNameAZ': 'الاسم الأول (أ-ي)',
  'patients.firstNameZA': 'الاسم الأول (ي-أ)',
  'patients.lastNameAZ': 'اسم العائلة (أ-ي)',
  'patients.lastNameZA': 'اسم العائلة (ي-أ)',
  'patients.statistics': 'إحصائيات المرضى',
  'patients.generateReport': 'إنشاء تقرير',
  'patients.activePatients': 'المرضى النشطون',
  'patients.loading': 'جاري تحميل المرضى...',
  'patients.errorLoading': 'خطأ في تحميل المرضى',
  'patients.errorLoadingMessage': 'فشل في تحميل المرضى',

  // Patient Form Fields
  'patient.name': 'الاسم الكامل',
  'patient.arabicName': 'الاسم الكامل (بالعربية)',
  'patient.age': 'العمر',
  'patient.gender': 'الجنس',
  'patient.male': 'ذكر',
  'patient.female': 'أنثى',
  'patient.other': 'آخر',
  'patient.email': 'البريد الإلكتروني',
  'patient.phone': 'رقم الهاتف',
  'patient.dateOfBirth': 'تاريخ الميلاد',
  'patient.address': 'العنوان',
  'patient.arabicAddress': 'العنوان (بالعربية)',
  'patient.bloodType': 'فصيلة الدم',
  'patient.allergies': 'الحساسية',
  'patient.arabicAllergies': 'الحساسية (بالعربية)',
  'patient.medicalHistory': 'التاريخ المرضي',
  'patient.arabicMedicalHistory': 'التاريخ المرضي (بالعربية)',
  'patient.emergencyContact': 'جهة اتصال الطوارئ',
  'patient.emergencyPhone': 'هاتف الطوارئ',

  // Patient Details Page
  'patient.patientId': 'رقم المريض',
  'patient.patient': 'المريض',
  'patient.addToAIContext': 'إضافة إلى سياق الذكاء الاصطناعي',
  'patient.editPatient': 'تعديل المريض',
  'patient.basicInformation': 'المعلومات الأساسية',
  'patient.recentRecords': 'السجلات الطبية الحديثة',
  'patient.medicationsPrescribed': 'تم وصف {{count}} دواء',
  'patient.noRecords': 'لم يتم العثور على سجلات طبية',
  'patient.scheduleNew': 'جدولة موعد جديد',
  'patient.noUpcomingAppointments': 'لا توجد مواعيد قادمة',
  'patient.medicalInfo': 'المعلومات الطبية',
  'patient.upcomingAppointments': 'المواعيد القادمة',
  'patient.addPatientToAIContext': 'إضافة المريض إلى سياق الذكاء الاصطناعي',
  'patient.admitPatient': 'إدخال المريض',
  'patient.currentAdmission': 'الإدخال الحالي',
  'patient.admissionDate': 'تاريخ الإدخال',
  'patient.ward': 'الجناح/الغرفة/السرير',
  'patient.admissionStatus': 'حالة الإدخال',
  'patient.admissionDiagnosis': 'تشخيص الإدخال',
  'patient.dischargePatient': 'إخراج المريض',
  'patient.transferPatient': 'نقل المريض',
  'patient.admissionHistory': 'سجل الإدخال',
  'patient.stillAdmitted': 'لا يزال منوماً',
  'patient.location': 'الموقع',
  'patient.room': 'الغرفة',

  // Patient Details Tabs
  'patientDetails.tabs.overview': 'نظرة عامة',
  'patientDetails.tabs.medicalHistory': 'التاريخ الطبي',
  'patientDetails.tabs.labs': 'طلبات المختبر',
  'patientDetails.tabs.records': 'السجلات',
  'patientDetails.tabs.appointments': 'المواعيد',
  'patientDetails.tabs.medications': 'الأدوية',
  'patientDetails.tabs.notes': 'الملاحظات السريرية',

  // Patient Details Sections
  'patientDetails.demographics': 'المعلومات الديموغرافية',
  'patientDetails.medicalRecords': 'السجلات الطبية',
  'patientDetails.vitals': 'العلامات الحيوية',
  'patientDetails.conditions': 'الحالات الطبية',
  'patientDetails.insuranceInfo': 'معلومات التأمين',
  'patientDetails.emergencyContacts': 'جهات الاتصال في حالات الطوارئ',
  'patientDetails.documents': 'المستندات',
  'patientDetails.allergiesAndReactions': 'الحساسية والتفاعلات',
  'patientDetails.immunizations': 'التطعيمات',
  'patientDetails.familyHistory': 'التاريخ العائلي',
  'patientDetails.socialHistory': 'التاريخ الاجتماعي',

  // Patient Details Labels
  'patientDetails.patientSince': 'مريض منذ',
  'patientDetails.lastVisit': 'آخر زيارة',
  'patientDetails.nextAppointment': 'الموعد القادم',
  'patientDetails.totalVisits': 'إجمالي الزيارات',
  'patientDetails.activeProblems': 'المشاكل النشطة',

  // Patient Details Buttons
  'patientDetails.addRecord': 'إضافة سجل',
  'patientDetails.newAppointment': 'موعد جديد',
  'patientDetails.orderLab': 'طلب مختبر',
  'patientDetails.prescribeMedication': 'وصف دواء',
  'patientDetails.addNote': 'إضافة ملاحظة',
  'patientDetails.voiceNote': 'ملاحظة صوتية',
  'patientDetails.noNotesYet': 'لا توجد ملاحظات سريرية بعد. أضف أول ملاحظة للبدء.',
  'patientDetails.viewAll': 'عرض الكل',
  'patientDetails.print': 'طباعة',
  'patientDetails.export': 'تصدير',
  'patientDetails.share': 'مشاركة',
  'patientDetails.download': 'تحميل',

  // Patient Details Form Fields
  'patientDetails.recordType': 'نوع السجل',
  'patientDetails.recordDate': 'تاريخ السجل',
  'patientDetails.provider': 'مقدم الخدمة',
  'patientDetails.diagnosis': 'التشخيص',
  'patientDetails.treatment': 'العلاج',
  'patientDetails.notes': 'الملاحظات',

  // Patient Details Placeholders
  'patientDetails.searchRecords': 'بحث في السجلات...',
  'patientDetails.selectProvider': 'اختر مقدم الخدمة',
  'patientDetails.enterDiagnosis': 'أدخل التشخيص',

  // Patient Details Status Messages
  'patientDetails.noRecordsFound': 'لم يتم العثور على سجلات',
  'patientDetails.noUpcomingAppointments': 'لا توجد مواعيد قادمة',
  'patientDetails.loading': 'جار تحميل تفاصيل المريض...',

  // Patient Details Warnings
  'patientDetails.criticalAllergy': 'تنبيه حساسية حرجة',
  'patientDetails.drugInteraction': 'تفاعل دوائي محتمل',

  // Patient Timeline
  'patient.timeline': 'المخطط الزمني للمريض',
  'patient.completeHistory': 'التاريخ الطبي الكامل',
  'patient.medicalTimeline': 'المخطط الزمني الطبي',
  'patient.allEvents': 'جميع الأحداث',
  'patient.admissions': 'الإدخالات',
  'patient.discharges': 'الإخراجات',
  'patient.allTime': 'كل الوقت',
  'patient.last30Days': 'آخر 30 يوماً',
  'patient.last90Days': 'آخر 90 يوماً',
  'patient.lastYear': 'السنة الماضية',
  'patient.events': 'أحداث',
  'patient.noEventsFound': 'لم يتم العثور على أحداث تطابق معاييرك',
  'patient.admitted': 'تم الإدخال',
  'patient.discharged': 'تم الإخراج',
  'patient.routineDischarge': 'إخراج روتيني',
  'patient.admissionType': 'نوع الإدخال',

  // Insurance Management
  'patient.insuranceManagement': 'إدارة التأمين',
  'patient.addInsurance': 'إضافة تأمين',
  'patient.editInsurance': 'تعديل التأمين',
  'patient.primaryInsurance': 'التأمين الأساسي',
  'patient.secondaryInsurance': 'التأمين الثانوي',
  'patient.noInsuranceRecords': 'لا توجد سجلات تأمين',
  'patient.addInsuranceToStart': 'أضف معلومات التأمين للبدء',
  'patient.addFirstInsurance': 'أضف تأمينك الأول',
  'patient.insuranceName': 'شركة التأمين',
  'patient.policyNumber': 'رقم البوليصة',
  'patient.groupNumber': 'رقم المجموعة',
  'patient.subscriberId': 'رقم المشترك',
  'patient.subscriberName': 'اسم المشترك',
  'patient.relationship': 'العلاقة بالمشترك',
  'patient.relationship.self': 'نفسي',
  'patient.relationship.spouse': 'الزوج/الزوجة',
  'patient.relationship.child': 'الطفل',
  'patient.relationship.other': 'أخرى',
  'patient.effectiveDate': 'تاريخ السريان',
  'patient.expirationDate': 'تاريخ الانتهاء',
  'patient.copay': 'مبلغ المشاركة',
  'patient.deductible': 'مبلغ التحمل',
  'patient.setPrimaryInsurance': 'تعيين كتأمين أساسي',
  'patient.activeInsurance': 'تأمين نشط',
  'patient.saveInsurance': 'حفظ التأمين',
  'patient.updateInsurance': 'تحديث التأمين',
  'patient.policy': 'البوليصة',
  'patient.subscriber': 'المشترك',
  'patient.insuranceCard.front': 'وجه البطاقة',
  'patient.insuranceCard.back': 'ظهر البطاقة',
  'patient.uploadCardImage': 'رفع صورة البطاقة',
  'patient.uploading': 'جاري الرفع...',
  'patient.insuranceNamePlaceholder': 'مثل: شركة التأمين الطبي التعاوني',
  'patient.policyNumberPlaceholder': 'مثل: ABC123456789',
  'patient.groupNumberPlaceholder': 'مثل: 12345',
  'patient.subscriberIdPlaceholder': 'مثل: 123456789',
  'patient.subscriberNamePlaceholder': 'مثل: محمد أحمد',

  // Resource Scheduling
  'scheduling.resourceScheduling': 'جدولة الموارد',
  'scheduling.manageResourceBookings': 'إدارة حجوزات الموارد والتوفر',
  'scheduling.newBooking': 'حجز جديد',
  'scheduling.searchResources': 'البحث عن الموارد...',
  'scheduling.allResources': 'جميع الموارد',
  'scheduling.rooms': 'الغرف',
  'scheduling.equipment': 'المعدات',
  'scheduling.facilities': 'المرافق',
  'scheduling.dayView': 'يوم',
  'scheduling.weekView': 'أسبوع',
  'scheduling.monthView': 'شهر',
  'scheduling.resourceAvailability': 'توفر الموارد',
  'scheduling.resources': 'موارد',
  'scheduling.resource': 'المورد',
  'scheduling.noResourcesFound': 'لم يتم العثور على موارد',
  'scheduling.adjustFilters': 'جرب تعديل البحث أو المرشحات',
  'scheduling.basicInformation': 'المعلومات الأساسية',
  'scheduling.type': 'النوع',
  'scheduling.room': 'غرفة',
  'scheduling.facility': 'مرفق',
  'scheduling.status': 'الحالة',
  'scheduling.status.available': 'متاح',
  'scheduling.status.occupied': 'مشغول',
  'scheduling.status.maintenance': 'صيانة',
  'scheduling.status.reserved': 'محجوز',
  'scheduling.capacity': 'السعة',
  'scheduling.people': 'أشخاص',
  'scheduling.features': 'المميزات',
  'scheduling.maintenance': 'الصيانة',
  'scheduling.frequency': 'التكرار',
  'scheduling.daily': 'يومي',
  'scheduling.weekly': 'أسبوعي',
  'scheduling.monthly': 'شهري',
  'scheduling.lastMaintenance': 'آخر صيانة',
  'scheduling.nextMaintenance': 'الصيانة القادمة',
  'scheduling.todaysBookings': 'حجوزات اليوم',
  'scheduling.noBookingsToday': 'لا توجد حجوزات مجدولة لليوم',
  'scheduling.priority.emergency': 'طارئ',
  'scheduling.priority.high': 'عالي',
  'scheduling.priority.medium': 'متوسط',
  'scheduling.priority.low': 'منخفض',

  // Provider Availability
  'scheduling.providerAvailability': 'توفر مقدمي الخدمة',
  'scheduling.manageProviderSchedules': 'إدارة جداول مقدمي الخدمة والتوفر',
  'scheduling.templates': 'القوالب',
  'scheduling.addAvailability': 'إضافة توفر',
  'scheduling.searchProviders': 'البحث عن مقدمي الخدمة...',
  'scheduling.allDepartments': 'جميع الأقسام',
  'scheduling.scheduleOverview': 'نظرة عامة على الجدول',
  'scheduling.providers': 'مقدمي خدمة',
  'scheduling.provider': 'مقدم الخدمة',
  'scheduling.noProvidersFound': 'لم يتم العثور على مقدمي خدمة',
  'scheduling.noSchedule': 'لا يوجد جدول',
  'scheduling.editAvailability': 'تعديل التوفر',
  'scheduling.selectProvider': 'اختر مقدم الخدمة',
  'scheduling.date': 'التاريخ',
  'scheduling.startTime': 'وقت البداية',
  'scheduling.endTime': 'وقت النهاية',
  'scheduling.type.regular': 'وردية عادية',
  'scheduling.type.on-call': 'استدعاء',
  'scheduling.type.unavailable': 'غير متاح',
  'scheduling.type.vacation': 'إجازة',
  'scheduling.type.sick': 'إجازة مرضية',
  'scheduling.type.education': 'تعليم/تدريب',
  'scheduling.location': 'الموقع',
  'scheduling.locationPlaceholder': 'مثل: العيادة الرئيسية، غرفة العمليات 1',
  'scheduling.notes': 'الملاحظات',
  'scheduling.notesPlaceholder': 'ملاحظات أو تعليمات إضافية...',

  // Waitlist Management
  'scheduling.waitlistManagement': 'إدارة قائمة الانتظار',
  'scheduling.managePatientWaitlist': 'إدارة قائمة انتظار المرضى والطوابير',
  'scheduling.autoMatch': 'المطابقة التلقائية',
  'scheduling.addToWaitlist': 'إضافة لقائمة الانتظار',
  'scheduling.totalWaiting': 'إجمالي المنتظرين',
  'scheduling.urgentCases': 'الحالات العاجلة',
  'scheduling.contacted': 'تم الاتصال',
  'scheduling.scheduled': 'مجدول',
  'scheduling.searchWaitlist': 'البحث في قائمة الانتظار...',
  'scheduling.allStatuses': 'جميع الحالات',
  'scheduling.allUrgencies': 'جميع الأولويات',
  'scheduling.status.waiting': 'انتظار',
  'scheduling.status.contacted': 'تم الاتصال',
  'scheduling.status.scheduled': 'مجدول',
  'scheduling.status.cancelled': 'ملغي',
  'scheduling.urgency.emergency': 'طوارئ',
  'scheduling.urgency.urgent': 'عاجل',
  'scheduling.urgency.routine': 'روتيني',
  'scheduling.sortBy': 'ترتيب حسب',
  'scheduling.position': 'الموضع',
  'scheduling.urgency': 'الأولوية',
  'scheduling.waitTime': 'وقت الانتظار',
  'scheduling.dateAdded': 'تاريخ الإضافة',
  'scheduling.waitlistEntries': 'إدخالات قائمة الانتظار',
  'scheduling.patient': 'المريض',
  'scheduling.appointmentType': 'نوع الموعد',
  'scheduling.availableSlots': 'الأوقات المتاحة',
  'scheduling.since': 'منذ',
  'scheduling.contactAttempts': 'محاولات الاتصال',
  'scheduling.contactPatient': 'الاتصال بالمريض',
  'scheduling.scheduleAppointment': 'جدولة الموعد',
  'scheduling.noWaitlistEntries': 'لا توجد إدخالات في قائمة الانتظار',
  'scheduling.adjustFiltersOrAdd': 'جرب تعديل المرشحات أو أضف إدخالاً جديداً',
  'scheduling.noMatchingSlots': 'لا توجد أوقات متطابقة متاحة',
  'scheduling.schedule': 'جدولة',
  'scheduling.markContacted': 'تحديد كمتصل به',
  'common.days': 'أيام',

  // Order Management
  'orders.management.title': 'إدارة الطلبات',
  'orders.management.subtitle': 'إدارة ومتابعة جميع الطلبات في النظام',
  'orders.status.pending': 'قيد الانتظار',
  'orders.status.active': 'نشط',
  'orders.status.completed': 'مكتمل',
  'orders.status.discontinued': 'متوقف',
  'orders.priority.urgent': 'عاجل',
  'orders.priority.routine': 'روتيني',
  'orders.search.placeholder': 'البحث بالمريض أو الطبيب أو رقم الطلب',
  'orders.filter.status': 'الحالة',
  'orders.filter.type': 'النوع',
  'orders.filter.priority': 'الأولوية',
  'orders.filter.provider': 'الطبيب',
  'orders.filter.dateStart': 'تاريخ البداية',
  'orders.filter.dateEnd': 'تاريخ النهاية',
  'orders.bulk.selected': 'طلبات محددة',
  'orders.actions.hold': 'إيقاف مؤقت',
  'orders.actions.resume': 'استئناف',
  'orders.actions.discontinue': 'إيقاف',
  'orders.actions.renew': 'تجديد',
  'orders.list.title': 'الطلبات',
  'orders.list.sortBy': 'ترتيب حسب',
  'orders.sort.date': 'التاريخ',
  'orders.sort.patient': 'المريض',
  'orders.sort.provider': 'الطبيب',
  'orders.sort.status': 'الحالة',
  'orders.sort.type': 'النوع',
  'orders.sort.priority': 'الأولوية',
  'orders.table.type': 'النوع',
  'orders.table.patient': 'المريض',
  'orders.table.details': 'التفاصيل',
  'orders.table.status': 'الحالة',
  'orders.table.priority': 'الأولوية',
  'orders.table.provider': 'الطبيب',
  'orders.table.date': 'التاريخ',
  'orders.noOrders': 'لا توجد طلبات',
  'orders.noOrdersDesc': 'حاول تعديل المرشحات أو معايير البحث',

  // Clinical Decision Support
  'cds.title': 'دعم القرار السريري',
  'cds.loading': 'تحليل الطلب للسلامة والفعالية...',
  'cds.alertsFound': 'تنبيه(ات) تتطلب الانتباه',
  'cds.noAlerts': 'لم يتم تحديد مخاوف أمان',
  'cds.interactions.title': 'تفاعلات الأدوية',
  'cds.interactions.none': 'لم يتم اكتشاف تفاعلات دوائية',
  'cds.allergies.title': 'تنبيهات الحساسية',
  'cds.allergies.none': 'لا توجد حساسية معروفة لهذا الدواء',
  'cds.allergies.reaction': 'التفاعل السابق',
  'cds.allergies.crossSensitivity': 'الحساسية المتقاطعة ممكنة',
  'cds.dosing.title': 'توصيات الجرعة',
  'cds.dosing.appropriate': 'الجرعة تبدو مناسبة',
  'cds.dosing.adjustment': 'تعديل',
  'cds.dosing.adjusted': 'الجرعة المعدلة',
  'cds.guidelines.title': 'الإرشادات السريرية',
  'cds.guidelines.none': 'لم يتم العثور على إرشادات محددة',
  'cds.calculations.title': 'حسابات الجرعة',
  'cds.calculations.none': 'الجرعة القياسية تنطبق',
  'cds.calculations.dosing': 'الجرعة',
  'cds.calculations.current': 'الجرعة الحالية',
  'cds.calculations.recommended': 'الجرعة الموصى بها',
  'cds.cost.title': 'فعالية التكلفة',
  'cds.cost.optimal': 'تم اختيار خيار فعال من حيث التكلفة',
  'cds.cost.alert': 'تنبيه',
  'cds.cost.alternatives': 'البدائل',
  'cds.actions.dismiss': 'إغلاق الكل',
  'cds.actions.acknowledge': 'تأكيد والمتابعة',
  'cds.drugInteraction': 'تفاعل دوائي',
  'cds.allergyAlert': 'تنبيه الحساسية',
  'cds.dosageAlert': 'تنبيه الجرعة',
  'cds.recommendation': 'التوصية',
  'cds.drugs': 'الأدوية',
  'cds.mechanism': 'الآلية',
  'cds.clinicalEffects': 'التأثيرات السريرية',
  'cds.management': 'الإدارة',
  'cds.adjustmentReason': 'سبب التعديل',
  'cds.recommendedDose': 'الجرعة الموصى بها',
  'cds.references': 'المراجع',
  'cds.overrideReason': 'سبب التجاوز',
  'cds.overrideReasonPlaceholder': 'أدخل سبب التجاوز...',
  'cds.override': 'تجاوز',
  'cds.additionalAlerts': 'تنبيهات إضافية',
  'cds.severity.critical': 'حرج',
  'cds.severity.high': 'عالي',
  'cds.severity.medium': 'متوسط',
  'cds.severity.low': 'منخفض',
  'cds.severity.info': 'معلومات',
  'cds.alertType.drugInteraction': 'تفاعل دوائي',
  'cds.alertType.allergy': 'حساسية',
  'cds.alertType.contraindication': 'موانع الاستعمال',
  'cds.alertType.dosage': 'الجرعة',
  'cds.alertType.duplicateTherapy': 'علاج مكرر',
  'cds.alertType.renalAdjustment': 'تعديل كلوي',
  'cds.alertType.hepaticAdjustment': 'تعديل كبدي',
  'cds.alertType.monitoring': 'مراقبة مطلوبة',
  'cds.alertType.costAlternative': 'بديل اقتصادي',
  'cds.alertType.formularyRestriction': 'قيد الدليل الدوائي',
  'cds.checkInteractions': 'فحص التفاعلات',
  'cds.calculateDose': 'حساب الجرعة',
  'cds.viewGuidelines': 'عرض الإرشادات',
  'cds.noAlertsFound': 'لم يتم العثور على تنبيهات',
  'cds.checking': 'جاري الفحص...',

  // Administrative Features
  'admin.systemSettings.title': 'إعدادات النظام',
  'admin.systemSettings.subtitle': 'تكوين منشأتك وعلامتك التجارية وتفضيلاتك',
  'admin.systemSettings.unsavedChanges': 'تغييرات غير محفوظة',
  'admin.systemSettings.lastSaved': 'آخر حفظ',
  'admin.systemSettings.tabs.hospital': 'المنشأة',
  'admin.systemSettings.tabs.system': 'النظام',
  'admin.systemSettings.tabs.branding': 'العلامة التجارية',
  'admin.systemSettings.tabs.backup': 'النسخ الاحتياطي',
  'admin.systemSettings.tabs.domains': 'النطاقات',
  'admin.systemSettings.hospital.basicInfo': 'معلومات المنشأة',
  'admin.systemSettings.hospital.basicInfoDesc': 'التفاصيل الأساسية لمنشأتك — مستشفى أو عيادة أو ممارسة فردية',
  'admin.systemSettings.hospital.nameEn': 'اسم المنشأة (إنجليزي)',
  'admin.systemSettings.hospital.nameAr': 'اسم المنشأة (عربي)',
  'admin.systemSettings.hospital.logo': 'شعار المنشأة',
  'admin.systemSettings.hospital.uploadLogo': 'رفع الشعار',
  'admin.systemSettings.hospital.movedToBranding':
    'يُدار اسم المستشفى والشعار من تبويب الهوية البصرية كي تنبع نفس القيمة للشريط الجانبي وصفحة تسجيل الدخول وملفات PDF.',
  'admin.systemSettings.hospital.contact': 'معلومات الاتصال',
  'admin.systemSettings.hospital.contactDesc': 'كيف يصل المرضى والشركاء إلى منشأتك',
  'admin.systemSettings.hospital.phone': 'رقم الهاتف',
  'admin.systemSettings.hospital.email': 'عنوان البريد الإلكتروني',
  'admin.systemSettings.hospital.website': 'الموقع الإلكتروني',
  'admin.systemSettings.hospital.location': 'الموقع والترخيص',
  'admin.systemSettings.hospital.locationDesc': 'العنوان الفعلي ومعلومات الترخيص',
  'admin.systemSettings.hospital.defaultLocale': 'اللغة الافتراضية',
  'admin.systemSettings.hospital.licenseNumber': 'رقم الترخيص',
  'admin.systemSettings.hospital.issuedBy': 'الجهة المصدرة',
  'admin.systemSettings.hospital.validUntil': 'صالح حتى',
  'admin.systemSettings.hospital.phoneCountry': 'دولة أرقام الهاتف',
  'admin.systemSettings.hospital.currencyDisplay': 'عرض العملة',
  'admin.systemSettings.hospital.currencyDisplayDesc': 'اختر طريقة عرض المبالغ في الفواتير. يتم اختيار الافتراضي تلقائياً بناءً على إعدادات المتصفح.',
  'admin.systemSettings.hospital.currencyCode': 'العملة',
  'admin.systemSettings.hospital.currencyPreview': 'معاينة',
  'admin.systemSettings.system.security': 'إعدادات الأمان',
  'admin.systemSettings.system.securityDesc': 'تكوين سياسات الأمان والمصادقة',
  'admin.systemSettings.system.sessionTimeout': 'انتهاء مهلة الجلسة (دقائق)',
  'admin.systemSettings.system.passwordExpiry': 'انتهاء صلاحية كلمة المرور (أيام)',
  'admin.systemSettings.system.loginAttempts': 'الحد الأقصى لمحاولات تسجيل الدخول',
  'admin.systemSettings.system.requireMFA': 'تطلب المصادقة متعددة العوامل',
  'admin.systemSettings.system.dataRetention': 'الاحتفاظ بالبيانات',
  'admin.systemSettings.system.dataRetentionDesc': 'تكوين مدة الاحتفاظ بالبيانات في النظام',
  'admin.systemSettings.system.patientRecords': 'سجلات المرضى (أشهر)',
  'admin.systemSettings.system.auditLogs': 'سجلات التدقيق (أشهر)',
  'admin.systemSettings.system.backups': 'النسخ الاحتياطية (أشهر)',
  'admin.systemSettings.branding.title': 'تخصيص العلامة التجارية',
  'admin.systemSettings.branding.description': 'تخصيص مظهر وشعور النظام',
  'admin.systemSettings.branding.primaryColor': 'اللون الأساسي',
  'admin.systemSettings.branding.secondaryColor': 'اللون الثانوي',
  'admin.systemSettings.branding.accentColor': 'اللون المميز',
  'admin.systemSettings.branding.logoPosition': 'موضع الشعار',
  'admin.systemSettings.branding.headerStyle': 'نمط الرأس',
  'admin.systemSettings.branding.left': 'يسار',
  'admin.systemSettings.branding.center': 'وسط',
  'admin.systemSettings.branding.right': 'يمين',
  'admin.systemSettings.branding.simple': 'بسيط',
  'admin.systemSettings.branding.gradient': 'متدرج',
  'admin.systemSettings.branding.image': 'خلفية صورة',
  'admin.systemSettings.branding.preview': 'معاينة الألوان',
  'admin.systemSettings.backup.settings': 'إعدادات النسخ الاحتياطي',
  'admin.systemSettings.backup.settingsDesc': 'تكوين خيارات النسخ الاحتياطي والاستعادة التلقائية',
  'admin.systemSettings.backup.autoBackup': 'تمكين النسخ الاحتياطي التلقائي',
  'admin.systemSettings.backup.frequency': 'تكرار النسخ الاحتياطي',
  'admin.systemSettings.backup.retention': 'الاحتفاظ (أيام)',
  'admin.systemSettings.backup.location': 'موقع النسخ الاحتياطي',
  'admin.systemSettings.backup.daily': 'يومي',
  'admin.systemSettings.backup.weekly': 'أسبوعي',
  'admin.systemSettings.backup.monthly': 'شهري',
  'admin.systemSettings.backup.local': 'التخزين المحلي',
  'admin.systemSettings.backup.cloud': 'التخزين السحابي',
  'admin.systemSettings.backup.both': 'كلاهما',
  'admin.systemSettings.backup.manual': 'النسخ الاحتياطي والاستعادة اليدوية',
  'admin.systemSettings.backup.manualDesc': 'إنشاء نسخ احتياطية يدوية أو الاستعادة من النسخ الاحتياطية الموجودة',
  'admin.systemSettings.backup.creating': 'إنشاء نسخة احتياطية...',
  'admin.systemSettings.backup.export': 'تصدير نسخة احتياطية',
  'admin.systemSettings.backup.restore': 'استعادة نسخة احتياطية',
  'admin.systemSettings.backup.warning': 'معلومات مهمة حول النسخ الاحتياطي',
  'admin.systemSettings.backup.warningText1': 'استعادة النسخة الاحتياطية ستحل محل البيانات الحالية',
  'admin.systemSettings.backup.warningText2': 'قم دائماً بإنشاء نسخة احتياطية قبل الاستعادة',
  'admin.systemSettings.backup.warningText3': 'تحتوي ملفات النسخ الاحتياطي على بيانات حساسة - احفظها بأمان',

  // System Monitoring
  'admin.monitoring.title': 'مراقبة النظام',
  'admin.monitoring.subtitle': 'مراقبة الأداء والصحة العامة للنظام في الوقت الفعلي',
  'admin.monitoring.lastUpdated': 'آخر تحديث',
  'admin.monitoring.autoRefresh': 'التحديث التلقائي',
  'admin.monitoring.cpu.title': 'استخدام المعالج',
  'admin.monitoring.memory.title': 'استخدام الذاكرة',
  'admin.monitoring.disk.title': 'استخدام القرص',
  'admin.monitoring.users.title': 'المستخدمون النشطون',
  'admin.monitoring.performance.title': 'اتجاهات الأداء',
  'admin.monitoring.timeRange.1h': 'الساعة الماضية',
  'admin.monitoring.timeRange.6h': '6 ساعات الماضية',
  'admin.monitoring.timeRange.24h': '24 ساعة الماضية',
  'admin.monitoring.timeRange.7d': '7 أيام الماضية',
  'admin.monitoring.alerts.title': 'تنبيهات النظام',
  'admin.monitoring.alerts.none': 'لا توجد تنبيهات نشطة',
  'admin.monitoring.alerts.resolve': 'حل',
  'admin.monitoring.network.title': 'الشبكة وقاعدة البيانات',
  'admin.monitoring.network.latency': 'زمن استجابة الشبكة',
  'admin.monitoring.network.throughput': 'معدل النقل',
  'admin.monitoring.database.connections': 'اتصالات قاعدة البيانات',
  'admin.monitoring.database.queries': 'الاستعلامات/دقيقة',
  'admin.monitoring.storage.title': 'تفاصيل التخزين',
  'admin.monitoring.storage.system': 'قرص النظام',
  'admin.monitoring.storage.iops': 'العمليات/ثانية',
  'admin.monitoring.storage.free': 'المساحة الحرة',
  'admin.monitoring.storage.database': 'حجم قاعدة البيانات',
  'admin.monitoring.storage.backups': 'حجم النسخ الاحتياطية',

  // Audit Logs
  'admin.audit.title': 'سجلات التدقيق والامتثال',
  'admin.audit.subtitle': 'مراقبة نشاط النظام والحفاظ على سجلات الامتثال',
  'admin.audit.export': 'تصدير',
  'admin.audit.searchPlaceholder': 'البحث في السجلات...',
  'admin.audit.category': 'الفئة',
  'admin.audit.outcome': 'النتيجة',
  'admin.audit.riskLevel': 'مستوى المخاطر',
  'admin.audit.dateRange': 'نطاق التاريخ',
  'admin.audit.success': 'نجح',
  'admin.audit.failure': 'فشل',
  'admin.audit.warning': 'تحذير',
  'admin.audit.risk.low': 'منخفض',
  'admin.audit.risk.medium': 'متوسط',
  'admin.audit.risk.high': 'عالي',
  'admin.audit.risk.critical': 'حرج',
  'admin.audit.logs': 'سجلات التدقيق',
  'admin.audit.noLogs': 'لم يتم العثور على سجلات تدقيق',
  'admin.audit.noLogsDesc': 'حاول تعديل المرشحات أو نطاق التاريخ',
  'admin.audit.complianceReports': 'تقارير الامتثال',
  'admin.audit.generateHIPAA': 'تقرير HIPAA',
  'admin.audit.generateCustom': 'تقرير مخصص',
  'admin.audit.quickStats': 'إحصائيات سريعة',
  'admin.audit.totalLogs': 'إجمالي السجلات',
  'admin.audit.failedActions': 'الإجراءات الفاشلة',
  'admin.audit.highRiskEvents': 'الأحداث عالية المخاطر',
  'admin.audit.uniqueUsers': 'المستخدمون الفريدون',
  'admin.audit.logDetails': 'تفاصيل سجل التدقيق',
  'admin.audit.timestamp': 'الطابع الزمني',
  'admin.audit.user': 'المستخدم',
  'admin.audit.action': 'الإجراء',
  'admin.audit.resource': 'المورد',
  'admin.audit.ipAddress': 'عنوان IP',
  'admin.audit.sessionId': 'معرف الجلسة',
  'admin.audit.complianceFlags': 'علامات الامتثال',
  'admin.audit.details': 'تفاصيل إضافية',
  'admin.audit.userAgent': 'وكيل المستخدم',

  // Medical Records
  'records.title': 'السجلات الطبية',
  'records.subtitle': 'عرض وإدارة السجلات الطبية للمرضى',
  'records.addNew': 'إضافة سجل',
  'records.addRecord': 'إضافة سجل',
  'records.editRecord': 'تعديل السجل',
  'records.saveRecord': 'حفظ السجل',
  'records.overview': 'نظرة عامة على السجلات الطبية',
  'records.searchPlaceholder': 'البحث في السجلات...',
  'records.filterAll': 'جميع الأنواع',
  'records.filterConsultation': 'استشارة',
  'records.filterDiagnosis': 'تشخيص',
  'records.filterTreatment': 'علاج',
  'records.filterFollowUp': 'متابعة',
  'records.type': 'نوع السجل',
  'records.date': 'التاريخ',
  'records.patient': 'المريض',
  'records.selectPatient': 'اختر المريض',
  'records.selectPatientFirst': 'يرجى اختيار مريض أولاً',
  'records.recordType': 'نوع السجل',
  'records.types.consultation': 'استشارة',
  'records.types.diagnosis': 'تشخيص',
  'records.types.treatment': 'علاج',
  'records.types.followUp': 'متابعة',
  'records.vitalSigns': 'العلامات الحيوية',
  'records.vitals.bloodPressure': 'ضغط الدم',
  'records.vitals.temperature': 'درجة الحرارة (°ف)',
  'records.vitals.heartRate': 'معدل ضربات القلب (ن/د)',
  'records.vitals.weight': 'الوزن (كجم)',
  'records.vitals.height': 'الطول (سم)',
  'records.diagnosis': 'التشخيص',
  'records.diagnosisPlaceholder': 'أدخل تفاصيل التشخيص...',
  'records.arabicDiagnosis': 'التشخيص (بالعربية)',
  'records.treatmentPlan': 'خطة العلاج',
  'records.treatment': 'خطة العلاج',
  'records.treatmentPlaceholder': 'أدخل تفاصيل العلاج...',
  'records.arabicTreatment': 'خطة العلاج (بالعربية)',
  'records.medications': 'الأدوية',
  'records.medicationPlaceholder': 'أدخل اسم الدواء والجرعة...',
  'records.arabicMedications': 'الأدوية (بالعربية)',
  'records.notes': 'ملاحظات إضافية',
  'records.notesPlaceholder': 'أي ملاحظات إضافية أو توصيات...',
  'records.validation.patientRequired': 'يرجى اختيار المريض',
  'records.validation.subjectiveRequired': 'الذاتي مطلوب',
  'records.validation.objectiveRequired': 'الموضوعي مطلوب',
  'records.validation.assessmentRequired': 'التقييم مطلوب',
  'records.validation.planRequired': 'الخطة مطلوبة',
  'records.validation.diagnosisRequired': 'التقييم مطلوب',
  'records.validation.treatmentRequired': 'الخطة مطلوبة',
  'records.arabicNotes': 'ملاحظات إضافية (بالعربية)',
  // 'records.vitalSigns': 'العلامات الحيوية', // DUPLICATE REMOVED
  'records.bloodPressure': 'ضغط الدم',
  'records.temperature': 'درجة الحرارة',
  'records.heartRate': 'معدل ضربات القلب',
  'records.weight': 'الوزن',
  'records.height': 'الطول',
  'records.respiratoryRate': 'معدل التنفس',
  'records.oxygenSaturation': 'تشبع الأكسجين',
  'records.clinicalInformation': 'المعلومات السريرية',
  // 'records.treatmentPlan': 'خطة العلاج', // DUPLICATE REMOVED
  'records.medicationsPrescribed': 'الأدوية الموصوفة',
  'records.followUpInstructions': 'تعليمات المتابعة',
  'records.additionalNotes': 'ملاحظات إضافية',

  // Record Details Page
  'records.recordDetails': 'تفاصيل السجل',
  'records.recordId': 'رقم السجل',
  'records.record': 'السجل',
  'records.medicalRecord': 'السجل الطبي',
  'records.notFound': 'لم يتم العثور على السجل الطبي',
  'records.download': 'تحميل',
  'records.viewPatientProfile': 'عرض ملف المريض',
  'records.recordInformation': 'معلومات السجل',
  'records.consultation': 'استشارة',
  'records.follow-up': 'متابعة',
  // 'records.treatmentPlan': 'خطة العلاج', // DUPLICATE REMOVED
  'records.prescribedMedications': 'الأدوية الموصوفة',
  'records.downloadPDF': 'تحميل PDF',
  'records.printRecord': 'طباعة السجل',
  'records.shareWithPatient': 'مشاركة مع المريض',
  'records.deleteConfirmTitle': 'حذف السجل الطبي؟',
  'records.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف هذا السجل الطبي؟ لا يمكن التراجع عن هذا الإجراء.',
  'records.confirmDelete': 'حذف السجل الطبي؟',
  'records.deleteWarning': 'هل أنت متأكد من رغبتك في حذف هذا السجل الطبي؟ لا يمكن التراجع عن هذا الإجراء.',
  'records.loading': 'جاري تحميل السجل الطبي...',
  'records.clinicalAssessment': 'التقييم السريري',
  'records.viewProfile': 'عرض الملف',
  'records.clinicalSummary': 'الملخص السريري',
  'records.visitDate': 'تاريخ الزيارة',
  'records.historyPresentIllness': 'تاريخ المرض الحالي',
  'records.pastMedicalHistory': 'التاريخ الطبي السابق',
  'records.allergies': 'الحساسية',
  'records.familyHistory': 'التاريخ العائلي',
  'records.socialHistory': 'التاريخ الاجتماعي',
  'records.reviewOfSystems': 'مراجعة الأجهزة',
  'records.physicalExamination': 'الفحص البدني',
  'records.subjective': 'الذاتي',
  'records.objective': 'الموضوعي',
  'records.assessment': 'التقييم',
  'records.plan': 'الخطة',
  'records.diagnoses': 'التشخيصات',
  'records.code': 'الرمز',
  'records.drugInteractionCheck': 'فحص التفاعلات الدوائية',
  'records.vitalSignsAnalysis': 'تحليل العلامات الحيوية',
  'records.bmi': 'مؤشر كتلة الجسم',
  'records.soapNote': 'ملاحظة SOAP',
  'records.additionalHistory': 'التاريخ الإضافي',
  'records.showAdditionalHistory': 'عرض التاريخ الإضافي',
  'records.notRecorded': 'غير مسجل',
  'records.signRecord': 'توقيع السجل',
  'records.signing': 'جاري التوقيع...',
  'records.status.draft': 'مسودة',
  'records.status.signed': 'موقّع',
  'records.status.final': 'نهائي',
  'records.provider': 'مقدم الخدمة',
  'records.chiefComplaint': 'الشكوى الرئيسية',

  // Schedule
  'schedule.title': 'الجدول',
  'schedule.subtitle': 'إدارة المواعيد والتقويم',
  'schedule.newAppointment': 'موعد جديد',
  'schedule.addAppointment': 'إضافة موعد',
  'schedule.appointmentsTitle': 'الجدول والمواعيد',
  'schedule.today': 'اليوم',
  'schedule.day': 'يوم',
  'schedule.week': 'أسبوع',
  'schedule.month': 'شهر',
  'schedule.noAppointments': 'لا توجد مواعيد',
  'schedule.more': 'المزيد',
  'schedule.scheduled': 'مجدول',
  'schedule.completed': 'مكتمل',
  'schedule.cancelled': 'ملغي',
  'schedule.todaysAppointments': 'مواعيد اليوم',
  'schedule.new': 'جديد',
  'schedule.weekOf': 'أسبوع {{date}}',
  'schedule.selectLimit': 'اختر الحد',
  'schedule.perDay': '{{count}} في اليوم',
  'schedule.showAll': 'عرض الكل',
  'schedule.moreAppointments': '+{{count}} موعد إضافي',
  'schedule.showLess': 'عرض أقل',
  'schedule.scheduleAnalytics': 'تحليلات الجدول',
  'schedule.generateReport': 'إنشاء تقرير الجدول',
  'schedule.startClinicalNote': 'بدء الملاحظة السريرية',
  'schedule.changeStatus': 'تغيير الحالة',
  'schedule.failedToLoad': 'فشل تحميل المواعيد',
  'schedule.unknownPatient': 'مريض غير معروف',
  'schedule.eyebrow': 'التقويم',
  'schedule.viewLabel': 'العرض',
  'schedule.emptyTitle': 'لا مواعيد اليوم',
  'schedule.emptyBody': 'لا مواعيد لهذا اليوم. اضغط "جديد" لإضافة زيارة.',
  'schedule.emptyMonth': 'لا زيارات في هذا اليوم',
  'schedule.appointmentsCount': '{{count}} مواعيد',
  'schedule.appointmentSingular': 'موعد واحد',
  'schedule.appointmentsZero': 'لا مواعيد',

  // Provider Availability
  'availability.title': 'توفر مقدمي الخدمة',
  'availability.subtitle': 'إدارة جداول مقدمي الخدمة وساعات العمل خلال الأسبوع',
  'availability.addAvailability': 'إضافة توفر',
  'availability.editAvailability': 'تعديل التوفر',
  'availability.updateSchedule': 'تحديث جدول مقدم الخدمة',
  'availability.setWorkingHours': 'تعيين ساعات عمل مقدم الخدمة',
  'availability.today': 'اليوم',
  'availability.showWeek': 'عرض الأسبوع',
  'availability.show3Days': 'عرض 3 أيام',
  'availability.searchProviders': 'البحث عن مقدمي الخدمة...',
  'availability.allDepartments': 'جميع الأقسام',
  'availability.provider': 'مقدم الخدمة',
  'availability.addAvailabilitySlot': 'إضافة توفر',
  'availability.oneTime': 'لمرة واحدة',
  'availability.noProvidersFound': 'لم يتم العثور على مقدمي خدمة',
  'availability.adjustFilters': 'حاول تعديل البحث أو التصفية للعثور على مقدمي الخدمة',
  'availability.selectProvider': 'اختر مقدم الخدمة',
  'availability.dayOfWeek': 'يوم الأسبوع',
  'availability.startTime': 'وقت البدء',
  'availability.endTime': 'وقت الانتهاء',
  'availability.recurring': 'متكرر (يتكرر أسبوعياً)',
  'availability.effectiveFrom': 'ساري من',
  'availability.effectiveTo': 'ساري حتى',
  'availability.oneTimeDate': 'التاريخ',
  'availability.oneTimeDateHint': 'يسري هذا التوفر على التاريخ المحدد فقط.',
  'availability.dateRequired': 'اختر تاريخاً لهذا التوفر لمرة واحدة.',
  'availability.notes': 'ملاحظات (اختياري)',
  'availability.addNotes': 'إضافة أي ملاحظات...',
  'availability.cancel': 'إلغاء',
  'availability.create': 'إنشاء',
  'availability.update': 'تحديث',
  'availability.saving': 'جاري الحفظ...',
  'availability.deleteTitle': 'حذف التوفر',
  'availability.deleteMessage': 'هل أنت متأكد من حذف هذا التوفر؟ لا يمكن التراجع عن هذا الإجراء.',
  'availability.delete': 'حذف',
  'availability.failedToLoad': 'فشل تحميل توفر مقدمي الخدمة',
  'availability.moduleRequired': 'مطلوب وحدة الجدولة لإدارة توفر مقدمي الخدمة.',
  'availability.monday': 'الإثنين',
  'availability.tuesday': 'الثلاثاء',
  'availability.wednesday': 'الأربعاء',
  'availability.thursday': 'الخميس',
  'availability.friday': 'الجمعة',
  'availability.saturday': 'السبت',
  'availability.sunday': 'الأحد',

  // Appointments
  'appointments.title': 'المواعيد',
  'appointments.addAppointment': 'إضافة موعد',
  'appointments.editAppointment': 'تعديل الموعد',
  'appointments.saveAppointment': 'حفظ الموعد',
  'appointments.patient': 'المريض',
  'appointments.provider': 'مقدم الخدمة',
  'appointments.selectProvider': 'اختر مقدم الخدمة',
  'appointments.selectPatient': 'اختر المريض',
  'appointments.searchPatient': 'ابحث بالاسم أو رقم الهاتف…',
  'appointments.searchPatientHint': 'اكتب حرفين على الأقل للبحث.',
  'appointments.noPatientMatches': 'لا يوجد مرضى مطابقون',
  'appointments.date': 'التاريخ',
  'appointments.time': 'الوقت',
  'appointments.duration': 'المدة',
  'appointments.reason': 'سبب الزيارة',
  'appointments.reasonPlaceholder': 'مثل: فحص دوري، استشارة متابعة...',
  'appointments.notes': 'ملاحظات إضافية',
  'appointments.notesPlaceholder': 'أي تعليمات خاصة أو ملاحظات...',
  'appointments.confirmationTitle': 'تأكيد الموعد',
  'appointments.confirmationMessage': 'سيتلقى المريض رسالة بريد إلكتروني لتأكيد تفاصيل الموعد.',
  'appointments.availabilityOutsideWindow': 'هذا الوقت خارج ساعات توفر {{provider}} في هذا اليوم.',
  'appointments.availabilityNoneForDay': 'لا يوجد توفر محدد لـ {{provider}} في هذا اليوم.',
  'appointments.availabilityWithinWindow': 'ضمن ساعات توفر {{provider}}.',
  'appointments.availabilityWarningHint': 'لا يزال بإمكانك الحجز — هذا تنبيه فقط.',
  'appointments.validation.requiredFields': 'يرجى ملء جميع الحقول المطلوبة',
  'appointments.validation.patientRequired': 'يرجى اختيار المريض',
  'appointments.validation.dateRequired': 'التاريخ مطلوب',
  'appointments.validation.timeRequired': 'الوقت مطلوب',
  'appointments.validation.reasonRequired': 'سبب الزيارة مطلوب',

  // Appointment Form (legacy - keeping for compatibility)
  'appointment.patient': 'المريض',
  'appointment.date': 'التاريخ',
  'appointment.time': 'الوقت',
  'appointment.duration': 'المدة',
  'appointment.reason': 'سبب الزيارة',
  'appointment.arabicReason': 'سبب الزيارة (بالعربية)',
  'appointment.notes': 'ملاحظات إضافية',
  'appointment.arabicNotes': 'ملاحظات إضافية (بالعربية)',
  'appointment.minutes': 'دقيقة',
  'appointment.hour': 'ساعة',
  'appointment.hours': 'ساعات',
  'appointment.appointment': 'الموعد',
  'appointment.appointmentDetails': 'تفاصيل الموعد',
  'appointment.appointmentId': 'رقم الموعد',
  'appointment.appointmentInformation': 'معلومات الموعد',
  'appointment.status': 'الحالة',
  'appointment.contact': 'معلومات الاتصال',
  'appointment.patientInformation': 'معلومات المريض',
  'appointment.createRecord': 'إنشاء سجل طبي',
  'appointment.documentVisit': 'توثيق هذه الزيارة',
  'appointment.reschedule': 'إعادة الجدولة',
  'appointment.changeDateOrTime': 'تغيير التاريخ أو الوقت',
  'appointment.sendReminder': 'إرسال تذكير',
  'appointment.emailConfirmation': 'تأكيد بالبريد الإلكتروني',
  'appointment.deleteConfirmTitle': 'حذف الموعد؟',
  'appointment.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف هذا الموعد؟ لا يمكن التراجع عن هذا الإجراء.',
  'appointment.notFound': 'لم يتم العثور على الموعد',
  'appointment.provider': 'الطبيب المعالج',
  'appointment.clinicalDocumentation': 'التوثيق السريري',
  'appointment.startVoiceNote': 'ابدأ تدوين ملاحظة سريرية صوتية لهذا الموعد',
  'appointment.startNote': 'ابدأ الملاحظة',
  'appointment.addAnotherNote': 'إضافة ملاحظة أخرى',
  'appointment.linkedRecords': 'السجلات المرتبطة',
  'appointment.loadingRecords': 'جاري تحميل السجلات الطبية...',
  'appointment.noChiefComplaint': 'لا يوجد شكوى رئيسية',
  'appointment.reminderSent': 'تم إرسال التذكير بنجاح',
  'appointment.reminderFailed': 'فشل إرسال التذكير',
  'appointment.whatsAppReminder': 'تذكير واتساب',
  'appointment.sendWhatsAppReminder': 'إرسال تذكير الموعد عبر واتساب',
  'appointment.type': 'النوع',

  // Settings
  'settings.language': 'اللغة',
  'settings.hospital': 'إعدادات المستشفى',
  'settings.hospitalTagline': 'شعار المستشفى',
  'settings.aiProvider': 'مزود الذكاء الاصطناعي',

  // Hospital & Bed Management
  'hospital.bedManagement.title': 'إدارة الأسرة',
  'hospital.bedManagement.subtitle': 'إدارة حالة الأسرة والطاقة الاستيعابية في الوقت الفعلي',
  'hospital.bedManagement.totalBeds': 'إجمالي الأسرة',
  'hospital.bedManagement.availableBeds': 'الأسرة المتاحة',
  'hospital.bedManagement.occupiedBeds': 'الأسرة المشغولة',
  'hospital.bedManagement.occupancyRate': 'معدل الإشغال',
  'hospital.bedManagement.needsCleaning': 'يحتاج تنظيف',
  'hospital.bedManagement.blockedBeds': 'الأسرة المحجوبة',
  'hospital.bedManagement.isolation': 'عزل',
  'hospital.bedManagement.realTimeOn': 'الوقت الفعلي مفعل',
  'hospital.bedManagement.realTimeOff': 'الوقت الفعلي معطل',
  'hospital.bedManagement.refresh': 'تحديث',
  'hospital.bedManagement.searchPlaceholder': 'البحث في الأسرة أو الوحدات...',
  'hospital.bedManagement.allFloors': 'جميع الطوابق',
  'hospital.bedManagement.floor': 'الطابق',
  'hospital.bedManagement.availableOnly': 'المتاحة فقط',
  'hospital.bedManagement.occupiedOnly': 'المشغولة فقط',
  'hospital.bedManagement.filters': 'المرشحات',
  'hospital.bedManagement.clearAll': 'مسح الكل',
  'hospital.bedManagement.assign': 'تخصيص',
  'hospital.bedManagement.discharge': 'خروج',
  'hospital.bedManagement.block': 'حجب',
  'hospital.bedManagement.edit': 'تحرير',
  'hospital.bedManagement.lastUpdated': 'آخر تحديث',
  'hospital.bedManagement.noBedsFound': 'لم يتم العثور على أسرة',
  'hospital.bedManagement.adjustFilters': 'جرب تعديل مرشحاتك أو معايير البحث',

  // Bed Status
  'hospital.bedStatus.occupied': 'مشغول',
  'hospital.bedStatus.available': 'متاح',
  'hospital.bedStatus.dirty': 'يحتاج تنظيف',
  'hospital.bedStatus.housekeeping': 'تدبير منزلي',
  'hospital.bedStatus.maintenance': 'صيانة',
  'hospital.bedStatus.blocked': 'محجوب',
  'hospital.bedStatus.isolation': 'عزل',

  // Bed Equipment
  'hospital.bedEquipment.oxygen': 'أكسجين',
  'hospital.bedEquipment.monitoring': 'مراقبة',
  'hospital.bedEquipment.ventilator': 'جهاز تنفس',
  'hospital.bedEquipment.telemetry': 'القياس عن بعد',
  'settings.appearance': 'المظهر',
  'settings.darkMode': 'الوضع الليلي',
  'settings.lightMode': 'الوضع النهاري',
  'settings.systemDefault': 'إفتراضي النظام',
  'settings.colorScheme': 'نظام الألوان',
  'settings.preview': 'معاينة',
  'settings.resetDefaults': 'إعادة تعيين الافتراضيات',

  // AI Assistant
  'ai.title': 'المساعد الطبي الذكي',
  'ai.subtitle': 'مدعوم بـ {{aiProvider}}',
  'ai.addContext': 'إضافة سياق الصفحة الكاملة',
  'ai.clearContext': 'مسح الكل',
  'ai.listening': 'جاري الاستماع...',
  'ai.stopListening': 'إيقاف الاستماع',
  'ai.voiceInput': 'إدخال صوتي',
  'ai.placeholder': 'اسأل عن التشخيص أو العلاج أو الإرشادات السريرية...',
  'ai.differentialDiagnosis': 'التشخيص التفريقي',
  'ai.medicationReview': 'مراجعة الأدوية',
  'ai.clinicalSummary': 'الملخص السريري',
  'ai.riskAssessment': 'تقييم المخاطر',
  'ai.followUpPlan': 'خطة المتابعة',
  'ai.treatmentOptions': 'خيارات العلاج',
  'ai.readyToAssist': 'جاهز للمساعدة',
  'ai.assistDescription': 'يمكنني المساعدة في دعم القرارات السريرية والتوثيق الطبي والتشخيص التفريقي وتخطيط العلاج.',
  'ai.quickActions': 'إجراءات سريرية سريعة',
  'ai.chat': 'محادثة',
  'ai.visitRecording': 'تسجيل الزيارة',

  // Lab Orders
  // 'nav.labOrders': 'طلبات المختبر', // DUPLICATE REMOVED
  'labOrders.title': 'طلبات المختبر',
  'labOrders.subtitle': 'إدارة طلبات المختبر والنتائج',
  'labOrders.newOrder': 'طلب مختبر جديد',
  'labOrders.newOrderDescription': 'إنشاء طلب مختبر جديد للمريض',
  'labOrders.searchPlaceholder': 'بحث في طلبات المختبر...',
  'labOrders.allStatuses': 'جميع الحالات',
  'labOrders.allPriorities': 'جميع الأولويات',
  'labOrders.allCategories': 'جميع الفئات',
  'labOrders.draft': 'مسودة',
  'labOrders.ordered': 'مطلوب',
  'labOrders.specimenCollected': 'تم جمع العينة',
  'labOrders.inProgress': 'قيد التنفيذ',
  'labOrders.resulted': 'النتائج جاهزة',
  'labOrders.cancelled': 'ملغي',
  'labOrders.routine': 'روتيني',
  'labOrders.urgent': 'عاجل',
  'labOrders.stat': 'طارئ',
  'labOrders.totalOrders': 'إجمالي الطلبات',
  'labOrders.pendingCollection': 'في انتظار الجمع',
  'labOrders.completed': 'مكتمل',
  'labOrders.noResults': 'لم يتم العثور على طلبات مختبر',
  'labOrders.adjustSearch': 'حاول تعديل البحث أو الفلاتر',
  'labOrders.moreTests': 'اختبارات أخرى',
  'labOrders.orderDetails': 'تفاصيل طلب المختبر',
  'labOrders.orderId': 'رقم الطلب',
  'labOrders.labOrder': 'طلب المختبر',
  'labOrders.orderInformation': 'معلومات الطلب',
  'labOrders.status': 'الحالة',
  'labOrders.orderDate': 'تاريخ الطلب',
  'labOrders.priority': 'الأولوية',
  'labOrders.requiredBy': 'مطلوب بحلول',
  'labOrders.orderedBy': 'طلب بواسطة',
  'labOrders.clinicalInformation': 'المعلومات السريرية',
  'labOrders.clinicalInfo': 'المعلومات السريرية',
  'labOrders.provisionalDiagnosis': 'التشخيص المؤقت',
  'labOrders.orderedTests': 'الاختبارات المطلوبة',
  'labOrders.category': 'الفئة',
  'labOrders.specimen': 'العينة',
  'labOrders.result': 'النتيجة',
  'labOrders.enterResult': 'إدخال النتيجة',
  'labOrders.editResults': 'تعديل النتائج',
  'labOrders.enterResults': 'تعديل',
  'labOrders.patientInformation': 'معلومات المريض',
  'labOrders.deleteConfirmTitle': 'حذف طلب المختبر؟',
  'labOrders.deleteConfirmMessage': 'هل أنت متأكد من رغبتك في حذف طلب المختبر هذا؟ لا يمكن التراجع عن هذا الإجراء.',
  'labOrders.notFound': 'طلب المختبر غير موجود',
  'labOrders.patient': 'المريض',
  'labOrders.selectPatient': 'اختر المريض',
  'labOrders.selectTests': 'اختر الاختبارات',
  'labOrders.searchTests': 'بحث في الاختبارات...',
  'labOrders.selectedTests': 'الاختبارات المختارة',
  'labOrders.common': 'شائع',
  'labOrders.turnaround': 'وقت الإنجاز',
  'labOrders.clinicalInfoPlaceholder': 'أدخل المعلومات السريرية أو الأعراض أو التاريخ الطبي ذي الصلة',
  'labOrders.diagnosisPlaceholder': 'أدخل التشخيص المؤقت',
  'labOrders.specialInstructions': 'تعليمات خاصة',
  'labOrders.instructionsPlaceholder': 'أدخل أي تعليمات خاصة للمختبر',
  'labOrders.orderSummary': 'ملخص الطلب',
  'labOrders.totalTests': 'إجمالي الاختبارات',
  'labOrders.testsByCategory': 'الاختبارات حسب الفئة',
  'labOrders.orderNote': 'سيتم إرسال الطلب إلى المختبر بمجرد تقديمه',
  'labOrders.submitOrder': 'تقديم الطلب',
  'labOrders.errors.selectPatient': 'الرجاء اختيار مريض',
  'labOrders.errors.selectTests': 'الرجاء اختيار اختبار واحد على الأقل',
  'labOrders.errors.clinicalInfoRequired': 'المعلومات السريرية مطلوبة',
  'labOrders.hematology': 'أمراض الدم',
  'labOrders.chemistry': 'الكيمياء',
  'labOrders.microbiology': 'الأحياء الدقيقة',
  'labOrders.immunology': 'المناعة',
  'labOrders.pathology': 'علم الأمراض',
  'labOrders.radiology': 'الأشعة',
  'labOrders.blood': 'دم',
  'labOrders.urine': 'بول',
  'labOrders.swab': 'مسحة',
  'labOrders.stool': 'براز',
  'labOrders.sputum': 'بلغم',
  'labOrders.tissue': 'نسيج',
  'labOrders.fluid': 'سائل',
  'labOrders.normal': 'طبيعي',
  'labOrders.abnormal-high': 'مرتفع',
  'labOrders.abnormal-low': 'منخفض',
  'labOrders.critical': 'حرج',
  'common.print': 'طباعة',
  'common.download': 'تحميل',
  'common.contact': 'اتصال',
  'common.by': 'بواسطة',
  'common.copy': 'نسخ',

  // Lab Order Workflow
  'labOrders.timeline': 'الجدول الزمني',
  'labOrders.specimens': 'العينات',
  'labOrders.specimenTracking': 'تتبع العينات',
  'labOrders.addSpecimen': 'إضافة عينة',
  'labOrders.noSpecimens': 'لم يتم جمع عينات بعد',
  'labOrders.specimenType': 'النوع',
  'labOrders.collectedAt': 'تم الجمع',
  'labOrders.collectedBy': 'جمعت بواسطة',
  'labOrders.notes': 'ملاحظات',
  'labOrders.printLabel': 'طباعة الملصق',
  'labOrders.showQR': 'عرض QR',
  'labOrders.updateStatus': 'تحديث الحالة',
  'labOrders.specimen.collected': 'تم الجمع',
  'labOrders.specimen.in-transit': 'في الطريق',
  'labOrders.specimen.received': 'تم الاستلام',
  'labOrders.specimen.processing': 'قيد المعالجة',
  'labOrders.specimen.stored': 'مخزنة',
  'labOrders.specimen.discarded': 'تم التخلص منها',
  'labOrders.barcode': 'رمز العينة',
  'labOrders.barcodePlaceholder': 'أدخل رمز العينة',
  'labOrders.selectSpecimenType': 'اختر نوع العينة',
  'labOrders.collectionDateTime': 'تاريخ ووقت الجمع',
  'labOrders.collectedByPlaceholder': 'اسم من جمع العينة',
  'labOrders.location': 'موقع التخزين',
  'labOrders.locationPlaceholder': 'مثل: ثلاجة المختبر A-1',
  'labOrders.temperature': 'درجة حرارة التخزين',
  'labOrders.temperaturePlaceholder': 'مثل: 4°م أو درجة حرارة الغرفة',
  'labOrders.errors.barcodeRequired': 'رمز العينة مطلوب',
  'labOrders.errors.specimenTypeRequired': 'نوع العينة مطلوب',
  'labOrders.errors.collectedByRequired': 'اسم من جمع العينة مطلوب',
  'labOrders.printRequisition': 'طباعة طلب المختبر',

  // Lab Order Events
  'labOrders.workflow.created': 'تم الإنشاء',
  'labOrders.workflow.ordered': 'تم الطلب',
  'labOrders.workflow.specimenCollected': 'تم جمع العينة',
  'labOrders.workflow.specimenReceived': 'تم استلام العينة',
  'labOrders.workflow.processingStarted': 'بدأت المعالجة',
  'labOrders.workflow.resultEntered': 'تم إدخال النتيجة',
  'labOrders.workflow.resultVerified': 'تم التحقق من النتيجة',
  'labOrders.workflow.reviewed': 'تمت المراجعة',
  'labOrders.events.created': 'تم إنشاء الطلب',
  'labOrders.events.ordered': 'تم تقديم الطلب',
  'labOrders.events.specimenCollected': 'تم جمع العينة',
  'labOrders.events.specimenReceived': 'تم استلام العينة في المختبر',
  'labOrders.events.processingStarted': 'بدأت المعالجة',
  'labOrders.events.resultEntered': 'تم إدخال النتائج',
  'labOrders.events.resultVerified': 'تم التحقق من النتائج',
  'labOrders.events.reportGenerated': 'تم إنشاء التقرير',
  'labOrders.events.reviewed': 'تمت مراجعة الطلب',
  'labOrders.events.amended': 'تم تعديل الطلب',
  'labOrders.events.cancelled': 'تم إلغاء الطلب',

  // Lab Result Entry
  'labOrders.resultValue': 'قيمة النتيجة',
  'labOrders.enterValue': 'أدخل قيمة النتيجة',
  'labOrders.referenceRange': 'النطاق المرجعي',
  'labOrders.referenceRangePlaceholder': 'مثال: 4.5-11.0',
  'labOrders.criticalValueAlert': 'تنبيه القيمة الحرجة',
  'labOrders.criticalRanges': 'النطاقات الحرجة',
  'labOrders.criticalLow': 'حرج منخفض',
  'labOrders.criticalHigh': 'حرج مرتفع',
  'labOrders.resultNotes': 'ملاحظات النتيجة',
  'labOrders.resultNotesPlaceholder': 'أضف أي ملاحظات حول هذه النتيجة...',
  'labOrders.testInformation': 'معلومات الاختبار',
  'labOrders.specimenNotes': 'ملاحظات العينة',
  'labOrders.saveResult': 'حفظ النتيجة',
  'labOrders.errors.resultRequired': 'قيمة النتيجة مطلوبة',
  'labOrders.reviewed': 'تمت المراجعة',

  // Medical Record Form
  'records.visitTypes.routineCheckup': 'فحص روتيني',
  'records.visitTypes.followUp': 'زيارة متابعة',
  'records.visitTypes.sickVisit': 'زيارة مرضية',
  'records.visitTypes.physicalExam': 'فحص بدني',
  'records.visitTypes.consultation': 'استشارة',
  'records.visitTypes.emergency': 'زيارة طوارئ',
  'records.visitTypes.specialistReferral': 'إحالة لأخصائي',
  'records.visitTypes.labReview': 'مراجعة نتائج المختبر',
  'records.visitTypes.vaccination': 'تطعيم',
  'records.visitTypes.procedure': 'إجراء طبي',
  'records.patientVisitInfo': 'معلومات المريض والزيارة',
  'records.clinicalFindings': 'النتائج السريرية',
  // 'records.vitalSigns': 'العلامات الحيوية', // DUPLICATE REMOVED
  'records.assessmentPlan': 'التقييم والخطة',
  // 'records.saveRecord': 'حفظ السجل', // DUPLICATE REMOVED
  'records.updateRecord': 'تحديث السجل',
  // 'records.chiefComplaint' — DUPLICATE REMOVED (defined earlier in this file)
  'records.chiefComplaintPlaceholder': 'السبب الرئيسي للزيارة...',
  'records.symptoms': 'الأعراض',
  'records.symptomsPlaceholder': 'وصف تفصيلي للأعراض...',
  // 'records.diagnosisPlaceholder': 'التشخيص السريري...', // DUPLICATE REMOVED
  // 'records.treatmentPlaceholder': 'خطة العلاج والإجراءات...', // DUPLICATE REMOVED
  'records.medicationsPlaceholder': 'الأدوية والجرعات والتعليمات...',
  'records.followUpPlaceholder': 'تعليمات المتابعة...',
  // 'records.notesPlaceholder': 'أي ملاحظات إضافية...', // DUPLICATE REMOVED
  'records.visitType': 'نوع الزيارة',
  'records.selectVisitType': 'اختر نوع الزيارة',
  // 'records.patient': 'المريض', // DUPLICATE REMOVED
  // 'records.selectPatient': 'اختر المريض', // DUPLICATE REMOVED

  // Appointment Form
  'appointment.reasons.generalConsultation': 'استشارة عامة',
  'appointment.reasons.followUp': 'متابعة',
  'appointment.reasons.physicalExam': 'فحص بدني',
  'appointment.reasons.vaccination': 'تطعيم',
  'appointment.reasons.labReview': 'مراجعة نتائج المختبر',
  'appointment.reasons.specialistReferral': 'إحالة لأخصائي',
  'appointment.reasons.emergency': 'طوارئ',
  'appointment.reasons.telemedicine': 'طب عن بعد',
  'appointment.notesPlaceholder': 'أي ملاحظات إضافية أو تعليمات خاصة...',
  'appointment.updateAppointment': 'تحديث الموعد',
  'appointment.scheduleAppointment': 'جدولة الموعد',
  'appointment.selectPatient': 'اختر المريض',
  'appointment.selectReason': 'اختر السبب',

  // Patient Form
  'patient.allergiesPlaceholder': 'اذكر أي حساسية معروفة (مثل البنسلين، المأكولات البحرية)...',
  'patient.medicationsPlaceholder': 'اذكر الأدوية الحالية مع الجرعات...',
  'patient.emergencyContactPlaceholder': 'اسم جهة الاتصال للطوارئ',
  'patient.emergencyPhonePlaceholder': 'هاتف الطوارئ',
  'patient.savePatient': 'حفظ المريض',
  'patient.updatePatient': 'تحديث المريض',
  'patient.selectGender': 'اختر الجنس',
  'patient.selectBloodType': 'اختر فصيلة الدم',
  'patient.namePlaceholder': 'محمد أحمد',
  'patient.emailPlaceholder': 'example@email.com',
  'patient.phonePlaceholder': '+(966) 500-000-000',
  'patient.addressPlaceholder': 'شارع الملك عبدالله، الرياض 12345',

  // Patient validation messages
  'patients.validation.nameRequired': 'الاسم مطلوب',
  'patients.validation.emailRequired': 'البريد الإلكتروني مطلوب',
  'patients.validation.emailInvalid': 'عنوان بريد إلكتروني غير صالح',
  'patients.validation.phoneRequired': 'رقم الهاتف مطلوب',
  'patients.validation.dateOfBirthRequired': 'تاريخ الميلاد مطلوب',

  // Common placeholders
  'common.currentUser': 'المستخدم الحالي',
  'common.labTech': 'فني المختبر',
  'common.labSystem': 'نظام المختبر',
  'common.patient': 'المريض',
  'common.nurse': 'الممرض',
  'common.doctor': 'الطبيب',
  'common.poweredByMAIE': 'مدعوم بواسطة {{aiProvider}}',

  // ADT Module
  'adt.title': 'القبول والخروج والنقل',
  'adt.subtitle': 'إدارة قبول المرضى وخروجهم ونقلهم',

  // ADT Tabs
  'adt.tabs.overview': 'نظرة عامة',
  'adt.tabs.admissions': 'القبول',
  'adt.tabs.discharges': 'الخروج',
  'adt.tabs.transfers': 'النقل',
  'adt.tabs.beds': 'إدارة الأسرّة',

  // ADT Overview
  'adt.overview.currentOccupancy': 'الإشغال الحالي',
  'adt.overview.bedUtilization': 'استخدام الأسرّة',
  'adt.overview.todaysAdmissions': 'قبولات اليوم',
  'adt.overview.avgLengthOfStay': 'متوسط مدة الإقامة',
  'adt.overview.days': 'أيام',
  'adt.overview.wardOccupancy': 'إشغال الأقسام',
  'adt.overview.recentAdmissions': 'القبولات الأخيرة',
  'adt.overview.pendingActions': 'الإجراءات المعلقة',
  'adt.overview.pendingDischarges': '{{count}} مريض جاهز للخروج',
  'adt.overview.scheduledTransfers': '{{count}} نقل مجدول',

  // ADT Filter & Search
  'adt.filter.all': 'الكل',
  'adt.filter.active': 'نشط',
  'adt.filter.pending': 'معلق',
  'adt.admissions.searchPlaceholder': 'البحث باسم المريض أو الرقم...',

  // ADT Status
  'adt.status.pending': 'معلق',
  'adt.status.active': 'نشط',
  'adt.status.discharged': 'تم الخروج',
  'adt.status.transferred': 'تم النقل',

  // ADT Actions
  'adt.actions.discharge': 'خروج',
  'adt.actions.transfer': 'نقل',

  // Admission
  'adt.admissions.newAdmission': 'قبول جديد',
  'adt.admissions.patient': 'المريض',
  'adt.admissions.admissionDate': 'تاريخ القبول',
  'adt.admissions.type': 'النوع',
  'adt.admissions.location': 'الموقع',
  'adt.admissions.status': 'الحالة',
  'adt.admission.patientInformation': 'معلومات المريض',
  'adt.admission.patient': 'المريض',
  'adt.admission.selectPatient': 'اختر المريض',
  'adt.admission.date': 'تاريخ القبول',
  'adt.admission.time': 'وقت القبول',
  'adt.admission.admittingPhysician': 'الطبيب المسؤول عن القبول',
  'adt.admission.physicianPlaceholder': 'أدخل اسم الطبيب',
  'adt.admission.admissionType': 'نوع القبول',
  'adt.admission.types.emergency': 'طوارئ',
  'adt.admission.types.elective': 'اختياري',
  'adt.admission.types.transfer': 'نقل',
  'adt.admission.chiefComplaint': 'الشكوى الرئيسية',
  'adt.admission.chiefComplaintPlaceholder': 'السبب الرئيسي للقبول...',
  'adt.admission.provisionalDiagnosis': 'التشخيص المبدئي',
  'adt.admission.diagnosisPlaceholder': 'التشخيص الأولي إن وجد...',
  'adt.admission.bedAssignment': 'تخصيص السرير',
  'adt.admission.ward': 'القسم',
  'adt.admission.selectWard': 'اختر القسم',
  'adt.admission.room': 'الغرفة',
  'adt.admission.selectRoom': 'اختر الغرفة',
  'adt.admission.bed': 'السرير',
  'adt.admission.bedsAvailable': 'أسرّة متاحة',
  'adt.admission.selectedBed': 'السرير المحدد',
  'adt.admission.completeAdmission': 'إتمام القبول',

  // Ward Types
  'adt.ward.types.icu': 'العناية المركزة',
  'adt.ward.types.general': 'عام',
  'adt.ward.types.emergency': 'الطوارئ',
  'adt.ward.types.pediatric': 'الأطفال',
  'adt.ward.types.maternity': 'الولادة',
  'adt.ward.types.surgical': 'الجراحة',

  // Room Types
  'adt.room.types.private': 'خاص',
  'adt.room.types.semi_private': 'شبه خاص',
  'adt.room.types.ward': 'عنبر',

  // Departments
  'adt.departments.nursing': 'التمريض',
  'adt.departments.dietary': 'التغذية',
  'adt.departments.housekeeping': 'الخدمات',
  'adt.departments.pharmacy': 'الصيدلية',
  'adt.departments.lab': 'المختبر',

  // Discharge
  'adt.discharges.patient': 'المريض',
  'adt.discharges.dischargeDate': 'تاريخ الخروج',
  'adt.discharges.type': 'النوع',
  'adt.discharges.status': 'الحالة',
  'adt.discharge.dischargeSummary': 'ملخص الخروج',
  'adt.discharge.date': 'تاريخ الخروج',
  'adt.discharge.time': 'وقت الخروج',
  'adt.discharge.types.home': 'المنزل',
  'adt.discharge.types.transfer': 'نقل',
  'adt.discharge.types.ama': 'خروج ضد النصيحة الطبية',
  'adt.discharge.types.expired': 'وفاة',
  'adt.discharge.types.other': 'أخرى',
  'adt.discharge.completeDischarge': 'إتمام الخروج',

  // Transfer
  'adt.transfers.patient': 'المريض',
  'adt.transfers.type': 'النوع',
  'adt.transfers.from': 'من',
  'adt.transfers.to': 'إلى',
  'adt.transfers.scheduledTime': 'الوقت المحدد',
  'adt.transfers.status': 'الحالة',
  'adt.transfer.types.inter_unit': 'نقل بين الأقسام',
  'adt.transfer.types.inter_facility': 'نقل بين المنشآت',
  'adt.transfer.reason': 'سبب النقل',
  'adt.transfer.completeTransfer': 'إتمام النقل',

  // Bed Management
  'adt.beds.occupied': 'مشغول',
  'adt.beds.room': 'غرفة',
  'adt.beds.status.available': 'متاح',
  'adt.beds.status.occupied': 'مشغول',
  'adt.beds.status.maintenance': 'صيانة',
  'adt.beds.status.cleaning': 'تنظيف',

  // CPOE (Computerized Physician Order Entry)
  'cpoe.title': 'إدارة الطلبات',
  'cpoe.subtitle': 'إدارة طلبات الأدوية والمختبرات والأشعة',
  'cpoe.indication': 'دواعي الاستخدام',
  'cpoe.dosage.amount': 'الجرعة',
  'cpoe.dosage.unit': 'الوحدة',
  'cpoe.route': 'طريقة الإعطاء',
  'cpoe.frequency': 'التكرار',
  'cpoe.prnReason': 'سبب الإعطاء عند الحاجة',
  'cpoe.startDate': 'تاريخ البدء',
  'cpoe.duration.label': 'المدة',
  'cpoe.duration.unit': 'وحدة المدة',
  'cpoe.priority': 'الأولوية',
  'cpoe.notes': 'ملاحظات',
  'cpoe.submitOrder': 'إرسال الطلب',
  'cpoe.orderDetails': 'تفاصيل الطلب',

  // CPOE Routes
  'cpoe.routes.oral': 'عن طريق الفم',
  'cpoe.routes.iv': 'وريدي',
  'cpoe.routes.im': 'عضلي',
  'cpoe.routes.sc': 'تحت الجلد',
  'cpoe.routes.sl': 'تحت اللسان',
  'cpoe.routes.topical': 'موضعي',
  'cpoe.routes.inhalation': 'استنشاق',
  'cpoe.routes.rectal': 'شرجي',

  // CPOE Frequencies
  'cpoe.frequencies.once': 'مرة واحدة',
  'cpoe.frequencies.bid': 'مرتين يومياً',
  'cpoe.frequencies.tid': 'ثلاث مرات يومياً',
  'cpoe.frequencies.qid': 'أربع مرات يومياً',
  'cpoe.frequencies.q4h': 'كل 4 ساعات',
  'cpoe.frequencies.q6h': 'كل 6 ساعات',
  'cpoe.frequencies.q8h': 'كل 8 ساعات',
  'cpoe.frequencies.q12h': 'كل 12 ساعة',
  'cpoe.frequencies.qhs': 'عند النوم',
  'cpoe.frequencies.prn': 'عند الحاجة',
  'cpoe.frequencies.ac': 'قبل الوجبات',
  'cpoe.frequencies.pc': 'بعد الوجبات',

  // CPOE Priorities
  'cpoe.priorities.routine': 'روتيني',
  'cpoe.priorities.urgent': 'عاجل',
  'cpoe.priorities.stat': 'فوري',

  // CPOE Medication
  'cpoe.medication.search': 'البحث عن دواء',
  'cpoe.medication.searchPlaceholder': 'ابحث عن اسم الدواء...',

  // CPOE Dosage Calculator
  'cpoe.dosageCalculator.title': 'حاسبة الجرعات',
  'cpoe.dosageCalculator.toggle': 'حساب الجرعة',
  'cpoe.dosageCalculator.patientWeight': 'وزن المريض',
  'cpoe.dosageCalculator.patientAge': 'عمر المريض',
  'cpoe.dosageCalculator.standard': 'جرعة قياسية',
  'cpoe.dosageCalculator.loading': 'جرعة التحميل',
  'cpoe.dosageCalculator.calculated': 'الجرعة المحسوبة',
  'cpoe.dosageCalculator.weightRequired': 'وزن المريض مطلوب لحساب الجرعة',

  // CPOE Clinical Alerts
  'cpoe.alerts.title': 'تنبيهات الدعم السريري',
  'cpoe.alerts.interaction': 'تفاعل دوائي',
  'cpoe.alerts.allergy': 'تنبيه حساسية',
  'cpoe.alerts.dosing': 'تنبيه الجرعة',
  'cpoe.alerts.recommendation': 'التوصية',
  'cpoe.alerts.reaction': 'رد الفعل',
  'cpoe.alerts.suggestedDose': 'الجرعة المقترحة',
  'cpoe.alerts.acknowledge': 'إقرار ومتابعة',

  // CPOE Order Status
  'cpoe.status.draft': 'مسودة',
  'cpoe.status.pending': 'معلق',
  'cpoe.status.active': 'نشط',
  'cpoe.status.on-hold': 'متوقف',
  'cpoe.status.discontinued': 'متوقف',
  'cpoe.status.completed': 'مكتمل',
  'cpoe.status.cancelled': 'ملغي',
  'cpoe.status.expired': 'منتهي',

  // CPOE Order Types
  'cpoe.orderType.medication': 'دواء',
  'cpoe.orderType.laboratory': 'مختبر',
  'cpoe.orderType.imaging': 'أشعة',
  'cpoe.orderType.procedure': 'إجراء',
  'cpoe.orderType.diet': 'حمية',
  'cpoe.orderType.activity': 'نشاط',
  'cpoe.orderType.nursing': 'تمريض',

  // CPOE Imaging
  'cpoe.imaging.modality': 'نوع الفحص',
  'cpoe.imaging.examType': 'نوع الفحص',
  'cpoe.imaging.anatomicalRegion': 'المنطقة التشريحية',
  'cpoe.imaging.contrast': 'يتطلب صبغة',
  'cpoe.imaging.sedation': 'يتطلب تخدير',
  'cpoe.imaging.transport': 'نوع النقل',
  'cpoe.imaging.isolation': 'يتطلب عزل',
  'cpoe.imaging.pregnancyStatus': 'حالة الحمل',
  'cpoe.imaging.safetyScreening': 'فحص السلامة',

  // CPOE Imaging Modalities
  'cpoe.imaging.modalities.xray': 'أشعة سينية',
  'cpoe.imaging.modalities.ct': 'أشعة مقطعية',
  'cpoe.imaging.modalities.mri': 'رنين مغناطيسي',
  'cpoe.imaging.modalities.ultrasound': 'موجات صوتية',
  'cpoe.imaging.modalities.nuclear': 'طب نووي',
  'cpoe.imaging.modalities.pet': 'مسح بوزيتروني',
  'cpoe.imaging.modalities.mammography': 'تصوير الثدي',
  'cpoe.imaging.modalities.fluoroscopy': 'تنظير تألقي',

  // CPOE Order Sets
  'cpoe.orderSets.title': 'مجموعات الطلبات',
  'cpoe.orderSets.admission': 'طلبات الدخول',
  'cpoe.orderSets.postOp': 'طلبات ما بعد العملية',
  'cpoe.orderSets.diseaseSpecific': 'خاصة بالمرض',
  'cpoe.orderSets.personal': 'مجموعات طلبات شخصية',
  'cpoe.orderSets.create': 'إنشاء مجموعة طلبات',
  'cpoe.orderSets.apply': 'تطبيق مجموعة طلبات',

  // Common Additions
  'common.notAvailable': 'غير متاح',

  // Authentication
  'auth.welcome': 'مرحباً بك في نظام {{hospitalName}} EMR',
  'auth.forgotPassword': 'نسيت كلمة المرور؟',

  // Authentication Errors
  'auth.errors.invalidCredentials': 'اسم المستخدم أو كلمة المرور غير صحيحة',
  'auth.errors.accountLocked': 'الحساب مقفل. يرجى الاتصال بالمدير.',
  'auth.errors.accountInactive': 'الحساب غير نشط. يرجى الاتصال بالمدير.',

  // User Management
  'users.title': 'إدارة المستخدمين',
  'users.subtitle': 'إدارة مستخدمي النظام والصلاحيات',
  'users.addUser': 'إضافة مستخدم',
  'users.editUser': 'تعديل مستخدم',
  'users.userDetails': 'تفاصيل المستخدم',
  'users.searchUsers': 'البحث عن المستخدمين...',
  'users.filterByRole': 'تصفية حسب الدور',
  'users.filterByDepartment': 'تصفية حسب القسم',
  'users.filterByStatus': 'تصفية حسب الحالة',
  'users.allRoles': 'جميع الأدوار',
  'users.allDepartments': 'جميع الأقسام',
  'users.allStatuses': 'جميع الحالات',

  // User Roles
  'roles.super_admin': 'مدير عام',
  'roles.admin': 'مدير',
  'roles.doctor': 'طبيب',
  'roles.nurse': 'ممرض',
  'roles.pharmacist': 'صيدلي',
  'roles.lab_tech': 'فني مختبر',
  'roles.radiologist': 'أخصائي أشعة',
  'roles.billing_staff': 'موظف فواتير',
  'roles.receptionist': 'موظف استقبال',
  'roles.security': 'أمن',
  'roles.it_support': 'دعم فني',
  'roles.department_head': 'رئيس قسم',
  'roles.case_manager': 'مدير حالة',
  'roles.social_worker': 'أخصائي اجتماعي',

  // User Status
  'userStatus.active': 'نشط',
  'userStatus.inactive': 'غير نشط',
  'userStatus.suspended': 'معلق',
  'userStatus.pending': 'في الانتظار',
  // Pharmacy Module
  'pharmacy.dashboard.title': 'لوحة تحكم الصيدلية',
  'pharmacy.dashboard.subtitle': 'إدارة والتحقق من طلبات الأدوية',
  'pharmacy.dashboard.newOrder': 'طلب جديد',
  'pharmacy.dashboard.searchOrders': 'البحث في الطلبات والمرضى والأدوية...',
  'pharmacy.dashboard.totalOrders': 'إجمالي الطلبات',
  'pharmacy.dashboard.pendingVerification': 'في انتظار التحقق',
  'pharmacy.dashboard.avgProcessingTime': 'متوسط وقت المعالجة',
  'pharmacy.dashboard.criticalInteractions': 'التفاعلات الحرجة',
  'pharmacy.dashboard.today': 'اليوم',
  'pharmacy.dashboard.requiresAction': 'يتطلب إجراء',
  'pharmacy.dashboard.improving': 'أسرع بنسبة 12%',
  'pharmacy.dashboard.needsAttention': 'يحتاج انتباه',

  // Pharmacy Orders
  'pharmacy.orders.title': 'طلبات الأدوية',
  'pharmacy.orders.patient': 'المريض',
  'pharmacy.orders.medication': 'الدواء',
  'pharmacy.orders.dose': 'الجرعة',
  'pharmacy.orders.priority': 'الأولوية',
  'pharmacy.orders.status': 'الحالة',
  'pharmacy.orders.orderDate': 'تاريخ الطلب',
  'pharmacy.orders.noOrders': 'لا توجد طلبات أدوية',
  'pharmacy.orders.noOrdersDescription': 'لا توجد طلبات أدوية تطابق المرشحات الحالية',

  // Pharmacy Status
  'pharmacy.status.pending': 'في الانتظار',
  'pharmacy.status.verified': 'تم التحقق',
  'pharmacy.status.dispensed': 'تم الصرف',
  'pharmacy.status.administered': 'تم الإعطاء',
  'pharmacy.status.discontinued': 'تم الإيقاف',
  'pharmacy.status.cancelled': 'تم الإلغاء',

  // Pharmacy Priority
  'pharmacy.priority.stat': 'عاجل جداً',
  'pharmacy.priority.urgent': 'عاجل',
  'pharmacy.priority.routine': 'عادي',

  // Pharmacy Actions
  'pharmacy.actions.verify': 'تحقق',
  'pharmacy.actions.dispense': 'صرف',
  'pharmacy.actions.cancel': 'إلغاء',

  // Pharmacy Filters
  'pharmacy.filters.allStatuses': 'جميع الحالات',
  'pharmacy.filters.allPriorities': 'جميع الأولويات',

  // Pharmacy Search
  'pharmacy.search.placeholder': 'البحث في الأدوية والمرضى ومقدمي الخدمة...',

  // Pharmacy Alerts
  'pharmacy.alerts.title': 'تنبيهات الصيدلية',
  'pharmacy.alerts.lowStock': 'أدوية أقل من نقطة إعادة الطلب',
  'pharmacy.alerts.expiring': 'أدوية ستنتهي صلاحيتها قريباً',

  // Pharmacy Metrics
  'pharmacy.metrics.dailyOrders': 'الطلبات اليومية',
  'pharmacy.metrics.pendingOrders': 'الطلبات المعلقة',
  'pharmacy.metrics.avgProcessingTime': 'متوسط وقت المعالجة',
  'pharmacy.metrics.productivity': 'الإنتاجية',

  // Medication Administration Record (MAR)
  'pharmacy.mar.title': 'سجل إعطاء الأدوية',
  'pharmacy.mar.subtitle': 'تتبع وتسجيل إعطاء الأدوية',
  'pharmacy.mar.medication': 'الدواء',
  'pharmacy.mar.dose': 'الجرعة',
  'pharmacy.mar.route': 'طريقة الإعطاء',
  'pharmacy.mar.frequency': 'التكرار',
  'pharmacy.mar.administrationTimes': 'أوقات الإعطاء',
  'pharmacy.mar.actions': 'الإجراءات',
  'pharmacy.mar.recordAdministration': 'تسجيل الإعطاء',
  'pharmacy.mar.viewDetails': 'عرض التفاصيل',
  'pharmacy.mar.noMedications': 'لا توجد أدوية مجدولة',
  'pharmacy.mar.noMedicationsDescription': 'لا توجد أدوية مجدولة لهذا المريض في التاريخ المحدد',
  'pharmacy.mar.administrationStatus': 'حالة الإعطاء',
  'pharmacy.mar.given': 'تم الإعطاء',
  'pharmacy.mar.notGiven': 'لم يتم الإعطاء',
  'pharmacy.mar.refused': 'رفض المريض',
  'pharmacy.mar.held': 'تم التوقف',
  'pharmacy.mar.partial': 'جزئي',
  'pharmacy.mar.reason': 'السبب',
  'pharmacy.mar.reasonPlaceholder': 'أدخل سبب عدم الإعطاء...',
  'pharmacy.mar.injectionSite': 'موقع الحقن',
  'pharmacy.mar.sitePlaceholder': 'أدخل موقع الحقن...',
  'pharmacy.mar.notes': 'ملاحظات',
  'pharmacy.mar.notesPlaceholder': 'ملاحظات إضافية...',
  'pharmacy.mar.witnessed': 'إعطاء بشاهد',
  'pharmacy.mar.witnessName': 'اسم الشاهد',

  // Medication Inventory
  'pharmacy.inventory.title': 'مخزون الأدوية',
  'pharmacy.inventory.subtitle': 'إدارة مستويات المخزون والجرد',
  'pharmacy.inventory.export': 'تصدير',
  'pharmacy.inventory.addItem': 'إضافة عنصر',
  'pharmacy.inventory.totalItems': 'إجمالي العناصر',
  'pharmacy.inventory.totalValue': 'القيمة الإجمالية',
  'pharmacy.inventory.lowStock': 'مخزون منخفض',
  'pharmacy.inventory.expiring': 'ستنتهي صلاحيته',
  'pharmacy.inventory.active': 'نشط',
  'pharmacy.inventory.searchPlaceholder': 'البحث في الأدوية والمواقع والصناديق...',
  'pharmacy.inventory.allStatuses': 'جميع الحالات',
  'pharmacy.inventory.allLocations': 'جميع المواقع',
  'pharmacy.inventory.lowStockOnly': 'المخزون المنخفض فقط',
  'pharmacy.inventory.expiringOnly': 'المنتهية الصلاحية فقط',
  'pharmacy.inventory.inventoryList': 'قائمة المخزون',
  'pharmacy.inventory.medication': 'الدواء',
  'pharmacy.inventory.location': 'الموقع',
  'pharmacy.inventory.currentStock': 'المخزون الحالي',
  'pharmacy.inventory.stockLevels': 'مستويات المخزون',
  'pharmacy.inventory.value': 'القيمة',
  'pharmacy.inventory.expiration': 'انتهاء الصلاحية',
  'pharmacy.inventory.status': 'الحالة',
  'pharmacy.inventory.viewDetails': 'عرض التفاصيل',
  'pharmacy.inventory.recordMovement': 'تسجيل الحركة',
  'pharmacy.inventory.edit': 'تعديل',
  'pharmacy.inventory.noItems': 'لا توجد عناصر مخزون',
  'pharmacy.inventory.noItemsDescription': 'لا توجد عناصر مخزون تطابق المرشحات الحالية',
  'pharmacy.inventory.movementType': 'نوع الحركة',
  'pharmacy.inventory.quantity': 'الكمية',
  'pharmacy.inventory.reason': 'السبب',
  'pharmacy.inventory.reasonPlaceholder': 'أدخل سبب الحركة...',
  'pharmacy.inventory.notesPlaceholder': 'ملاحظات إضافية...',
  'pharmacy.inventory.received': 'استلام',
  'pharmacy.inventory.dispensed': 'صرف',
  'pharmacy.inventory.wasted': 'هدر',
  'pharmacy.inventory.returned': 'إرجاع',
  'pharmacy.inventory.transferred': 'نقل',
  'pharmacy.inventory.adjusted': 'تعديل',
  'pharmacy.inventory.inactive': 'غير نشط',
  'pharmacy.inventory.expired': 'منتهي الصلاحية',
  'pharmacy.inventory.recalled': 'مسحوب',

  // Pharmacy Status Labels
  'pharmacy.inventory.status.active': 'نشط',
  'pharmacy.inventory.status.inactive': 'غير نشط',
  'pharmacy.inventory.status.expired': 'منتهي الصلاحية',
  'pharmacy.inventory.status.recalled': 'مسحوب',

  // Admin (additional)
  'admin.auditLogs': 'سجل التحقق',
  'admin.dashboard.title': 'الرئيسية',
  'admin.systemMonitoring': 'مراقبة النظام',
  'admin.systemSettings': 'إعدادات النظام',

  // Adt (additional)
  'adt.admission.admissionOrders': 'Admission Orders',
  'adt.admission.admissionSummary': 'Admission Summary',
  'adt.admission.assignedBed': 'Assigned Bed',
  'adt.admission.confirmAndNotify': 'Confirm And Notify',
  'adt.admission.dateTime': 'Date Time',
  'adt.admission.insurance': 'Insurance',
  'adt.admission.insuranceProvider': 'Insurance Provider',
  'adt.admission.insuranceProviderPlaceholder': 'Insurance Provider Placeholder',
  'adt.admission.insuranceVerification': 'Insurance Verification',
  'adt.admission.insuranceVerifiedMessage': 'Insurance Verified Message',
  'adt.admission.notifyDepartments': 'Notify Departments',
  'adt.admission.orderPlaceholder': 'Order Placeholder',
  'adt.admission.policyNumber': 'Policy Number',
  'adt.admission.policyNumberPlaceholder': 'Policy Number Placeholder',
  'adt.admission.verified': 'Verified',
  'adt.admission.verifying': 'Verifying',
  'adt.admission.verifyInsurance': 'Verify Insurance',
  'adt.admission.wristbandReminder': 'Wristband Reminder',
  'adt.discharge.addAppointment': 'Add Appointment',
  'adt.discharge.addMedication': 'Add Medication',
  'adt.discharge.admissionDate': 'Admission Date',
  'adt.discharge.appointmentNotes': 'Appointment Notes',
  'adt.discharge.billingAndFinalSteps': 'Billing And Final Steps',
  'adt.discharge.billingCompleted': 'Billing Completed',
  'adt.discharge.billingSummary': 'Billing Summary',
  'adt.discharge.checklist.belongingsReturned': 'Belongings Returned',
  'adt.discharge.checklist.followUpScheduled': 'Follow Up Scheduled',
  'adt.discharge.checklist.instructionsProvided': 'Instructions Provided',
  'adt.discharge.checklist.medicationReconciliation': 'Medication Reconciliation',
  'adt.discharge.confirmMedicationReconciliation': 'Confirm Medication Reconciliation',
  'adt.discharge.dischargeInstructions': 'Discharge Instructions',
  'adt.discharge.dischargeType': 'Discharge Type',
  'adt.discharge.dischargingPhysician': 'Discharging Physician',
  'adt.discharge.dosage': 'Dosage',
  'adt.discharge.downloadPDF': 'Download P D F',
  'adt.discharge.duration': 'Duration',
  'adt.discharge.educationTopicPlaceholder': 'Education Topic Placeholder',
  'adt.discharge.finalChecklist': 'Final Checklist',
  'adt.discharge.followUpAppointments': 'Follow Up Appointments',
  'adt.discharge.frequency': 'Frequency',
  'adt.discharge.homeMedications': 'Home Medications',
  'adt.discharge.instructionsPlaceholder': 'Instructions Placeholder',
  'adt.discharge.insuranceCovered': 'Insurance Covered',
  'adt.discharge.medicationName': 'Medication Name',
  'adt.discharge.medicationReconciliation': 'Medication Reconciliation',
  'adt.discharge.patientEducation': 'Patient Education',
  'adt.discharge.patientInstructions': 'Patient Instructions',
  'adt.discharge.patientResponsibility': 'Patient Responsibility',
  'adt.discharge.physicianName': 'Physician Name',
  'adt.discharge.physicianPlaceholder': 'Physician Placeholder',
  'adt.discharge.printInstructions': 'Print Instructions',
  'adt.discharge.specialInstructions': 'Special Instructions',
  'adt.discharge.specialty': 'Specialty',
  'adt.discharge.summary': 'Summary',
  'adt.discharge.summaryPlaceholder': 'Summary Placeholder',
  'adt.discharge.totalCharges': 'Total Charges',
  'adt.discharge.validation.billingRequired': 'Billing Required',
  'adt.discharge.validation.followUpRequired': 'Follow Up Required',
  'adt.discharge.validation.instructionsRequired': 'Instructions Required',
  'adt.discharge.validation.medicationReconciliationRequired': 'Medication Reconciliation Required',
  'adt.discharge.validation.physicianRequired': 'Physician Required',
  'adt.discharge.validation.summaryRequired': 'Summary Required',
  'adt.discharge.with': 'With',
  'adt.transfer.additionalNotes': 'Additional Notes',
  'adt.transfer.additionalNotesPlaceholder': 'Additional Notes Placeholder',
  'adt.transfer.allergies': 'Allergies',
  'adt.transfer.allergyPlaceholder': 'Allergy Placeholder',
  'adt.transfer.approvalGranted': 'Approval Granted',
  'adt.transfer.approvalPending': 'Approval Pending',
  'adt.transfer.approvalStatus': 'Approval Status',
  'adt.transfer.bed': 'Bed',
  'adt.transfer.bedsAvailable': 'Beds Available',
  'adt.transfer.bloodPressure': 'Blood Pressure',
  'adt.transfer.currentLocation': 'Current Location',
  'adt.transfer.currentMedications': 'Current Medications',
  'adt.transfer.currentVitalSigns': 'Current Vital Signs',
  'adt.transfer.destinationBed': 'Destination Bed',
  'adt.transfer.destinationFacility': 'Destination Facility',
  'adt.transfer.destinationRoom': 'Destination Room',
  'adt.transfer.destinationUnit': 'Destination Unit',
  'adt.transfer.destinationWard': 'Destination Ward',
  'adt.transfer.escortRequired': 'Escort Required',
  'adt.transfer.escortType': 'Escort Type',
  'adt.transfer.facilityAddress': 'Facility Address',
  'adt.transfer.facilityAddressPlaceholder': 'Facility Address Placeholder',
  'adt.transfer.facilityContact': 'Facility Contact',
  'adt.transfer.facilityContactPlaceholder': 'Facility Contact Placeholder',
  'adt.transfer.facilityName': 'Facility Name',
  'adt.transfer.facilityNamePlaceholder': 'Facility Name Placeholder',
  'adt.transfer.from': 'From',
  'adt.transfer.handoffDocumentation': 'Handoff Documentation',
  'adt.transfer.heartRate': 'Heart Rate',
  'adt.transfer.medicationPlaceholder': 'Medication Placeholder',
  'adt.transfer.oxygenSaturation': 'Oxygen Saturation',
  'adt.transfer.patientId': 'Patient Id',
  'adt.transfer.patientInfo': 'Patient Info',
  'adt.transfer.reasonPlaceholder': 'Reason Placeholder',
  'adt.transfer.requestApproval': 'Request Approval',
  'adt.transfer.requestDate': 'Request Date',
  'adt.transfer.requestedBy': 'Requested By',
  'adt.transfer.requestedByPlaceholder': 'Requested By Placeholder',
  'adt.transfer.requestTime': 'Request Time',
  'adt.transfer.respiratoryRate': 'Respiratory Rate',
  'adt.transfer.room': 'Room',
  'adt.transfer.scheduledFor': 'Scheduled For',
  'adt.transfer.scheduledTransferTime': 'Scheduled Transfer Time',
  'adt.transfer.selectRoom': 'Select Room',
  'adt.transfer.selectWard': 'Select Ward',
  'adt.transfer.specialInstructions': 'Special Instructions',
  'adt.transfer.specialInstructionsPlaceholder': 'Special Instructions Placeholder',
  'adt.transfer.temperature': 'Temperature',
  'adt.transfer.to': 'To',
  'adt.transfer.transferDate': 'Transfer Date',
  'adt.transfer.transferRequest': 'Transfer Request',
  'adt.transfer.transferSummary': 'Transfer Summary',
  'adt.transfer.transferTime': 'Transfer Time',
  'adt.transfer.transferType': 'Transfer Type',
  'adt.transfer.transportAndApproval': 'Transport And Approval',
  'adt.transfer.transportMode': 'Transport Mode',
  'adt.transfer.validation.approvalRequired': 'Approval Required',
  'adt.transfer.validation.bedRequired': 'Bed Required',
  'adt.transfer.validation.escortTypeRequired': 'Escort Type Required',
  'adt.transfer.validation.facilityAddressRequired': 'Facility Address Required',
  'adt.transfer.validation.facilityContactRequired': 'Facility Contact Required',
  'adt.transfer.validation.facilityNameRequired': 'Facility Name Required',
  'adt.transfer.validation.instructionsRequired': 'Instructions Required',
  'adt.transfer.validation.reasonRequired': 'Reason Required',
  'adt.transfer.validation.requestedByRequired': 'Requested By Required',
  'adt.transfer.validation.roomRequired': 'Room Required',
  'adt.transfer.validation.vitalSignsRequired': 'Vital Signs Required',
  'adt.transfer.validation.wardRequired': 'Ward Required',
  'adt.validation.bedRequired': 'Bed Required',
  'adt.validation.chiefComplaintRequired': 'Chief Complaint Required',
  'adt.validation.insuranceNotVerified': 'Insurance Not Verified',
  'adt.validation.patientRequired': 'Patient Required',
  'adt.validation.physicianRequired': 'Physician Required',
  'adt.validation.roomRequired': 'Room Required',
  'adt.validation.wardRequired': 'Ward Required',

  // Ai (additional)

  // Appointments (additional)

  // Auth (additional)

  // Common (additional)
  'common.address': 'Address',
  'common.email': 'Email',
  'common.filter.all': 'All',
  'common.phone': 'Phone',
  'common.retry': 'Retry',

  // Cpoe (additional)

  // Dashboard (additional)
  'dashboard.analyzeOverview': 'Analyze Overview',

  // Nav (additional)
  'nav.appointments': 'Appointments',
  'nav.medicalRecords': 'Medical Records',

  // Orders (additional)

  // Patient (additional)
  'patient.clinicalNotes': 'Clinical Notes',
  'patient.enterAddress': 'Enter Address',
  'patient.enterEmail': 'Enter Email',
  'patient.enterEmergencyContactName': 'Enter Emergency Contact Name',
  'patient.enterEmergencyContactPhone': 'Enter Emergency Contact Phone',
  'patient.enterFirstName': 'Enter First Name',
  'patient.enterInsuranceProvider': 'Enter Insurance Provider',
  'patient.enterLastName': 'Enter Last Name',
  'patient.enterPhone': 'Enter Phone',

  // Patients (additional)

  // Patient (additional)

  // Patients (additional)

  // Patient (additional)

  // Pharmacy (additional)
  'pharmacy.inventory.notes': 'Notes',

  // Records (additional)
  'records.vitals': 'Vitals',

  // RoleManagement (additional)

  // Scheduling (additional)
  'scheduling.contact': 'Contact',
  'scheduling.contact.email': 'Email',
  'scheduling.contact.phone': 'Phone',
  'scheduling.contactPreference': 'Contact Preference',
  'scheduling.contact.sms': 'Sms',
  'scheduling.department': 'Department',
  'scheduling.email': 'Email',
  'scheduling.patientName': 'Patient Name',
  'scheduling.phoneNumber': 'Phone Number',
  'scheduling.selectAppointmentType': 'Select Appointment Type',
  'scheduling.selectDepartment': 'Select Department',

  // UserManagement (additional)

  // Voice (additional)
  'voice.appointmentRecording': 'Appointment Recording',
  'voice.clinicalNotesRecording': 'Clinical Notes Recording',
  'voice.generalRecording': 'General Recording',
  'voice.patientConversation': 'Patient Conversation',
  'voice.paused': 'Paused',
  'voice.recording': 'Recording',
  'voice.startRecording': 'Start Recording',
  'voice.stopRecording': 'Stop Recording',
  'voice.transcribing': 'Transcribing',


  // Adt (synced)
  'adt.discharge.status.planned': 'Planned',
  'adt.discharge.status.in_progress': 'In Progress',
  'adt.discharge.status.completed': 'Completed',
  'adt.transfer.transportModes.wheelchair': 'Wheelchair',
  'adt.transfer.transportModes.stretcher': 'Stretcher',
  'adt.transfer.transportModes.ambulance': 'Ambulance',
  'adt.transfer.transportModes.air_ambulance': 'Air Ambulance',
  'adt.transfer.escortTypes.nurse': 'Nurse',
  'adt.transfer.escortTypes.physician': 'Physician',
  'adt.transfer.escortTypes.paramedic': 'Paramedic',
  'adt.transfer.approvedBy': 'Approved by {{name}}',
  'adt.transfer.status.requested': 'Requested',
  'adt.transfer.status.approved': 'Approved',
  'adt.transfer.status.in_transit': 'In Transit',
  'adt.transfer.status.completed': 'Completed',
  'adt.transfer.status.cancelled': 'Cancelled',

  // Common (synced)
  'common.done': 'Done',

  // Patient (synced)
  'patient.personalInformation': 'Personal Information',
  'patient.firstName': 'First Name',
  'patient.lastName': 'Last Name',
  'patient.contactInformation': 'Contact Information',
  'patient.medicalInformation': 'Medical Information',
  'patient.insuranceProvider': 'Insurance Provider',
  'patient.knownAllergies': 'Known Allergies',
  'patient.currentMedications': 'Current Medications',
  'patient.emergencyContactName': 'Emergency Contact Name',
  'patient.emergencyContactPhone': 'Emergency Contact Phone',
  'patient.medicalHistoryPlaceholder': 'Brief medical history including chronic conditions, previous surgeries, etc.',

  // Voice (synced)
  'voice.maxDurationWarning': '{{seconds}} seconds remaining',

  // Notifications
  'notifications.title': 'الإشعارات',
  'notifications.subtitle': 'إدارة الإشعارات والتنبيهات',
  'notifications.refresh': 'تحديث',
  'notifications.total': 'الإجمالي',
  'notifications.unread': 'غير مقروءة',
  'notifications.read': 'مقروءة',
  'notifications.archived': 'مؤرشفة',
  'notifications.filter': 'تصفية',
  'notifications.filtered': 'مُصفى',
  'notifications.clearAll': 'مسح الكل',
  'notifications.status': 'الحالة',
  'notifications.priority': 'الأولوية',
  'notifications.all': 'الكل',
  'notifications.urgent': 'عاجل',
  'notifications.high': 'عالي',
  'notifications.normal': 'عادي',
  'notifications.low': 'منخفض',
  'notifications.markRead': 'وضع علامة كمقروء',
  'notifications.markUnread': 'وضع علامة كغير مقروء',
  'notifications.markAllRead': 'وضع علامة على الكل كمقروء',
  'notifications.archive': 'أرشفة',
  'notifications.delete': 'حذف',
  'notifications.selected': 'محدد',
  'notifications.empty': 'لا توجد إشعارات',
  'notifications.emptyDescription': 'لقد قرأت كل شيء!',
  'notifications.patient': 'المريض',
  'notifications.search': 'البحث في الإشعارات...',
  'notifications.settings': 'إعدادات الإشعارات',
  'notifications.viewAll': 'عرض كل الإشعارات',
  'notifications.pagination.pageInfo': 'صفحة {{current}} من {{total}} ({{count}} إجمالي)',

  // Common (settings)
  'common.settings': 'الإعدادات',

  // Pharmacy Dashboard (additional)
  'pharmacy.tabs.orders': 'الطلبات',
  'pharmacy.tabs.verification': 'التحقق',
  'pharmacy.tabs.inventory': 'المخزون',
  'pharmacy.tabs.alerts': 'التنبيهات',
  'pharmacy.dashboard.pharmacistWorkload': 'عبء عمل الصيدلي',
  'pharmacy.dashboard.assignedOrders': 'الطلبات المعينة',
  'pharmacy.dashboard.verifiedToday': 'تم التحقق منها اليوم',
  'pharmacy.dashboard.avgVerificationTime': 'متوسط وقت التحقق',
  'pharmacy.dashboard.allPriorities': 'جميع الأولويات',
  'pharmacy.dashboard.allStatuses': 'جميع الحالات',
  'pharmacy.dashboard.stat': 'عاجل جداً',
  'pharmacy.dashboard.asap': 'في أقرب وقت',
  'pharmacy.dashboard.urgent': 'عاجل',
  'pharmacy.dashboard.routine': 'روتيني',
  'pharmacy.dashboard.pending': 'قيد الانتظار',
  'pharmacy.dashboard.verified': 'تم التحقق',
  'pharmacy.dashboard.filled': 'تم التعبئة',
  'pharmacy.dashboard.dispensed': 'تم الصرف',
  'pharmacy.dashboard.patient': 'المريض',
  'pharmacy.dashboard.medication': 'الدواء',
  'pharmacy.dashboard.provider': 'الطبيب',
  'pharmacy.dashboard.priority': 'الأولوية',
  'pharmacy.dashboard.status': 'الحالة',
  'pharmacy.dashboard.orderTime': 'وقت الطلب',
  'pharmacy.dashboard.actions': 'الإجراءات',
  'pharmacy.dashboard.verify': 'تحقق',
  'pharmacy.dashboard.dispense': 'صرف',
  'pharmacy.dashboard.controlled': 'مراقب',
  'pharmacy.dashboard.interactions': 'التفاعلات',
  'pharmacy.dashboard.status.pending': 'قيد الانتظار',
  'pharmacy.dashboard.status.verified': 'تم التحقق',
  'pharmacy.dashboard.status.filled': 'تم التعبئة',
  'pharmacy.dashboard.status.dispensed': 'تم الصرف',
  'pharmacy.dashboard.verificationQueue': 'قائمة انتظار التحقق',
  'pharmacy.dashboard.verificationContent': 'الطلبات التي تحتاج إلى تحقق الصيدلي ستظهر هنا',
  'pharmacy.dashboard.inventory': 'مخزون الأدوية',
  'pharmacy.dashboard.inventoryContent': 'مستويات المخزون وإدارة المخزون',
  'pharmacy.dashboard.alerts': 'تنبيهات الصيدلية',
  'pharmacy.dashboard.alertsContent': 'التفاعلات الدوائية، المخزون المنخفض، والتنبيهات الحرجة الأخرى',
  'pharmacy.dashboard.orderDetails': 'تفاصيل طلب الدواء',
  'pharmacy.dashboard.patientInformation': 'معلومات المريض',
  'pharmacy.dashboard.patientName': 'اسم المريض',
  'pharmacy.dashboard.location': 'الموقع',
  'pharmacy.dashboard.medicationDetails': 'تفاصيل الدواء',
  'pharmacy.dashboard.medicationName': 'الدواء',
  'pharmacy.dashboard.strength': 'القوة',
  'pharmacy.dashboard.route': 'طريقة الإعطاء',
  'pharmacy.dashboard.frequency': 'التكرار',
  'pharmacy.dashboard.quantity': 'الكمية',
  'pharmacy.dashboard.refills': 'إعادة التعبئة',
  'pharmacy.dashboard.drugInteractions': 'التفاعلات الدوائية',
  'pharmacy.dashboard.verificationDetails': 'تفاصيل التحقق',
  'pharmacy.dashboard.verifiedBy': 'تم التحقق بواسطة',
  'pharmacy.dashboard.verifiedAt': 'تم التحقق في',
  'pharmacy.dashboard.notes': 'ملاحظات',

  // E-Prescribing
  'eprescribing.title': 'الوصفات الإلكترونية',
  'eprescribing.prescriptions': 'الوصفات',
  'eprescribing.viewPrescriptions': 'انقر على "عرض الكل" لرؤية جميع الوصفات لهذا المريض',
  'eprescribing.newPrescription': 'وصفة جديدة',
  'eprescribing.prescriptionDetails': 'تفاصيل الوصفة',
  'eprescribing.prescriptionHistory': 'سجل الوصفات',
  'eprescribing.activePrescriptions': 'الوصفات النشطة',
  'eprescribing.searchMedication': 'البحث عن دواء...',
  'eprescribing.selectPharmacy': 'اختر صيدلية',
  'eprescribing.searchPharmacy': 'البحث عن صيدلية...',
  'eprescribing.preferredPharmacy': 'الصيدلية المفضلة',

  // E-Prescribing Steps
  'eprescribing.step.medication': 'الدواء',
  'eprescribing.step.dosage': 'الجرعة',
  'eprescribing.step.pharmacy': 'الصيدلية',
  'eprescribing.step.review': 'المراجعة',

  // Prescription Status
  'eprescribing.status.draft': 'مسودة',
  'eprescribing.status.pending-signature': 'في انتظار التوقيع',
  'eprescribing.status.signed': 'موقّعة',
  'eprescribing.status.transmitted': 'مُرسلة',
  'eprescribing.status.received-by-pharmacy': 'استلمتها الصيدلية',
  'eprescribing.status.in-progress': 'قيد التنفيذ',
  'eprescribing.status.ready-for-pickup': 'جاهزة للاستلام',
  'eprescribing.status.dispensed': 'تم الصرف',
  'eprescribing.status.cancelled': 'ملغاة',
  'eprescribing.status.declined': 'مرفوضة',
  'eprescribing.status.expired': 'منتهية الصلاحية',
  'eprescribing.status.discontinued': 'متوقفة',

  // DEA Schedule
  'eprescribing.schedule.I': 'الجدول الأول',
  'eprescribing.schedule.II': 'الجدول الثاني',
  'eprescribing.schedule.III': 'الجدول الثالث',
  'eprescribing.schedule.IV': 'الجدول الرابع',
  'eprescribing.schedule.V': 'الجدول الخامس',
  'eprescribing.schedule.Non-Controlled': 'غير مراقب',

  // Dosage Instructions
  'eprescribing.dosage': 'الجرعة',
  'eprescribing.route': 'طريقة الإعطاء',
  'eprescribing.frequency': 'التكرار',
  'eprescribing.duration': 'المدة',
  'eprescribing.quantity': 'الكمية',
  'eprescribing.daysSupply': 'عدد الأيام',
  'eprescribing.refills': 'إعادة التعبئة',
  'eprescribing.refillsRemaining': 'المتبقي من إعادة التعبئة',
  'eprescribing.substitutionAllowed': 'يسمح بالبديل',
  'eprescribing.dispenseAsWritten': 'صرف كما هو مكتوب',
  'eprescribing.additionalInstructions': 'تعليمات إضافية',

  // Actions
  'eprescribing.signPrescription': 'توقيع الوصفة',
  'eprescribing.transmitToPharmacy': 'إرسال للصيدلية',
  'eprescribing.cancelPrescription': 'إلغاء الوصفة',
  'eprescribing.renewPrescription': 'تجديد الوصفة',
  'eprescribing.modifyPrescription': 'تعديل الوصفة',
  'eprescribing.viewHistory': 'عرض السجل',
  'eprescribing.checkPMP': 'فحص برنامج مراقبة الوصفات',
  'eprescribing.checkInteractions': 'فحص التفاعلات',

  // Controlled Substances
  'eprescribing.controlledSubstance': 'مادة مراقبة',
  'eprescribing.deaNumber': 'رقم DEA',
  'eprescribing.pmpCheck': 'فحص PMP',
  'eprescribing.pmpRequired': 'فحص PMP مطلوب للمواد المراقبة',
  'eprescribing.pmpCompleted': 'تم إكمال فحص PMP',
  'eprescribing.narcoticsAgreement': 'اتفاقية المخدرات',
  'eprescribing.narcoticsAgreementRequired': 'اتفاقية المخدرات مطلوبة',

  // Refills
  'eprescribing.refill.request': 'طلب إعادة تعبئة',
  'eprescribing.refill.approve': 'الموافقة على إعادة التعبئة',
  'eprescribing.refill.deny': 'رفض إعادة التعبئة',
  'eprescribing.refill.pending': 'طلبات إعادة التعبئة المعلقة',
  'eprescribing.refill.noRefills': 'لا توجد إعادة تعبئة متبقية',
  'eprescribing.refill.refillsAvailable': 'إعادة تعبئة متاحة',

  // Prior Authorization
  'eprescribing.priorAuth.required': 'التصريح المسبق مطلوب',
  'eprescribing.priorAuth.status': 'حالة التصريح المسبق',
  'eprescribing.priorAuth.pending': 'معلق',
  'eprescribing.priorAuth.approved': 'موافق عليه',
  'eprescribing.priorAuth.denied': 'مرفوض',
  'eprescribing.priorAuth.authNumber': 'رقم التصريح',

  // Pharmacy Information
  'eprescribing.pharmacy.name': 'اسم الصيدلية',
  'eprescribing.pharmacy.address': 'العنوان',
  'eprescribing.pharmacy.phone': 'الهاتف',
  'eprescribing.pharmacy.hours': 'ساعات العمل',
  'eprescribing.pharmacy.capabilities': 'الإمكانيات',
  'eprescribing.pharmacy.eprescribing': 'الوصفات الإلكترونية',
  'eprescribing.pharmacy.controlledSubstances': 'المواد المراقبة',
  'eprescribing.pharmacy.delivery': 'التوصيل متاح',
  'eprescribing.pharmacy.twentyFourHour': '24 ساعة',

  // Messages
  'eprescribing.messages.signatureRequired': 'التوقيع الإلكتروني مطلوب',
  'eprescribing.messages.transmissionSuccess': 'تم إرسال الوصفة بنجاح',
  'eprescribing.messages.transmissionFailed': 'فشل إرسال الوصفة',
  'eprescribing.messages.validationError': 'يرجى تصحيح الأخطاء قبل المتابعة',
  'eprescribing.messages.pmpCheckRequired': 'فحص PMP مطلوب قبل التوقيع',
  'eprescribing.messages.noMedicationSelected': 'يرجى اختيار دواء',
  'eprescribing.messages.noPharmacySelected': 'يرجى اختيار صيدلية',
  'eprescribing.messages.prescriptionCreated': 'تم إنشاء الوصفة بنجاح',
  'eprescribing.messages.prescriptionCancelled': 'تم إلغاء الوصفة',
  'eprescribing.messages.refillApproved': 'تمت الموافقة على إعادة التعبئة وإرسالها',
  'eprescribing.messages.refillDenied': 'تم رفض طلب إعادة التعبئة',

  // Interactions
  'eprescribing.interactions.title': 'التفاعلات الدوائية',
  'eprescribing.interactions.severity.minor': 'بسيط',
  'eprescribing.interactions.severity.moderate': 'متوسط',
  'eprescribing.interactions.severity.major': 'كبير',
  'eprescribing.interactions.severity.contraindicated': 'موانع الاستعمال',
  'eprescribing.interactions.override': 'تجاوز التفاعل',
  'eprescribing.interactions.overrideReason': 'سبب التجاوز',

  // Refill Requests Page
  'eprescribing.refillRequests': 'طلبات إعادة التعبئة',
  'eprescribing.refillRequestsDescription': 'مراجعة وإدارة طلبات إعادة تعبئة الوصفات',
  'eprescribing.pendingRequests': 'الطلبات المعلقة',
  'eprescribing.approvedToday': 'الموافق عليها اليوم',
  'eprescribing.deniedRequests': 'الطلبات المرفوضة',
  'eprescribing.searchRefills': 'البحث عن طريق الدواء أو المريض أو الصيدلية...',
  'eprescribing.noRefillRequests': 'لا توجد طلبات إعادة تعبئة',
  'eprescribing.approve': 'موافقة',
  'eprescribing.deny': 'رفض',
  'eprescribing.requestedDate': 'تاريخ الطلب',
  'eprescribing.neededBy': 'مطلوب بحلول',
  'eprescribing.requestedBy': 'طلب من قبل',
  'eprescribing.processedDate': 'تاريخ المعالجة',
  'eprescribing.denialReason': 'سبب الرفض',
  'eprescribing.denyRefillRequest': 'رفض طلب إعادة التعبئة',
  'eprescribing.denyRefillDescription': 'يرجى تقديم سبب لرفض طلب إعادة التعبئة هذا.',
  'eprescribing.enterDenialReason': 'أدخل سبب الرفض...',
  'eprescribing.denyRefill': 'رفض إعادة التعبئة',
  'eprescribing.viewOriginalPrescription': 'عرض الوصفة الأصلية',
  'eprescribing.originalPrescription': 'الوصفة الأصلية',
  'eprescribing.overdue': 'متأخر',
  'eprescribing.urgent': 'عاجل',
  'eprescribing.refillsAuthorized': 'إعادة التعبئة المصرح بها',
  'eprescribing.quantityDispensed': 'الكمية الموزعة',
  'eprescribing.writtenDate': 'تاريخ الكتابة',
  'eprescribing.prescriptionNumber': 'رقم الوصفة',

  // Refill Status
  'eprescribing.refillStatus.pending': 'معلق',
  'eprescribing.refillStatus.approved': 'موافق عليه',
  'eprescribing.refillStatus.denied': 'مرفوض',
  'eprescribing.refillStatus.cancelled': 'ملغى',

  // CPOE Integration
  'eprescribing.createPrescription': 'إنشاء وصفة إلكترونية',
  'eprescribing.fromMedicationOrder': 'من طلب الدواء',
  'eprescribing.readyToTransmit': 'جاهز للإرسال',
  'eprescribing.orderWillConvert': 'سيتم تحويل طلب الدواء هذا إلى وصفة طبية إلكترونية وإرساله إلى الصيدلية.',
  'eprescribing.nextSteps': 'ما هي الخطوات التالية؟',
  'eprescribing.step.selectPharmacy': 'اختيار صيدلية المريض',
  'eprescribing.step.reviewDetails': 'مراجعة تفاصيل الوصفة',
  'eprescribing.step.signPrescription': 'التوقيع على الوصفة إلكترونياً',
  'eprescribing.step.transmitToPharmacy': 'الإرسال إلى الصيدلية',
  'eprescribing.proceedToPrescription': 'المتابعة إلى الوصفة الإلكترونية',
  'cpoe.sendAsEPrescription': 'إرسال كوصفة إلكترونية',

  // Common Additions (new keys only)
  'common.showLess': 'إظهار أقل',
  'common.pharmacy': 'الصيدلية',
  'common.provider': 'مقدم الخدمة',

  // Medical Coding
  'coding.medicalCoding': 'الترميز الطبي',
  'coding.description': 'تعيين رموز ICD-10 و CPT لمواجهات المرضى',
  'coding.browse': 'تصفح الرموز',
  'coding.codingWorkspace': 'مساحة عمل الترميز',
  'coding.statistics': 'الإحصائيات',
  'coding.selectPatientEncounter': 'يرجى اختيار مريض ومواجهة',
  'coding.diagnosesSaved': 'تم حفظ التشخيصات بنجاح',
  'coding.selectEncounter': 'اختر المواجهة',
  'coding.searchPatient': 'بحث عن مريض...',
  'coding.noEncounters': 'لم يتم العثور على مواجهات لهذا المريض',
  'coding.draftDiagnoses': 'التشخيصات المسودة',
  'coding.addDiagnosis': 'إضافة تشخيص',
  'coding.noDraftDiagnoses': 'لم يتم إضافة تشخيصات بعد. تصفح الرموز للبدء.',
  'coding.recentlyCoded': 'تم ترميزه مؤخرًا',
  'coding.noRecentCoding': 'لا يوجد نشاط ترميز حديث',

  // Diagnosis Types
  'coding.diagnosisType.primary': 'أساسي',
  'coding.diagnosisType.secondary': 'ثانوي',
  'coding.diagnosisType.comorbidity': 'مرض مصاحب',
  'coding.diagnosisType.complication': 'مضاعفة',

  // ICD-10 Browser
  'coding.icd10.browser': 'متصفح رموز ICD-10-CM',
  'coding.icd10.catalogLabel': 'ICD-10-CM 2025',
  'coding.icd10.startSearching': 'ابحث في رموز ICD-10-CM',
  'coding.icd10.startSearchingHint':
    'اكتب رمزًا أو وصفًا للبحث في مجموعة الرموز الكاملة.',
  'coding.icd10.browserDescription': 'البحث وتصفح رموز تشخيص ICD-10-CM',
  'coding.icd10.codes': 'رموز',
  'coding.icd10.searchPlaceholder': 'البحث بالرمز أو العنوان أو الوصف...',
  'coding.icd10.favorites': 'المفضلة',
  'coding.icd10.recent': 'الأخيرة',
  'coding.icd10.billableOnly': 'القابلة للفوترة فقط',
  'coding.icd10.nonBillable': 'غير قابلة للفوترة',
  'coding.icd10.chapter': 'الفصل',
  'coding.icd10.selectChapter': 'اختر الفصل',
  'coding.icd10.noResultsHint': 'حاول تعديل البحث أو المرشحات',

  // Coding Statistics
  'coding.stats.encountersCoded': 'المواجهات المرمزة',
  'coding.stats.last30Days': 'آخر 30 يومًا',
  'coding.stats.averageTime': 'متوسط الوقت/مواجهة',
  'coding.stats.productivity': 'مقياس الإنتاجية',
  'coding.stats.accuracy': 'دقة الترميز',
  'coding.stats.qualityMetric': 'مقياس الجودة',
  'coding.stats.queryRate': 'معدل الاستفسار',
  'coding.stats.queriesPerEncounter': 'استفسارات لكل مواجهة',
  'coding.stats.revenueImpact': 'تأثير الإيرادات',
  'coding.stats.totalCharges': 'إجمالي الرسوم المولدة',
  'coding.stats.averageCharge': 'متوسط ​​الرسوم/مواجهة',

  // Coding Notice
  'coding.notice.title': 'إحصائيات تجريبية',
  'coding.notice.description': 'يتم حساب هذه الإحصائيات من نشاط الترميز الخاص بك. في بيئة الإنتاج، ستعكس هذه مقاييس الإنتاجية والجودة الفعلية.',

  // CPT
  'coding.cpt.browser': 'متصفح رموز CPT',
  'coding.cpt.searchPlaceholder': 'البحث عن رموز الإجراءات...',

  // Billing & Revenue Management
  'billing.title': 'إدارة الفواتير والإيرادات',
  'billing.subtitle': 'إدارة الفواتير والمدفوعات والتقارير المالية',
  'billing.newBill': 'فاتورة جديدة',
  'billing.new': 'جديد',
  'billing.recordPayment': 'تسجيل الدفع',
  'billing.payment': 'الدفع',

  // Tabs
  'billing.tabs.overview': 'نظرة عامة',
  'billing.tabs.bills': 'الفواتير',
  'billing.tabs.payments': 'المدفوعات',
  'billing.tabs.claims': 'مطالبات التأمين',
  'billing.tabs.reports': 'التقارير',
  'billing.tabs.saved': 'دليل الخدمات',

  // Overview Stats
  'billing.stats.totalRevenue': 'إجمالي الإيرادات',
  'billing.stats.collectionRate': 'معدل التحصيل',
  'billing.stats.pendingAmount': 'المبلغ المعلق',
  'billing.stats.overdueAmount': 'المبلغ المتأخر',
  'billing.stats.pendingBills': 'فواتير معلقة',
  'billing.stats.overdueBills': 'فواتير متأخرة',
  'billing.stats.fromLastMonth': 'من الشهر الماضي',

  // Recent Activity
  'billing.recentBills': 'الفواتير الأخيرة',
  'billing.topRevenueServices': 'أفضل الخدمات من حيث الإيرادات',
  'billing.services': 'خدمات',

  // Bills Tab
  'billing.searchPlaceholder': 'البحث عن الفواتير باسم المريض أو رقم الفاتورة...',
  'billing.allStatus': 'جميع الحالات',
  'billing.today': 'اليوم',
  'billing.thisWeek': 'هذا الأسبوع',
  'billing.thisMonth': 'هذا الشهر',
  'billing.thisQuarter': 'هذا الربع',
  'billing.thisYear': 'هذا العام',

  // Bill Status
  'billing.status.paid': 'مدفوع',
  'billing.status.pending': 'معلق',
  'billing.status.partial': 'جزئي',
  'billing.status.overdue': 'متأخر',
  'billing.status.cancelled': 'ملغي',
  'billing.status.disputed': 'متنازع عليه',

  // Table Headers
  'billing.table.billDetails': 'تفاصيل الفاتورة',
  'billing.table.patient': 'المريض',
  'billing.table.amount': 'المبلغ',
  'billing.table.status': 'الحالة',
  'billing.table.dueDate': 'تاريخ الاستحقاق',
  'billing.table.actions': 'الإجراءات',
  'billing.table.billId': 'رقم الفاتورة',
  'billing.table.totalAmount': 'المبلغ الإجمالي',
  'billing.table.paid': 'المدفوع',
  'billing.table.balance': 'الرصيد',

  // Bill Details
  'billing.billDetails': 'تفاصيل الفاتورة',
  'billing.patientInformation': 'معلومات المريض',
  'billing.billInformation': 'معلومات الفاتورة',
  'billing.totalAmount': 'المبلغ الإجمالي',
  'billing.paidAmount': 'المبلغ المدفوع',
  'billing.balance': 'الرصيد',
  'billing.serviceDetails': 'تفاصيل الخدمة',
  'billing.service': 'الخدمة',
  'billing.quantity': 'الكمية',
  'billing.unitPrice': 'سعر الوحدة',
  'billing.total': 'المجموع',

  // Payments Tab
  'billing.paymentManagement': 'إدارة المدفوعات',
  'billing.paymentManagementSubtitle': 'معالجة المدفوعات وعرض سجل المدفوعات',
  'billing.totalCollected': 'إجمالي المحصل',
  'billing.pendingCollection': 'التحصيل المعلق',
  'billing.billsRequiringPayment': 'الفواتير التي تتطلب الدفع',
  'billing.allBillsPaid': 'تم دفع جميع الفواتير بالكامل!',

  // Claims Tab
  'billing.insuranceClaims': 'مطالبات التأمين',
  'billing.insuranceClaimsSubtitle': 'سيتم عرض تتبع وإدارة مطالبات التأمين هنا.',

  // Reports Tab
  'billing.financialReports': 'التقارير المالية',
  'billing.revenueAnalytics': 'تحليلات الإيرادات وتقارير الفواتير',
  'billing.exportReport': 'تصدير التقرير',
  'billing.totalRevenue': 'إجمالي الإيرادات',
  'billing.collected': 'المحصل',
  'billing.outstanding': 'المستحق',
  'billing.overdue': 'المتأخر',
  'billing.invoices': 'فواتير',
  'billing.collectionRate': 'معدل التحصيل',
  'billing.invoiceStatusBreakdown': 'تفصيل حالة الفواتير',
  'billing.revenueSummary': 'ملخص الإيرادات',
  'billing.grossRevenue': 'إجمالي الإيرادات',
  'billing.paymentsReceived': 'المدفوعات المستلمة',
  'billing.accountsReceivable': 'الحسابات المستحقة',
  'billing.recentInvoices': 'الفواتير الأخيرة',
  'billing.invoice': 'الفاتورة',
  'billing.patient': 'المريض',
  'billing.date': 'التاريخ',
  'billing.amount': 'المبلغ',

  // Actions
  'billing.viewDetails': 'عرض التفاصيل',
  'billing.editBill': 'تحرير الفاتورة',
  'billing.downloadPrint': 'تنزيل/طباعة',

  // Loading & Empty States
  'billing.loadingBills': 'جاري تحميل الفواتير...',
  'billing.noBillsFound': 'لم يتم العثور على فواتير',
  'billing.tryAdjustingFilters': 'حاول تعديل المرشحات لرؤية المزيد من النتائج',
  'billing.getStartedFirstBill': 'ابدأ بإنشاء أول فاتورة',
  'billing.createFirstBill': 'إنشاء أول فاتورة',
  'billing.noMatchingBills': 'لم يتم العثور على فواتير مطابقة',
  'billing.tryAdjustingSearch': 'حاول تعديل البحث',
  'billing.greatJobPayments': 'عمل رائع في متابعة المدفوعات',

  // Pagination
  'billing.show': 'عرض',
  'billing.entries': 'مدخلات',
  'billing.showing': 'عرض',
  'billing.to': 'إلى',
  'billing.of': 'من',

  // Claims Tab
  'billing.insuranceClaimsManagement': 'إدارة مطالبات التأمين',
  'billing.trackInsuranceClaims': 'تتبع مطالبات التأمين والمقدمات والتعويضات في مكان واحد.',
  'billing.submitClaims': 'تقديم المطالبات',
  'billing.trackStatus': 'تتبع الحالة',
  'billing.viewPayments': 'عرض المدفوعات',
  'billing.comingSoon': 'قريباً - هذه الميزة قيد التطوير',

  // Overview Stats (Additional)
  'billing.vsLastMonth': 'مقارنة بالشهر الماضي',
  'billing.toCollect': 'للتحصيل',
  'billing.needAttention': 'تحتاج إلى اهتمام',
  'billing.noServiceData': 'لا توجد بيانات خدمة بعد',
  'billing.serviceAnalytics': 'ستظهر تحليلات الخدمة هنا',

  // Reports (Additional)
  'billing.exportAsCSV': 'تصدير كـ CSV',
  'billing.exportAsJSON': 'تصدير كـ JSON',
  'billing.exportAsPDF': 'تصدير كـ PDF',
  'billing.pendingBillsCount': 'فواتير معلقة',
  'billing.overdueBillsCount': 'فواتير متأخرة',

  // Reports & Analytics
  'reports.title': 'التقارير والتحليلات',
  'reports.subtitle': 'رؤى شاملة وتحليلات البيانات',
  'reports.configure': 'تكوين',
  'reports.config': 'إعدادات',
  'reports.exportAll': 'تصدير الكل',
  'reports.export': 'تصدير',
  'reports.tabs.dashboard': 'لوحة المعلومات',
  'reports.tabs.financial': 'مالي',
  'reports.tabs.clinical': 'سريري',
  'reports.tabs.operational': 'تشغيلي',
  'reports.tabs.custom': 'تقارير مخصصة',
  'reports.executiveDashboard': 'لوحة التحكم التنفيذية',
  'reports.today': 'اليوم',
  'reports.thisWeek': 'هذا الأسبوع',
  'reports.thisMonth': 'هذا الشهر',
  'reports.thisQuarter': 'هذا الربع',
  'reports.thisYear': 'هذا العام',
  'reports.customRange': 'نطاق مخصص',
  'reports.monthlyRevenue': 'الإيرادات الشهرية',
  'reports.totalPatients': 'إجمالي المرضى',
  'reports.appointments': 'المواعيد',
  'reports.collectionRate': 'معدل التحصيل',
  'reports.vsLastMonth': 'مقارنة بالشهر الماضي',
  'reports.revenueTrend': 'اتجاه الإيرادات',
  'reports.viewDetails': 'عرض التفاصيل',
  'reports.details': 'التفاصيل',
  'reports.revenueTrendChart': 'سيتم عرض مخطط اتجاه الإيرادات هنا',
  'reports.patientDemographics': 'التركيبة السكانية للمرضى',
  'reports.demographicsChart': 'سيتم عرض المخطط الدائري للتركيبة السكانية هنا',
  'reports.quickReports': 'تقارير سريعة',
  'reports.generate': 'إنشاء',
  'reports.gen': 'إنشاء',
  'reports.generating': 'جاري الإنشاء...',
  'reports.financialReports': 'التقارير المالية',
  'reports.newReport': 'تقرير جديد',
  'reports.new': 'جديد',
  'reports.ready': 'جاهز',
  'reports.error': 'خطأ',
  'reports.last': 'آخر',
  'reports.daily': 'يومي',
  'reports.weekly': 'أسبوعي',
  'reports.monthly': 'شهري',
  'reports.quarterly': 'ربع سنوي',
  'reports.yearly': 'سنوي',
  'reports.onDemand': 'عند الطلب',
  'reports.viewReport': 'عرض التقرير',
  'reports.downloadReport': 'تنزيل التقرير',
  'reports.clinicalReports': 'التقارير السريرية',
  'reports.clinicalMetrics': 'سيتم عرض مقاييس الجودة السريرية وتقارير نتائج المرضى هنا.',
  'reports.operationalReports': 'التقارير التشغيلية',
  'reports.operationalEfficiency': 'سيتم عرض تقارير الكفاءة التشغيلية واستخدام الموارد هنا.',
  'reports.customReports': 'تقارير مخصصة',
  'reports.customReportBuilder': 'سيتم عرض منشئ التقارير المخصصة والتقارير المحفوظة هنا.',
  'reports.reportConfiguration': 'تكوين التقرير',
  'reports.defaultSettings': 'الإعدادات الافتراضية',
  'reports.defaultDateRange': 'النطاق الزمني الافتراضي',
  'reports.currentMonth': 'الشهر الحالي',
  'reports.currentQuarter': 'الربع الحالي',
  'reports.currentYear': 'العام الحالي',
  'reports.autoRefreshInterval': 'فترة التحديث التلقائي',
  'reports.never': 'أبداً',
  'reports.everyHour': 'كل ساعة',
  'reports.automatedReportScheduling': 'جدولة التقارير التلقائية',
  'reports.currently': 'حالياً',
  'reports.emailNotifications': 'إشعارات البريد الإلكتروني',
  'reports.sendDailySummary': 'إرسال ملخصات التقارير اليومية',
  'reports.alertOnChanges': 'التنبيه عند حدوث تغييرات كبيرة في المقاييس',
  'reports.weeklyExecutiveDashboard': 'لوحة التحكم التنفيذية الأسبوعية',
  'reports.cancel': 'إلغاء',
  'reports.saveSettings': 'حفظ الإعدادات',
  'reports.exportReports': 'تصدير التقارير',
  'reports.selectReportsToExport': 'حدد التقارير للتصدير',
  'reports.selectAllReports': 'تحديد جميع التقارير',
  'reports.exportFormat': 'تنسيق التصدير',
  'reports.generatingReports': 'جاري إنشاء التقارير... قد يستغرق ذلك بعض الوقت.',
  'reports.readyToExport': 'جاهز للتصدير',
  'reports.report': 'تقرير',
  'reports.reports': 'تقارير',
  'reports.totalRecords': 'إجمالي السجلات',
  'reports.averageValue': 'القيمة المتوسطة',
  'reports.completionRate': 'معدل الإنجاز',
  'reports.fromLastPeriod': 'من الفترة السابقة',
  'reports.trendAnalysis': 'تحليل الاتجاه',
  'reports.interactiveChart': 'سيتم عرض الرسم البياني التفاعلي هنا',
  'reports.downloadPDF': 'تنزيل PDF',
  'reports.downloadExcel': 'تنزيل Excel',
  'reports.close': 'إغلاق',
  'reports.createNewReport': 'إنشاء تقرير جديد',
  'reports.reportName': 'اسم التقرير',
  'reports.enterReportName': 'أدخل اسم التقرير',
  'reports.category': 'الفئة',
  'reports.financial': 'مالي',
  'reports.clinical': 'سريري',
  'reports.operational': 'تشغيلي',
  'reports.quality': 'الجودة',
  'reports.dataSource': 'مصدر البيانات',
  'reports.billingData': 'بيانات الفواتير',
  'reports.patientRecords': 'سجلات المرضى',
  'reports.labOrders': 'طلبات المختبر',
  'reports.medications': 'الأدوية',
  'reports.generationFrequency': 'تكرار الإنشاء',
  'reports.description': 'الوصف',
  'reports.enterDescription': 'أدخل وصف التقرير',
  'reports.createReport': 'إنشاء تقرير',

  // Drugs Page
  'drugsPage.title': 'قاعدة بيانات الأدوية',
  'drugsPage.subtitle': 'ابحث في أكثر من 100,000 دواء بدعم من RxNorm',
  'drugsPage.tabs.drugSearch': 'البحث عن الأدوية',
  'drugsPage.tabs.interactionChecker': 'فحص التفاعلات الدوائية',
  'drugsPage.tabs.about': 'حول',
  'drugsPage.search.title': 'البحث عن الأدوية',
  'drugsPage.search.placeholder': 'ابحث باسم الدواء (مثل: ميتفورمين، إيبوبروفين، أسبرين)...',
  'drugsPage.infoCards.drugs.title': '+100,000 دواء',
  'drugsPage.infoCards.drugs.description': 'ابحث في قاعدة بيانات شاملة للأدوية تشمل الأدوية العامة والأسماء التجارية.',
  'drugsPage.infoCards.alternatives.title': 'البدائل',
  'drugsPage.infoCards.alternatives.description': 'اعثر على الأدوية البديلة بنفس المكونات النشطة والتركيبات.',
  'drugsPage.infoCards.interactions.title': 'التفاعلات الدوائية',
  'drugsPage.infoCards.interactions.description': 'تحقق من التفاعلات الدوائية المحتملة والتنبيهات الأمنية.',
  'drugsPage.about.mainTitle': 'حول تكامل RxNorm',
  'drugsPage.about.whatIsRxNorm.title': 'ما هو RxNorm؟',
  'drugsPage.about.whatIsRxNorm.description': 'RxNorm هو نظام تسمية موحد للأدوية السريرية تم إنتاجه من قبل المكتبة الوطنية للطب الأمريكية (NLM). يوفر أسماء موحدة ومعرفات فريدة للأدوية لتمكين التوافق بين الأنظمة الصحية المختلفة.',
  'drugsPage.about.features.title': 'الميزات المتاحة',
  'drugsPage.about.features.searchDrugs': 'البحث في أكثر من 100,000 دواء بالاسم العام أو التجاري',
  'drugsPage.about.features.viewDetails': 'عرض معلومات مفصلة عن الدواء بما في ذلك أكواد RxCUI',
  'drugsPage.about.features.findAlternatives': 'العثور على الأدوية البديلة بنفس المكونات النشطة',
  'drugsPage.about.features.checkInteractions': 'فحص التفاعلات الدوائية والمشاكل الأمنية المحتملة',
  'drugsPage.about.features.extractIngredients': 'استخراج المكونات النشطة من الأدوية',
  'drugsPage.about.features.lookupNDC': 'البحث عن الأدوية برمز NDC (رمز الدواء الوطني)',
  'drugsPage.about.dataSource.title': 'مصدر البيانات',
  'drugsPage.about.dataSource.description': 'يتم استرجاع جميع بيانات الأدوية في الوقت الفعلي من واجهة برمجة التطبيقات RxNorm التي تحتفظ بها المكتبة الوطنية للطب الأمريكية. البيانات مجانية ومتاحة للعامة ويتم تحديثها بانتظام لضمان الدقة.',
  'drugsPage.about.termTypes.title': 'أنواع المصطلحات (TTY)',
  'drugsPage.about.termTypes.scd.label': 'SCD',
  'drugsPage.about.termTypes.scd.description': 'دواء سريري دلالي (عام)',
  'drugsPage.about.termTypes.sbd.label': 'SBD',
  'drugsPage.about.termTypes.sbd.description': 'دواء ذو علامة تجارية دلالية (اسم تجاري)',
  'drugsPage.about.termTypes.in.label': 'IN',
  'drugsPage.about.termTypes.in.description': 'المكون (المكون النشط)',
  'drugsPage.about.termTypes.gpck.label': 'GPCK',
  'drugsPage.about.termTypes.gpck.description': 'عبوة عامة',
  'drugsPage.about.termTypes.bpck.label': 'BPCK',
  'drugsPage.about.termTypes.bpck.description': 'عبوة ذات علامة تجارية',
  'drugsPage.about.disclaimer.title': 'إخلاء المسؤولية الطبية:',
  'drugsPage.about.disclaimer.text': 'هذه الأداة لأغراض المعلومات فقط. استشر دائماً أخصائي رعاية صحية مؤهل قبل اتخاذ أي قرارات دوائية أو تغييرات في خطة العلاج الخاصة بك.',
  'drugsPage.about.resources.title': 'الموارد',
  'drugsPage.about.resources.rxnav': 'RxNav - متصفح RxNorm الرسمي',
  'drugsPage.about.resources.api': 'وثائق واجهة برمجة التطبيقات RxNorm',
  'drugsPage.about.resources.about': 'حول RxNorm',

  // Feature Toggle Page
  'featureToggle.title': 'إدارة تبديل الميزات',
  'featureToggle.subtitle': 'تفعيل أو تعطيل الوحدات والميزات بشكل عام',
  'featureToggle.buttons.resetToDefaults': 'إعادة تعيين إلى الافتراضيات',
  'featureToggle.success.message': 'تم تحديث إعدادات الميزات بنجاح!',
  'featureToggle.stats.activeModules': 'الوحدات النشطة',
  'featureToggle.stats.totalFeatures': 'إجمالي الميزات',
  'featureToggle.stats.lastUpdated': 'آخر تحديث',
  'featureToggle.search.title': 'البحث والتصفية',
  'featureToggle.search.placeholder': 'البحث عن الوحدات أو الميزات...',
  'featureToggle.buttons.expandAll': 'توسيع الكل',
  'featureToggle.buttons.collapseAll': 'طي الكل',
  'featureToggle.info.title': 'حول تبديل الميزات',
  'featureToggle.emptyState.title': 'لا توجد وحدات أو ميزات تطابق بحثك.',
  'featureToggle.emptyState.message': 'حاول تعديل استعلام البحث أو مسح التصفية.',
  'featureToggle.module.enabled': 'مفعّل',
  'featureToggle.module.disabled': 'معطّل',
  'featureToggle.module.featuresCount': '{enabled} / {total} ميزة مفعّلة',
  'featureToggle.module.dependsOn': 'يعتمد على:',
  'featureToggle.module.requiredBy': 'مطلوب بواسطة:',
  'featureToggle.module.missingDeps': 'لا يمكن التفعيل - التبعيات المفقودة: {names}',
  'featureToggle.module.toggleOn': 'تشغيل',
  'featureToggle.module.toggleOff': 'إيقاف',
  'featureToggle.feature.active': 'نشط',
  'featureToggle.feature.inactive': 'غير نشط',
  'featureToggle.feature.parentDisabled': 'هذه الميزة مفعّلة ولكن الوحدة الرئيسية معطّلة',
  'featureToggle.feature.noFeatures': 'لا توجد ميزات قابلة للتكوين لهذه الوحدة',
  'featureToggle.confirm.resetDefaults': 'هل أنت متأكد من إعادة تعيين جميع مفاتيح تبديل الميزات إلى الإعدادات الافتراضية؟ لا يمكن التراجع عن هذا الإجراء.',
  'featureToggle.confirm.disableWithDeps': 'تحذير: الوحدات التالية تعتمد على {moduleName}:\n\n{dependentNames}\n\nتعطيل {moduleName} سيعطل هذه الوحدات أيضاً. هل تريد المتابعة؟',
  'featureToggle.alert.cannotEnable': 'لا يمكن تفعيل {moduleName}. يجب تفعيل الوحدات المطلوبة التالية أولاً:\n\n{dependencyNames}',

  // Provider Schedule Manager
  'providerSchedule.title': 'جداول مقدمي الخدمة',
  'providerSchedule.subtitle': 'إدارة ساعات العمل والتوافر',
  'providerSchedule.buttons.import': 'استيراد',
  'providerSchedule.buttons.export': 'تصدير',
  'providerSchedule.buttons.saveTemplate': 'حفظ كقالب',
  'providerSchedule.search.placeholder': 'البحث عن مقدمي الخدمة...',
  'providerSchedule.viewMode.grid': 'شبكة',
  'providerSchedule.viewMode.timeline': 'خط زمني',
  'providerSchedule.bulkActions.selected': 'مقدم خدمة محدد',
  'providerSchedule.bulkActions.clearSelection': 'مسح التحديد',
  'providerSchedule.noProviders.title': 'لم يتم العثور على مقدمي خدمة',
  'providerSchedule.noProviders.message': 'حاول تعديل معايير البحث',
  'providerSchedule.provider.weeklyHours': 'ساعات أسبوعية',
  'providerSchedule.provider.role': 'موظف',
  'providerSchedule.dropdown.copyToSelected': 'نسخ إلى المحدد',
  'providerSchedule.dropdown.exportSchedule': 'تصدير الجدول',
  'providerSchedule.dropdown.edit': 'تعديل',
  'providerSchedule.dropdown.duplicate': 'تكرار',
  'providerSchedule.dropdown.delete': 'حذف',
  'providerSchedule.dropdown.addTimeBlock': 'إضافة فترة زمنية',
  'providerSchedule.dropdown.copyTo': 'نسخ إلى {day}',
  'providerSchedule.timeBlock.oneTime': 'مرة واحدة',
  'providerSchedule.days.monday': 'الإثنين',
  'providerSchedule.days.tuesday': 'الثلاثاء',
  'providerSchedule.days.wednesday': 'الأربعاء',
  'providerSchedule.days.thursday': 'الخميس',
  'providerSchedule.days.friday': 'الجمعة',
  'providerSchedule.days.saturday': 'السبت',
  'providerSchedule.days.sunday': 'الأحد',
  'providerSchedule.toast.scheduleUpdated': 'تم تحديث الجدول بنجاح',
  'providerSchedule.toast.scheduleAdded': 'تمت إضافة الجدول بنجاح',
  'providerSchedule.toast.scheduleDeleted': 'تم حذف الجدول بنجاح',
  'providerSchedule.toast.scheduleCopied': 'تم نسخ الجدول إلى {day}',
  'providerSchedule.toast.weekCopied': 'تم نسخ جدول الأسبوع إلى {{count}} مقدم خدمة',
  'providerSchedule.toast.saveFailed': 'فشل حفظ الجدول',
  'providerSchedule.toast.deleteFailed': 'فشل حذف الجدول',
  'providerSchedule.toast.copyFailed': 'فشل نسخ الجدول',
  'providerSchedule.confirm.delete': 'هل أنت متأكد من حذف هذه الفترة الزمنية؟',
  'providerSchedule.dependencyError': 'وحدة الجدولة مطلوبة لإدارة جداول مقدمي الخدمة.',

  // Medical Records
  'medicalRecords.title': 'السجلات الطبية',
  'medicalRecords.subtitle': 'عرض وإدارة السجلات الطبية للمرضى',
  'medicalRecords.clinicalInsights': 'رؤى سريرية',
  'medicalRecords.newRecord': 'سجل جديد',
  'medicalRecords.new': 'جديد',
  'medicalRecords.loading': 'جاري تحميل السجلات الطبية...',
  'medicalRecords.noRecordsFound': 'لم يتم العثور على سجلات',
  'medicalRecords.adjustFilters': 'حاول تعديل البحث أو الفلاتر',

  // Medical Records Search & Filters
  'medicalRecords.search.placeholder': 'البحث في السجلات حسب التشخيص أو العلاج أو اسم المريض...',
  'medicalRecords.filters.advanced': 'فلاتر متقدمة',
  'medicalRecords.filters.active': 'نشط',
  'medicalRecords.filters.typeStatus': 'فلترة حسب النوع والحالة',
  'medicalRecords.filters.recordType': 'نوع السجل',
  'medicalRecords.filters.status': 'الحالة',
  'medicalRecords.filters.patientId': 'رقم المريض',
  'medicalRecords.filters.patientIdPlaceholder': 'أدخل رقم المريض',
  'medicalRecords.filters.patientPlaceholder': 'ابحث بالاسم أو رقم الهاتف…',
  'medicalRecords.filters.dateRange': 'فلترة حسب نطاق التاريخ',
  'medicalRecords.filters.startDate': 'تاريخ البداية',
  'medicalRecords.filters.endDate': 'تاريخ النهاية',
  'medicalRecords.filters.activeLabel': 'نشط',
  'medicalRecords.filters.activeFilters': 'الفلاتر النشطة:',
  'medicalRecords.filters.clearAll': 'مسح الكل',
  'medicalRecords.filters.type': 'النوع',
  'medicalRecords.filters.statusLabel': 'الحالة',
  'medicalRecords.filters.patient': 'المريض',
  'medicalRecords.filters.from': 'من',
  'medicalRecords.filters.to': 'إلى',

  // Record Types
  'medicalRecords.types.allTypes': 'جميع الأنواع',
  'medicalRecords.types.progressNote': 'ملاحظة تقدم',
  'medicalRecords.types.consultation': 'استشارة',
  'medicalRecords.types.admission': 'قبول',
  'medicalRecords.types.discharge': 'خروج',
  'medicalRecords.types.procedureNote': 'ملاحظة إجراء',
  'medicalRecords.types.operativeNote': 'ملاحظة عملية',
  'medicalRecords.types.emergency': 'طوارئ',
  'medicalRecords.types.followUp': 'متابعة',

  // Record Statuses
  'medicalRecords.statuses.allStatuses': 'جميع الحالات',
  'medicalRecords.statuses.draft': 'مسودة',
  'medicalRecords.statuses.signed': 'موقّع',
  'medicalRecords.statuses.final': 'نهائي',

  // Medical Records Stats
  'medicalRecords.stats.overview': 'نظرة عامة على السجلات الطبية',
  'medicalRecords.stats.generateReport': 'إنشاء تقرير سريري',
  'medicalRecords.stats.totalRecords': 'إجمالي السجلات',
  'medicalRecords.stats.consultations': 'الاستشارات',
  'medicalRecords.stats.progressNotes': 'ملاحظات التقدم',
  'medicalRecords.stats.signedRecords': 'السجلات الموقّعة',

  // Medical Record Card
  'medicalRecords.card.unknownPatient': 'مريض غير معروف',
  'medicalRecords.card.noChiefComplaint': 'لم يتم تسجيل الشكوى الرئيسية',
  'medicalRecords.card.assessment': 'التقييم:',
  'medicalRecords.card.plan': 'الخطة:',
  'medicalRecords.card.moreDiagnoses': 'المزيد',
  'medicalRecords.card.status': 'الحالة:',
  'medicalRecords.card.signedBy': 'تم التوقيع بواسطة',

  // Drug Interaction Checker
  'drugs.interactionChecker.title': 'مدقق التفاعلات الدوائية',
  'drugs.interactionChecker.subtitle': 'فحص التفاعلات بين الأدوية المتعددة',
  'drugs.interactionChecker.addMedications': 'إضافة أدوية',
  'drugs.interactionChecker.searchPlaceholder': 'ابحث وأضف الأدوية للفحص...',
  'drugs.interactionChecker.selectedMedications': 'الأدوية المختارة',
  'drugs.interactionChecker.addAtLeast2': 'أضف دواءين على الأقل لفحص التفاعلات',
  'drugs.interactionChecker.checking': 'جاري فحص التفاعلات...',
  'drugs.interactionChecker.interactionsFound': 'تفاعل',
  'drugs.interactionChecker.interactionsFoundPlural': 'تفاعلات',
  'drugs.interactionChecker.found': 'تم العثور على',
  'drugs.interactionChecker.noInteractions': 'لم يتم العثور على تفاعلات',
  'drugs.interactionChecker.safeToUse': 'يبدو أن هذه الأدوية آمنة للاستخدام معًا',
  'drugs.interactionChecker.note': 'ملاحظة:',
  'drugs.interactionChecker.disclaimer': 'تستخدم هذه الأداة بيانات التفاعلات الدوائية من RxNorm التابعة للمكتبة الوطنية للطب الأمريكية. استشر دائمًا أخصائي الرعاية الصحية قبل اتخاذ قرارات بشأن الأدوية.',

  // Lab Orders Additional
  'labOrders.filters': 'الفلاتر:',
  'labOrders.labAnalytics': 'تحليلات المختبر',
  'labOrders.dashboard': 'لوحة طلبات المختبر',
  'labOrders.generateLabReport': 'إنشاء تقرير مختبري',
  'labOrders.loading': 'جاري تحميل طلبات المختبر...',

  // Clinic Lab Orders Page
  'clinicLabOrders.title': 'طلبات المختبر',
  'clinicLabOrders.subtitle': 'إدارة وتتبع طلبات المختبر لجميع المرضى',
  'clinicLabOrders.refresh': 'تحديث',
  'clinicLabOrders.newOrder': 'طلب جديد',
  'clinicLabOrders.searchPlaceholder': 'البحث باسم المريض أو اسم المختبر أو الملاحظات...',
  'clinicLabOrders.allStatus': 'جميع الحالات',
  'clinicLabOrders.allPriority': 'جميع الأولويات',
  'clinicLabOrders.stats.pending': 'قيد الانتظار',
  'clinicLabOrders.stats.inProgress': 'قيد التنفيذ',
  'clinicLabOrders.stats.resulted': 'مكتملة',
  'clinicLabOrders.stats.needsReview': 'بحاجة للمراجعة',
  'clinicLabOrders.loading': 'جاري تحميل طلبات المختبر...',
  'clinicLabOrders.noOrders': 'لا توجد طلبات مختبر',
  'clinicLabOrders.noOrdersDesc': 'ستظهر طلبات المختبر هنا بمجرد إنشائها من سجلات المرضى',
  'clinicLabOrders.table.patient': 'المريض',
  'clinicLabOrders.table.tests': 'الفحوصات',
  'clinicLabOrders.table.orderDate': 'تاريخ الطلب',
  'clinicLabOrders.table.priority': 'الأولوية',
  'clinicLabOrders.table.status': 'الحالة',
  'clinicLabOrders.table.lab': 'المختبر',
  'clinicLabOrders.table.actions': 'الإجراءات',
  'clinicLabOrders.moreTests': 'المزيد',
  'clinicLabOrders.needsReview': 'بحاجة للمراجعة',
  'clinicLabOrders.viewDetails': 'عرض التفاصيل',
  'clinicLabOrders.editOrder': 'تعديل الطلب',

  // New/Edit Clinic Lab Order Pages
  'clinicLabOrders.new.title': 'طلب مختبر جديد',
  'clinicLabOrders.new.subtitle': 'إنشاء طلب مختبر جديد للمريض',
  'clinicLabOrders.edit.title': 'تعديل طلب المختبر',
  'clinicLabOrders.edit.orderId': 'رقم الطلب',
  'clinicLabOrders.loading.order': 'جاري تحميل طلب المختبر...',
  'clinicLabOrders.error.loadFailed': 'فشل تحميل تفاصيل طلب المختبر',
  'clinicLabOrders.error.notFound': 'لم يتم العثور على طلب المختبر',
  'clinicLabOrders.error.backToOrders': 'العودة إلى طلبات المختبر',
  'clinicLabOrders.edit.cannotEdit': 'لا يمكن تعديل هذا الطلب',
  'clinicLabOrders.edit.cancelled': 'تم إلغاء طلب المختبر هذا ولا يمكن تعديله.',
  'clinicLabOrders.edit.resulted': 'تم إنجاز طلب المختبر هذا بالفعل. يمكن للمسؤولين فقط تعديل الطلبات المنجزة.',
  'clinicLabOrders.edit.backToDetails': 'العودة إلى تفاصيل الطلب',
  'clinicLabOrders.edit.adminOverride': 'تجاوز المسؤول',
  'clinicLabOrders.edit.adminWarning': 'أنت تقوم بتعديل طلب مختبر منجز. سيتم تسجيل التغييرات لأغراض المراجعة.',
  'clinicLabOrders.form.patient': 'المريض',
  'clinicLabOrders.form.selectPatient': 'اختر مريض',
  'clinicLabOrders.form.searchPatient': 'البحث عن المرضى بالاسم...',
  'clinicLabOrders.form.searchingPatients': 'جاري البحث عن المرضى...',
  'clinicLabOrders.form.noPatients': 'لم يتم العثور على مرضى',
  'clinicLabOrders.form.patientLocked': 'لا يمكن تغيير المريض بعد إنشاء الطلب',
  'clinicLabOrders.form.selectTests': 'اختر الفحوصات',
  'clinicLabOrders.form.editTests': 'تعديل الفحوصات',
  'clinicLabOrders.form.addCustomTest': 'إضافة فحص مخصص',
  'clinicLabOrders.form.testName': 'اسم الفحص',
  'clinicLabOrders.form.testCode': 'الرمز (اختياري)',
  'clinicLabOrders.form.orderDetails': 'تفاصيل الطلب',
  'clinicLabOrders.form.priority': 'الأولوية',
  'clinicLabOrders.form.labName': 'اسم المختبر (اختياري)',
  'clinicLabOrders.form.labNamePlaceholder': 'مثال: مختبر البرج',
  'clinicLabOrders.form.clinicalNotes': 'الملاحظات السريرية / سبب الطلب',
  'clinicLabOrders.form.clinicalNotesPlaceholder': 'أدخل الملاحظات السريرية أو سبب طلب هذه الفحوصات...',
  'clinicLabOrders.summary.title': 'ملخص الطلب',
  'clinicLabOrders.summary.selectedTests': 'الفحوصات المختارة',
  'clinicLabOrders.summary.noTests': 'لم يتم اختيار فحوصات',
  'clinicLabOrders.error.selectPatient': 'يرجى اختيار مريض',
  'clinicLabOrders.error.selectTests': 'يرجى إضافة فحص واحد على الأقل',
  'clinicLabOrders.error.createFailed': 'فشل إنشاء طلب المختبر. يرجى المحاولة مرة أخرى.',
  'clinicLabOrders.error.updateFailed': 'فشل تحديث طلب المختبر. يرجى المحاولة مرة أخرى.',
  'clinicLabOrders.action.cancel': 'إلغاء',
  'clinicLabOrders.action.creating': 'جاري الإنشاء...',
  'clinicLabOrders.action.createOrder': 'إنشاء الطلب',
  'clinicLabOrders.action.saving': 'جاري الحفظ...',
  'clinicLabOrders.action.saveChanges': 'حفظ التغييرات',

  // Clinic Lab Order Details Page
  'clinicLabOrders.details.title': 'تفاصيل طلب المختبر',
  'clinicLabOrders.details.backToOrders': 'العودة إلى الطلبات',
  'clinicLabOrders.details.edit': 'تعديل الطلب',
  'clinicLabOrders.details.cancel': 'إلغاء الطلب',
  'clinicLabOrders.details.confirmCancel': 'إلغاء طلب المختبر؟',
  'clinicLabOrders.details.confirmCancelMessage': 'هل أنت متأكد من رغبتك في إلغاء طلب المختبر هذا؟ لا يمكن التراجع عن هذا الإجراء.',
  'clinicLabOrders.details.orderInfo': 'معلومات الطلب',
  'clinicLabOrders.details.orderDate': 'تاريخ الطلب',
  'clinicLabOrders.details.orderedBy': 'تم الطلب بواسطة',
  'clinicLabOrders.details.patientInfo': 'معلومات المريض',
  'clinicLabOrders.details.viewPatient': 'عرض ملف المريض',
  'clinicLabOrders.details.tests': 'الفحوصات',
  'clinicLabOrders.details.testCount': 'فحص',
  'clinicLabOrders.details.clinicalNotes': 'الملاحظات السريرية',
  'clinicLabOrders.details.noClinicalNotes': 'لم يتم تقديم ملاحظات سريرية',
  'clinicLabOrders.details.timeline': 'الجدول الزمني للطلب',
  'clinicLabOrders.details.statusUpdated': 'تم تحديث الحالة إلى',
  'clinicLabOrders.details.orderCreated': 'تم إنشاء الطلب',
  'clinicLabOrders.details.orderId': 'رقم الطلب',
  'clinicLabOrders.details.labAnalysis': 'تحليل المختبر',
  'clinicLabOrders.details.markReviewed': 'وضع علامة تمت المراجعة',
  'clinicLabOrders.details.needsReview': 'بحاجة للمراجعة',
  'clinicLabOrders.details.reviewedStatus': 'تمت المراجعة',
  'clinicLabOrders.details.resultDate': 'تاريخ النتيجة',
  'clinicLabOrders.details.enterResults': 'إدخال النتائج',
  'clinicLabOrders.details.relevantToConditions': 'ذات صلة بحالات المريض',
  'clinicLabOrders.details.clinicalSignificance': 'الأهمية السريرية',
  'clinicLabOrders.details.reasonForOrder': 'سبب الطلب',
  'clinicLabOrders.details.resultNotes': 'ملاحظات النتيجة',
  'clinicLabOrders.details.relevantConditions': 'الحالات ذات الصلة',
  'clinicLabOrders.details.labsCorrelatedNote': 'الفحوصات المرتبطة بالأمراض المزمنة:',
  'clinicLabOrders.details.blueMarkerNote': 'الفحوصات المميزة بحافة زرقاء ذات صلة خاصة بهذه الحالات.',
  'clinicLabOrders.details.provider': 'مقدم الخدمة',
  'clinicLabOrders.details.resultsReceived': 'تم استلام النتائج',
  'clinicLabOrders.details.saveResults': 'حفظ النتائج',
  'clinicLabOrders.form.result': 'النتيجة',
  'clinicLabOrders.form.resultPlaceholder': 'أدخل النتيجة',
  'clinicLabOrders.form.unit': 'الوحدة',
  'clinicLabOrders.form.unitPlaceholder': 'مثال: ملغ/ديسيلتر',
  'clinicLabOrders.form.resultNotesPlaceholder': 'أضف أي ملاحظات حول النتائج...',
  'labOrders.abnormal': 'غير طبيعي',

  // Voiceprint enrollment
  'voiceprint.title': 'بصمتي الصوتية',
  'voiceprint.enrolled': 'مُسجَّل',
  'voiceprint.notEnrolled': 'غير مُسجَّل بعد',
  'voiceprint.enrollCta': 'سجّل صوتي',
  'voiceprint.unavailable':
    'التعرف على الصوت مُعطَّل في هذه العيادة، لذلك لا يمكن تسجيل صوتك الآن. يمكن لمسؤول العيادة تغيير ذلك.',
  'voiceprint.replaceCta': 'أعِد تسجيل صوتي',
  'voiceprint.captureLabel': 'تحدث بشكل طبيعي لمدة تصل إلى {{seconds}} ثانية.',
  'voiceprint.promptHeading': 'اقرأ هذه — أو تحدّث بحرّية',
  'voiceprint.promptHint':
    'قراءة جمل متنوّعة تعطي MAIE عيّنة صوتية أغنى. أي شيء تقوله مقبول.',
  'voiceprint.prompt1':
    'صباح الخير، أنا الدكتور [الاسم]. كيف حالك اليوم؟',
  'voiceprint.prompt2':
    'هل لاحظت أعراضاً جديدة منذ زيارتك السابقة، أو أي آثار جانبية لأدويتك؟',
  'voiceprint.prompt3':
    'دعنا نراجع نتائجك الأخيرة ونعدّل الخطة إذا لزم الأمر.',
  'voiceprint.recordingNow': 'جارٍ التسجيل…',
  'voiceprint.processing': 'جارٍ معالجة الصوت…',
  'voiceprint.waitingForMic': 'في انتظار إذن الميكروفون…',
  'voiceprint.startRecording': 'ابدأ التسجيل',
  'voiceprint.stopRecording': 'إيقاف',
  'voiceprint.recordAgain': 'سجِّل مرة أخرى',
  'voiceprint.capturedSeconds': 'تم تسجيل {{seconds}} ثانية',
  'voiceprint.tooShort':
    'التسجيل أقصر من {{min}} ثانية — يرجى تسجيل عينة أطول.',
  'voiceprint.consent':
    'أوافق على أن يحتفظ نظام MAIE ببصمة مشفَّرة لصوتي، مشفَّرة لكل مؤسسة، بهدف تحديد كلماتي في الاستشارات فقط. يمكنني سحب هذه الموافقة في أي وقت.',
  'voiceprint.submitEnroll': 'حفظ البصمة الصوتية',
  'voiceprint.submitReplace': 'استبدال البصمة الصوتية',
  'voiceprint.savedToast': 'تم حفظ البصمة الصوتية',
  'voiceprint.savedToastDesc':
    'سيتعرّف MAIE على صوتك ويُسمّي كلامك في النصوص المُدوّنة.',
  'voiceprint.replacedToast': 'تم استبدال البصمة الصوتية',
  'voiceprint.history': 'بصماتي الصوتية',
  'voiceprint.rowActive': 'نشط',
  'voiceprint.rowRetired': 'مسحوب',
  'voiceprint.revoke': 'سحب',
  'voiceprint.errors.enroll':
    'تعذّر حفظ البصمة الصوتية. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.',

  // First-login onboarding modal
  'voiceprint.onboarding.title': 'دع MAIE يتعرف على صوتك',
  'voiceprint.onboarding.description':
    'نود تسجيل عينة قصيرة (30 ثانية) من صوتك ليتم تمييز كلماتك في الاستشارات تلقائياً. يمكنك التسجيل الآن أو لاحقاً من الإعدادات.',
  'voiceprint.onboarding.pointPrivacy':
    'نخزن بصمة رياضية فقط وليس التسجيل الصوتي. مشفَّرة لكل مؤسسة.',
  'voiceprint.onboarding.pointAttribution':
    'ستظهر كلماتك في النص تحت تصنيف "الطبيب"، وتبقى كلمات المريض والعائلة منفصلة.',
  'voiceprint.onboarding.pointRevoke':
    'يمكنك سحب أو استبدال بصمتك في أي وقت من الإعدادات ← بصمتي الصوتية.',
  'voiceprint.onboarding.remindLater': 'ذكِّرني لاحقاً',
  'voiceprint.onboarding.enrollNow': 'سجِّل الآن',

  // إدارة الفريق / العضويات (واجهة المالك)
  'memberships.title': 'أعضاء الفريق',
  'memberships.subtitle': 'إدارة من يصل إلى عيادتك وما يمكنه فعله.',
  'memberships.inviteCta': 'دعوة عضو',
  'memberships.notOwnerHeading': 'إدارة الفريق',
  'memberships.notOwnerBody':
    'يمكن لمالك العيادة فقط إدارة أعضاء الفريق. اطلب من المالك دعوة المستخدمين أو تغيير أدوارهم.',
  'memberships.pendingHeading': 'الدعوات المعلقة ({{count}})',
  'memberships.activeHeading': 'الأعضاء النشطون',
  'memberships.empty': 'لا يوجد أعضاء بعد. اضغط "دعوة عضو" أعلاه لإضافة واحد.',
  'memberships.loading': 'جارٍ تحميل الأعضاء…',
  'memberships.col.email': 'البريد الإلكتروني',
  'memberships.col.role': 'الدور',
  'memberships.col.sent': 'أُرسلت',
  'memberships.col.expires': 'تنتهي',
  'memberships.col.name': 'الاسم',
  'memberships.col.status': 'الحالة',
  'memberships.col.you': '(أنت)',
  'memberships.col.assists': 'يساعد',
  'memberships.assists.unassigned': 'غير معين',
  'memberships.assists.notApplicable': '—',
  'memberships.assists.noDoctors': 'لا يوجد أطباء بعد — قم بدعوة طبيب أولًا.',

  // الصفحة الرئيسية للطبيب — لوحة المساعدين
  'home.myAssistants.title': 'مساعدوني',

  // الصفحات الرئيسية حسب الدور (الاستقبال / التمريض / المحاسبة)
  'roleHome.greeting.morning': 'صباح الخير',
  'roleHome.greeting.afternoon': 'مساء الخير',
  'roleHome.greeting.evening': 'مساء الخير',
  'roleHome.assisting': 'يساعد د. {{name}}',
  'roleHome.unassigned': 'لم يتم الربط بطبيب بعد',
  'roleHome.empty.appointments': 'لا توجد مواعيد مجدولة اليوم.',

  'receptionistHome.title': 'مكتب الاستقبال',
  'receptionistHome.subtitle': 'تدفق المرضى لليوم في لمحة.',
  'receptionistHome.queueTitle': 'طابور اليوم',
  'receptionistHome.walkInsTitle': 'المرضى دون موعد',
  'receptionistHome.quick.newAppointment': 'موعد جديد',
  'receptionistHome.quick.newPatient': 'إضافة مريض',
  'receptionistHome.quick.viewSchedule': 'فتح الجدول',
  'receptionistHome.quick.messages': 'الرسائل',
  'receptionistHome.checkIn': 'تسجيل الدخول',
  'receptionistHome.markNoShow': 'لم يحضر',

  'nurseHome.title': 'التمريض',
  'nurseHome.subtitle': 'فرز المرضى والتحضير.',
  'nurseHome.queueTitle': 'مرضى اليوم',
  'nurseHome.handoffTitle': 'التسليم للطبيب',
  'nurseHome.handoffEmpty': 'لا توجد عمليات تسليم نشطة.',
  'nurseHome.recordVitals': 'تسجيل العلامات الحيوية',
  'nurseHome.viewChart': 'عرض الملف',

  'billingHome.title': 'المحاسبة',
  'billingHome.subtitle': 'إيرادات اليوم في لمحة.',
  'billingHome.outstanding': 'المستحقات',
  'billingHome.paidToday': 'مدفوعات اليوم',
  'billingHome.invoicesTitle': 'الفواتير الأخيرة',
  'billingHome.refundsTitle': 'طلبات الاسترداد',
  'billingHome.refundsEmpty': 'لا توجد طلبات استرداد مفتوحة.',
  'billingHome.openSubscription': 'الاشتراك والمقاعد',
  'billingHome.openInvoices': 'جميع الفواتير',
  'memberships.action.revoke': 'إلغاء',
  'memberships.action.remove': 'إزالة',
  'memberships.action.resend': 'إعادة إرسال',
  'memberships.action.sendAgain': 'إرسال مرة أخرى',
  'memberships.action.resendExpiredHint':
    'إصدار رمز دعوة جديد وإرساله بالبريد. الرابط القديم يصبح غير صالح.',
  'memberships.action.resendPendingHint':
    'إرسال بريد جديد برابط جديد. الرابط السابق يتوقف عن العمل.',
  'memberships.status.pending': 'قيد الانتظار',
  'memberships.status.expired': 'منتهية',
  'memberships.invitationExpiredHint':
    'انتهت صلاحية هذه الدعوة. أزلها وأرسل واحدة جديدة.',
  'memberships.confirmRevoke': 'هل تريد إلغاء وصول {{name}} إلى هذه العيادة؟',
  'memberships.selfDemoteHint':
    'قم بترقية عضو آخر إلى مالك قبل تغيير دورك.',
  'memberships.seat.ai': 'مقعد بالذكاء الاصطناعي',
  'memberships.seat.recordsOnly': 'سجلات فقط',
  'memberships.seat.hint':
    'يحتفظ مقعد السجلات فقط بجميع الصلاحيات السريرية — الملاحظات ووصف الأدوية والتوقيع — ويزيل مزايا الذكاء الاصطناعي. تكلفة شهرية أقل.',
  'memberships.action.resetPin': 'إعادة تعيين PIN التوقيع',
  'memberships.action.suspend': 'تعليق',
  'memberships.action.reactivate': 'إعادة التفعيل',
  'memberships.resetPinHint':
    'يمسح PIN التوقيع — سيعيّن العضو رقمًا جديدًا عند التوقيع التالي.',
  'memberships.suspendHint':
    'يمنع تسجيل الدخول مع الإبقاء على المقعد والبيانات. قابل للتراجع.',
  'memberships.reactivateHint': 'استعادة صلاحية تسجيل الدخول لهذا العضو.',
  'memberships.confirmResetPin':
    'إعادة تعيين PIN التوقيع لـ {{name}}؟ سيعيّن رقمًا جديدًا عند توقيعه التالي.',
  'memberships.confirmSuspend':
    'تعليق {{name}}؟ لن يتمكن من تسجيل الدخول حتى إعادة التفعيل.',
  'memberships.resetPinSuccess': 'تمت إعادة تعيين PIN التوقيع لـ {{name}}.',
  'memberships.action.resetPassword': 'إعادة تعيين كلمة المرور',
  'memberships.resetPwTitle': 'إعادة تعيين كلمة مرور {{name}}',
  'memberships.resetPwEmailOption': 'إرسال رابط إعادة التعيين',
  'memberships.resetPwEmailDesc':
    'يرسل إلى {{name}} رابطًا آمنًا لتعيين كلمة المرور بنفسه. لن تراها أنت.',
  'memberships.resetPwTempOption': 'إنشاء كلمة مرور مؤقتة',
  'memberships.resetPwTempDesc':
    'للأعضاء بدون بريد فعّال. ستحصل على كلمة مرور لمرة واحدة لتسليمها؛ وعليهم تغييرها عند تسجيل الدخول التالي.',
  'memberships.resetPwSending': 'جارٍ التنفيذ…',
  'memberships.resetPwEmailSent': 'تم إرسال رابط إعادة التعيين إلى {{name}}. ينتهي خلال ساعة.',
  'memberships.resetPwEmailNotDelivered':
    'تعذّر إرسال البريد (تحقّق من إعداد البريد). جرّب كلمة مرور مؤقتة بدلًا من ذلك.',
  'memberships.resetPwTempReady':
    'كلمة المرور المؤقتة لـ {{name}} — انسخها الآن، لن تظهر مرة أخرى:',
  'memberships.resetPwTempHint':
    'شاركها بأمان. عليهم تعيين كلمة مرور جديدة عند تسجيل الدخول التالي.',
  'memberships.copy': 'نسخ',
  'memberships.copied': 'تم النسخ',
  'memberships.done': 'تم',
  'memberships.cancel': 'إلغاء',

  // نافذة الدعوة
  'invite.modal.title': 'دعوة عضو إلى الفريق',
  'invite.modal.issuedTitle': 'تم إصدار الدعوة',
  'invite.modal.helper': 'سيستلم رابطًا لمرة واحدة لإعداد حسابه.',
  'invite.modal.emailLabel': 'البريد الإلكتروني',
  'invite.modal.emailPlaceholder': 'newdoctor@clinic.health',
  'invite.modal.roleLabel': 'الدور',
  'invite.modal.roleDesc.Owner':
    'إدارة كاملة للعيادة — الدعوات وتغيير الأدوار وضبط الإعدادات.',
  'invite.modal.roleDesc.Clinic Manager':
    'التشغيل والإدارة أسفل المالك — الموظفون والجدولة والفوترة؛ يطّلع على البيانات الإكلينيكية دون إدارة الأدوار.',
  'invite.modal.roleDesc.Doctor': 'الرعاية الإكلينيكية والتوثيق ووصف الأدوية.',
  'invite.modal.roleDesc.Nurse': 'دعم سير العمل الإكلينيكي بصلاحيات سجلات محدودة.',
  'invite.modal.roleDesc.Receptionist':
    'مكتب الاستقبال والمواعيد، دون الوصول إلى السجلات الطبية.',
  'invite.modal.roleDesc.Billing':
    'المراجعة المالية والفواتير، دون الوصول إلى السجلات الطبية.',
  'invite.modal.seatLabel': 'المقعد',
  'invite.modal.seat.ai': 'مقعد بالذكاء الاصطناعي',
  'invite.modal.seat.recordsOnly': 'مقعد سجلات فقط',
  'invite.modal.seatDesc.ai':
    'التدوين الصوتي و«اسأل MAIE» ومسح المستندات، بالإضافة إلى الوصول السريري الكامل.',
  'invite.modal.seatDesc.recordsOnly':
    'وصول سريري كامل — الملاحظات ووصف الأدوية والتوقيع تعمل جميعها. بدون مزايا الذكاء الاصطناعي. تكلفة شهرية أقل.',
  'invite.modal.cancel': 'إلغاء',
  'invite.modal.send': 'إرسال الدعوة',
  'invite.modal.sending': 'جارٍ الإرسال…',
  'invite.modal.delivered':
    'تم إرسال الدعوة بالبريد إلى {{email}}. ينتهي الرابط في {{expires}}.',
  'invite.modal.notDelivered':
    'شارك هذا الرابط لمرة واحدة مع {{email}} — إرسال البريد غير متاح في هذا النشر. ينتهي الرابط في {{expires}}.',
  'invite.modal.warningDelivered':
    'يمكنك أيضاً نسخ الرابط أدناه إذا لم يصل البريد — هو ذاته. لن يظهر مرة أخرى بعد إغلاق هذه النافذة.',
  'invite.modal.warningNotDelivered':
    'لن يظهر هذا الرابط مرة أخرى بعد إغلاق النافذة. انسخه الآن أو ألغِه وأصدِره من جديد إن فُقد.',
  'invite.modal.copy': 'نسخ',
  'invite.modal.copied': 'تم النسخ',
  'invite.modal.done': 'تم',

  // قبول الدعوة (عام)
  'inviteAccept.eyebrow': 'دعوة',
  'inviteAccept.heroLine1': 'لقد تمت دعوتك',
  'inviteAccept.heroLine2': 'للانضمام إلى {{clinic}}',
  'inviteAccept.heroAs': 'بصفة {{role}}',
  'inviteAccept.heroByline': 'دعاك {{inviter}}',
  'inviteAccept.expires': 'ينتهي الرابط في {{date}}',
  'inviteAccept.poweredBy': 'بدعم من MAIE',
  'inviteAccept.previewLoading': 'نتحقق من دعوتك…',
  'inviteAccept.errorTitle': 'لا يمكن استخدام هذه الدعوة',
  'inviteAccept.errorAskOwner': 'اطلب من مالك العيادة إرسال دعوة جديدة.',
  'inviteAccept.linkMissing': 'رابط الدعوة مفقود.',
  'inviteAccept.title': 'قبول الدعوة',
  'inviteAccept.subtitle': 'أعدّ حسابك للانضمام إلى العيادة.',
  'inviteAccept.firstName': 'الاسم الأول',
  'inviteAccept.firstNamePlaceholder': 'سارة',
  'inviteAccept.lastName': 'اسم العائلة',
  'inviteAccept.lastNamePlaceholder': 'محمد',
  'inviteAccept.password': 'كلمة المرور',
  'inviteAccept.passwordPlaceholder': 'اختر كلمة مرور قوية',
  'inviteAccept.confirmPassword': 'تأكيد كلمة المرور',
  'inviteAccept.confirmPasswordPlaceholder': 'كرّر كلمة المرور',
  'inviteAccept.passwordHint': '٨ أحرف على الأقل.',
  'inviteAccept.passwordsMismatch': 'كلمتا المرور غير متطابقتين.',
  'inviteAccept.passwordTooShort': 'يجب ألا تقل كلمة المرور عن ٨ أحرف.',
  'inviteAccept.submit': 'قبول الدعوة',
  'inviteAccept.submitting': 'جارٍ الإعداد…',
  'inviteAccept.successTitle': 'تم إعدادك',
  'inviteAccept.successRedirect': 'جارٍ تسجيل الدخول…',
  'inviteAccept.attachedTitle': 'تمت إضافتك',
  'inviteAccept.attachedBody':
    'تعرّفنا على بريدك — تم ربط حسابك الحالي في MAIE بهذه العيادة. جارٍ تسجيل الدخول. (كلمة مرور حساباتك الأخرى لم تتغيّر؛ تم تجاهل الكلمة التي أدخلتها للتو.)',
  'inviteAccept.goToSignIn': 'متابعة',

  // أسماء الأدوار المرئية للعميل
  'roles.Owner': 'المالك',
  'roles.Clinic Manager': 'مدير العيادة',
  'roles.Stock Manager': 'مسؤول المخزون',
  'roles.Accountant': 'المحاسب',
  'roles.Doctor': 'طبيب',
  'roles.Nurse': 'ممرض',
  'roles.Receptionist': 'موظف استقبال',
  'roles.Billing': 'المحاسبة',

  // شاشة الترحيب والاستشارة التجريبية
  // TODO(ar-review): welcome/demo strings below need Ahmed's pass.
  'welcome.eyebrow': 'مرحباً بك في MAIE',
  'welcome.title': 'لنرَ MAIE أثناء العمل',
  'welcome.titleWithClinic': 'مرحباً، {{clinic}} جاهزة',
  'welcome.specialtyQuestion': 'ما هو تخصصك؟',
  'welcome.specialtyHint':
    'هذا يخصّص العرض التجريبي — ويحسّن كل ملاحظة ذكاء اصطناعي لاحقاً.',
  'welcome.youllMeet': 'ستقابل {{name}} — {{summary}}.',
  'welcome.tailoringWait': 'جارٍ تجهيز مريضك…',
  'welcome.tailoring':
    'نجهّز مريضاً مناسباً لتخصصك — سيتم تحديث هذه المعاينة بعد لحظات.',
  'welcome.cta': 'جرّب استشارة تجريبية',
  'welcome.skip': 'تخطَّ — خذني إلى عيادتي',
  'welcome.goToClinic': 'اذهب إلى عيادتي',
  'welcome.ready': 'MAIE جاهزة',
  'welcome.wakingUp': 'MAIE تستيقظ…',
  'welcome.offline': 'أنت غير متصل — العرض التجريبي يحتاج اتصالاً.',
  'welcome.loading': 'جارٍ التجهيز…',
  'welcome.scribeUnavailable':
    'الكاتب الصوتي غير متاح حالياً، لذا سينتظر العرض التجريبي — عيادتك جاهزة للاستخدام على أي حال.',
  'welcome.recordingStarted': 'جارٍ التسجيل — صف الزيارة بصوتك.',
  'welcome.startFailed': 'تعذّر بدء العرض التجريبي. حاول مرة أخرى.',
  'welcome.micDeniedTitle': 'الوصول إلى الميكروفون محظور',
  'welcome.micDeniedBodyWeb':
    'لا تستطيع MAIE سماعك. اسمح بالوصول إلى الميكروفون من إعدادات الموقع في المتصفح ثم حاول مجدداً.',
  'welcome.micDeniedBodyNative':
    'لا تستطيع MAIE سماعك. اسمح بالوصول إلى الميكروفون من إعدادات النظام ثم حاول مجدداً.',
  'welcome.openSettings': 'افتح الإعدادات',
  'welcome.tryAgain': 'حاول مجدداً',

  // شريط المريض التجريبي
  'demoPatient.banner.title': 'هذا مريضك التجريبي',
  'demoPatient.banner.body':
    'لا شيء هنا حقيقي. عند انتهائك من الاستكشاف يمكنك حذف البيانات التجريبية بنقرة واحدة.',
  'demoPatient.banner.delete': 'حذف البيانات التجريبية',
  'demoPatient.banner.deleteConfirm': 'نعم، احذفها',
  'demoPatient.banner.keepExploring': 'متابعة الاستكشاف',
  'demoPatient.banner.deleted': 'تم حذف البيانات التجريبية.',
  'demoPatient.banner.deleteFailed': 'تعذّر حذف البيانات التجريبية.',

  // قائمة البدء (الرئيسية)
  // TODO(ar-review): checklist/roleWelcome strings below need Ahmed's pass.
  'setupChecklist.eyebrow': 'لنبدأ',
  'setupChecklist.title': 'أكمل الإعداد (متبقٍ {{count}})',
  'setupChecklist.dismiss': 'إخفاء',
  'setupChecklist.item.tryDemo': 'جرّب استشارة تجريبية',
  'setupChecklist.item.addPatient': 'أضف أول مريض',
  'setupChecklist.item.inviteTeam': 'ادعُ فريقك',
  'setupChecklist.item.branding': 'أضف شعار عيادتك',
  'setupChecklist.item.pin': 'عيّن رقم التوقيع السري',
  'setupChecklist.item.specialty': 'اختر تخصصك (يحسّن ملاحظات الذكاء الاصطناعي)',

  // بطاقات ترحيب الأدوار (أعضاء الفريق المدعوون)
  'roleWelcome.eyebrow': 'مرحباً',
  'roleWelcome.gotIt': 'فهمت',
  'roleWelcome.receptionist.title': 'مرحباً {{name}} — هذا مكتب الاستقبال',
  'roleWelcome.receptionist.body': 'كل شيء في يومك يبدأ من هذه الصفحة. جرّب أحد هذه:',
  'roleWelcome.receptionist.step.book': 'احجز موعداً',
  'roleWelcome.receptionist.step.bookBody': 'جدولة زيارة مريض بنقرات قليلة.',
  'roleWelcome.receptionist.step.addPatient': 'أضف مريضاً',
  'roleWelcome.receptionist.step.addPatientBody': 'أنشئ ملفاً لمريض جديد.',
  'roleWelcome.receptionist.step.schedule': 'اعرض جدول اليوم',
  'roleWelcome.receptionist.step.scheduleBody': 'كل مواعيد اليوم في شاشة واحدة.',
  'roleWelcome.receptionist.step.messages': 'ردّ على الرسائل',
  'roleWelcome.receptionist.step.messagesBody': 'رسائل المرضى تصل إلى صندوق واحد.',
  'roleWelcome.nurse.title': 'مرحباً {{name}} — هذه محطتك',
  'roleWelcome.nurse.body': 'يومك يمر عبر هذه الأماكن الثلاثة:',
  'roleWelcome.nurse.step.vitals': 'سجّل العلامات الحيوية',
  'roleWelcome.nurse.step.vitalsBody': 'اختر مريضاً وسجّل قراءات اليوم.',
  'roleWelcome.nurse.step.schedule': 'اعرض جدول اليوم',
  'roleWelcome.nurse.step.scheduleBody': 'من سيحضر، ومتى.',
  'roleWelcome.nurse.step.protocols': 'تصفّح البروتوكولات',
  'roleWelcome.nurse.step.protocolsBody': 'الأوامر الدائمة وبروتوكولات الرعاية.',
  'roleWelcome.billing.title': 'مرحباً {{name}} — هذه المحاسبة',
  'roleWelcome.billing.body': 'الفواتير والمدفوعات والتقارير كلها هنا:',
  'roleWelcome.billing.step.invoice': 'أنشئ فاتورة',
  'roleWelcome.billing.step.invoiceBody': 'فوترة زيارة أو خدمة بنقرات قليلة.',
  'roleWelcome.billing.step.workspace': 'افتح المحاسبة',
  'roleWelcome.billing.step.workspaceBody': 'الفواتير والمدفوعات في مكان واحد.',
  'roleWelcome.billing.step.reports': 'اعرض التقارير',
  'roleWelcome.billing.step.reportsBody': 'الإيرادات والأرصدة المستحقة.',
  'roleWelcome.doctor.title': 'مرحباً {{name}} — كل شيء جاهز',
  'roleWelcome.doctor.body': 'أسرع طريقة للبدء أن ترى MAIE تكتب ملاحظة:',
  'roleWelcome.doctor.step.demo': 'جرّب زيارة تجريبية',
  'roleWelcome.doctor.step.demoBody': 'صف استشارة افتراضية بصوتك وستكتب MAIE الملاحظة.',
  'roleWelcome.doctor.step.addPatient': 'أضف مريضاً',
  'roleWelcome.doctor.step.addPatientBody': 'أنشئ ملفاً لمريض جديد.',
  'roleWelcome.doctor.step.notes': 'راجع الملاحظات',
  'roleWelcome.doctor.step.notesBody': 'المسودات بانتظار توقيعك هنا.',

  // إدارة النطاقات
  'domains.title': 'النطاقات',
  'domains.unsupported.title': 'النطاقات المخصصة غير متاحة',
  'domains.unsupported.body':
    'لا يدعم هذا النشر النطاقات المخصصة. تبقى عيادتك على نطاقها الفرعي المُدار.',
  'domains.notOwner':
    'يمكن لمالك العيادة فقط إدارة النطاقات. تواصل مع المالك.',
  'domains.col.url': 'الرابط',
  'domains.col.tier': 'النوع',
  'domains.col.status': 'الحالة',
  'domains.col.cert': 'الشهادة',
  'domains.tier.subdomain': 'نطاق فرعي مُدار',
  'domains.tier.custom_domain': 'نطاق مخصّص',
  'domains.tier.shared': 'مشترك',
  'domains.status.active': 'نشط',
  'domains.status.pending_verification': 'بانتظار التحقق',
  'domains.status.retired': 'متوقف',
  'domains.cert.none': '—',
  'domains.cert.issued': 'مُصدَرة',
  'domains.cert.expiring_soon': 'تنتهي قريباً',
  'domains.cert.expired': 'منتهية',
  'domains.cert.failed': 'فشل',
  'domains.add': 'إضافة نطاق مخصص',
  'domains.add.placeholder': 'clinic.example.com',
  'domains.add.cancel': 'إلغاء',
  'domains.add.submit': 'إضافة النطاق',
  'domains.add.submitting': 'جارٍ الإضافة…',
  'domains.verify': 'تحقّق',
  'domains.verifying': 'جارٍ التحقق…',
  'domains.retire': 'إزالة',
  'domains.confirmRetire': 'إزالة «{{domain}}» من هذه العيادة؟',
  'domains.dnsHeading': 'سجلات DNS المطلوبة',
  'domains.dnsType': 'النوع',
  'domains.dnsName': 'الاسم / المضيف',
  'domains.dnsValue': 'القيمة',
  'domains.dnsCopy': 'نسخ',
  'domains.dnsCopied': 'تم النسخ',
  'domains.dnsPropagation':
    'قد تحتاج تغييرات DNS لبضع دقائق حتى تنتشر. إذا فشل التحقق، انتظر قليلاً ثم أعد المحاولة.',

  // Specialty / Profile
  'profile.title': 'الملف الشخصي',
  'profile.specialty.label': 'التخصص',
  'profile.specialty.placeholder': 'اختر تخصصك',
  'profile.subspecialty.label': 'التخصص الدقيق (اختياري)',
  'profile.subspecialty.placeholder': 'مثل: جراحة القلب التداخلية',
  'profile.save': 'حفظ الملف',
  'profile.saved': 'تم تحديث الملف',
  'profile.specialty.notSet': 'غير محدد',

  'specialty.onboarding.title': 'اختر تخصصك',
  'specialty.onboarding.description':
    'نخصص دقة التحويل الصوتي وشكل ملاحظات SOAP والقوالب المقترحة بناءً على تخصصك. يمكنك تغيير ذلك في أي وقت من الإعدادات.',
  'specialty.onboarding.skip': 'تخطّى الآن',
  'specialty.onboarding.confirm': 'حفظ ومتابعة',

  // Personal info card (settings)
  'settings.personalInfo.eyebrow': 'الحساب',
  'settings.personalInfo.title': 'البيانات الشخصية',
  'settings.personalInfo.firstName': 'الاسم الأول',
  'settings.personalInfo.lastName': 'اسم العائلة',
  'settings.personalInfo.email': 'البريد الإلكتروني',
  'settings.personalInfo.saveFailed': 'تعذّر حفظ التعديلات. حاول مرة أخرى.',

  // Security / change password card
  'settings.security.eyebrow': 'الحماية',
  'settings.security.title': 'كلمة المرور',
  'settings.security.currentPassword': 'كلمة المرور الحالية',
  'settings.security.newPassword': 'كلمة المرور الجديدة',
  'settings.security.confirmPassword': 'تأكيد كلمة المرور الجديدة',
  'settings.security.tooShort': 'يجب ألا تقل كلمة المرور عن 8 أحرف.',
  'settings.security.mismatch': 'كلمتا المرور غير متطابقتين.',
  'settings.security.changeWarning':
    'تغيير كلمة المرور سيُسجّل خروجك من كل الأجهزة الأخرى.',
  'settings.security.passwordUpdated': 'تم تحديث كلمة المرور',
  'settings.security.invalidCurrentPassword':
    'كلمة المرور الحالية غير صحيحة.',
  'settings.security.passwordUnchanged':
    'اختر كلمة مرور جديدة — لا يمكن أن تطابق الحالية.',
  'settings.security.updateFailed':
    'تعذّر تحديث كلمة المرور. حاول مرة أخرى.',
  'settings.security.updateButton': 'تحديث كلمة المرور',

  // SSO register fallback errors
  'auth.register.ssoEmailUnverified':
    'لم يقم {{provider}} بالتحقق من بريدك بعد. تحقق منه أولاً ثم حاول مجدداً.',
  'auth.register.ssoGenericError':
    'تعذّر إكمال التسجيل عبر {{provider}}. حاول مجدداً أو استخدم البريد وكلمة المرور.',
};